
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("74Gga", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6b402dd6b18638d$export$2e2bcd8739ae039);
function $e6b402dd6b18638d$export$2e2bcd8739ae039(radian) {
    return Math.round(radian * (180 / Math.PI));
}

});

parcelRegister("ckaL5", function(module, exports) {

$parcel$export(module.exports, "PINK_ANGLE_COLORS", () => $bb84c280a189e0ba$export$7a003cdef7722780);
$parcel$export(module.exports, "CENTER_OF_CIRCLE", () => $bb84c280a189e0ba$export$c7609d9da8d80867);
$parcel$export(module.exports, "CIRCLE_RADIUS", () => $bb84c280a189e0ba$export$ca8f2c484d507a5d);
$parcel$export(module.exports, "INITIAL_INTERSEC_RADIUS", () => $bb84c280a189e0ba$export$71b7ee2b1d39589f);
$parcel$export(module.exports, "INITIAL_RADIANS", () => $bb84c280a189e0ba$export$95c476c8e1b0007);
$parcel$export(module.exports, "ARC_COLOR_ARR", () => $bb84c280a189e0ba$export$bdea539c223eec51);
$parcel$export(module.exports, "INFO_SLIDER_COORD", () => $bb84c280a189e0ba$export$840ec2322406bfdd);
$parcel$export(module.exports, "SLIDERS_COORD", () => $bb84c280a189e0ba$export$186dbbe504e85fe1);
$parcel$export(module.exports, "SLIDERS_COORD_OFFSET_VERTICAL", () => $bb84c280a189e0ba$export$75f2cc8245aafe09);
$parcel$export(module.exports, "THRESHOLD_RADIANS", () => $bb84c280a189e0ba$export$16d4da82cc3d15d6);
$parcel$export(module.exports, "INFO_SLIDER_ASSETS_SLUG", () => $bb84c280a189e0ba$export$2e51dc0dfab2d766);
const $bb84c280a189e0ba$export$7a003cdef7722780 = [
    0xFC99C4,
    0xF94F6F
];
const $bb84c280a189e0ba$export$c7609d9da8d80867 = {
    x: 600,
    y: 310
};
const $bb84c280a189e0ba$export$ca8f2c484d507a5d = 200;
const $bb84c280a189e0ba$export$71b7ee2b1d39589f = 145;
const $bb84c280a189e0ba$export$95c476c8e1b0007 = [
    Math.PI / 16,
    Math.PI / 4 * 3
];
const $bb84c280a189e0ba$export$bdea539c223eec51 = [
    0x000000,
    0x000000
];
const $bb84c280a189e0ba$export$840ec2322406bfdd = {
    x: 1180,
    y: 200
};
const $bb84c280a189e0ba$export$186dbbe504e85fe1 = [
    {
        x: 70,
        y: 800
    },
    {
        x: 440,
        y: 800
    },
    {
        x: 810,
        y: 800
    }
];
const $bb84c280a189e0ba$export$75f2cc8245aafe09 = [
    {
        x: -260,
        y: 400
    },
    {
        x: -260,
        y: 600
    },
    {
        x: 60,
        y: 400
    }
];
const $bb84c280a189e0ba$export$16d4da82cc3d15d6 = {
    max: Math.PI / 3 * 2,
    min: Math.PI / 9 * 5
};
const $bb84c280a189e0ba$export$2e51dc0dfab2d766 = "circle-theorem-10";

});

parcelRegister("dWkAg", function(module, exports) {

$parcel$export(module.exports, "areCoordsEqual", () => $526be0ad93c3e4bf$export$102b20725d4d2263);
function $526be0ad93c3e4bf$export$102b20725d4d2263(coordArr1, coordArr2) {
    if (coordArr1.length !== coordArr2.length) return false;
    return coordArr1.every((point, index)=>{
        const other = coordArr2[index];
        return point.x === other.x && point.y === other.y;
    });
}

});

parcelRegister("g4gW0", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0d65a8310461d1d$export$2e2bcd8739ae039);

var $iuB9z = parcelRequire("iuB9z");

var $9ec1t = parcelRequire("9ec1t");

var $i30uN = parcelRequire("i30uN");

var $3f3J1 = parcelRequire("3f3J1");
class $b0d65a8310461d1d$export$2e2bcd8739ae039 extends $iuB9z.Container {
    Layers = (0, $9ec1t.default).getInstance();
    AngleValue;
    arc;
    arcStroke;
    tag;
    startRadian;
    endRadian;
    degree;
    fillColor;
    smallDistance = 100;
    smallDistanceOffset = 0;
    addSmallDis = true;
    constructor(tag, angleColor, smallDistanceOffset = 0, addCon = false, addSmallDis = true){
        super();
        this.tag = tag;
        this.fillColor = angleColor.color;
        this.smallDistanceOffset = smallDistanceOffset;
        this.addSmallDis = addSmallDis;
        this.AngleValue = new (0, $i30uN.default)({
            x: -100,
            y: -100
        }, angleColor.textColor);
        this.addArc();
        !addCon && this.addToLayer();
    }
    addToLayer = ()=>this.Layers.Bottom.addChild(this);
    addArc() {
        this.arc = new $iuB9z.Graphics();
        this.addChild(this.arc);
        this.arcStroke = new $iuB9z.Graphics();
        this.addChild(this.arcStroke);
    }
    setVisible(status) {
        this.visible = status;
        this.AngleValue.visible = status;
    }
    draw(cCoord, startRadian, endRadian, degree, cClockwise) {
        const sD = this.smallDistance;
        const radian = sD <= 76 + this.smallDistanceOffset && this.addSmallDis ? Math.max((sD - this.smallDistanceOffset) / 2, 15) : 38;
        this.degree = degree;
        this.startRadian = startRadian;
        this.endRadian = endRadian;
        if (degree == 90) {
            this.arcStroke.clear();
            (0, $3f3J1.drawSquare)(this.arc, radian, startRadian, endRadian, this.fillColor, cClockwise);
        } else {
            (0, $3f3J1.drawArc)(this.arcStroke, radian, startRadian, endRadian, 3, 0x000000, cClockwise, true);
            (0, $3f3J1.drawArc)(this.arc, radian / 2, startRadian, endRadian, radian, this.fillColor, cClockwise, false);
        }
        const initialAngle = cClockwise ? endRadian : startRadian;
        this.AngleValue.setAngleValue(cCoord, initialAngle, degree, radian);
    }
}

});
parcelRegister("i30uN", function(module, exports) {

$parcel$export(module.exports, "default", () => $6935df93860f2c37$export$2e2bcd8739ae039);

var $iuB9z = parcelRequire("iuB9z");

var $9ec1t = parcelRequire("9ec1t");

var $eymUv = parcelRequire("eymUv");
class $6935df93860f2c37$export$2e2bcd8739ae039 extends $iuB9z.Text {
    Layers = (0, $9ec1t.default).getInstance();
    constructor(coord, color){
        super();
        this.text = "60\xb0";
        this.style.fill = color;
        this.style.fontSize = 34;
        this.style.fontWeight = "800";
        this.anchor.set(.5);
        this.setAngleValue(coord, 0, 0, 38);
        this.addToLayer();
    }
    addToLayer = ()=>this.Layers.Top.addChild(this);
    setValue = (value)=>this.text = `${value}\xb0`;
    setAngleValue(cCoord, initialAngle, degree, radian) {
        const angle = initialAngle + (0, $eymUv.default)(degree / 2);
        const coord = {
            x: Math.cos(angle) * radian * 1.7 + cCoord.x,
            y: Math.sin(angle) * radian * 1.7 + cCoord.y
        };
        this.setValue(degree);
        this.style.fontSize = radian;
        this.x = coord.x;
        this.y = coord.y;
    }
}

});
parcelRegister("eymUv", function(module, exports) {

$parcel$export(module.exports, "default", () => $0afd35e271dc067b$export$2e2bcd8739ae039);
function $0afd35e271dc067b$export$2e2bcd8739ae039(degree) {
    return degree * (Math.PI / 180);
}

});


parcelRegister("3f3J1", function(module, exports) {

$parcel$export(module.exports, "drawArc", () => $827e00f616855d7e$export$bf8a3f9983094125);
$parcel$export(module.exports, "drawSquare", () => $827e00f616855d7e$export$9340b6a85ea854b9);
function $827e00f616855d7e$export$bf8a3f9983094125(arc, r, sRadian, eRadian, w, color, cClockwise, isStroke) {
    arc.clear();
    if (!isStroke) arc.arc(0, 0, r, sRadian, eRadian, cClockwise).stroke({
        width: w,
        color: color
    });
    else arc.moveTo(Math.cos(sRadian) * r, Math.sin(sRadian) * r).lineTo(0, 0).arc(0, 0, r, sRadian, eRadian, cClockwise).moveTo(0, 0).lineTo(Math.cos(eRadian) * r, Math.sin(eRadian) * r).stroke({
        width: w,
        color: color
    });
    arc.rotation = 0;
}
function $827e00f616855d7e$export$9340b6a85ea854b9(square, dim, startRadian, endRadian, color, cClockwise) {
    square.clear();
    square.rect(0, 0, dim, dim).fill(color).stroke({
        color: 0x000000,
        width: 3
    });
    square.rotation = !cClockwise ? startRadian : endRadian;
}

});


parcelRegister("jZEcn", function(module, exports) {

$parcel$export(module.exports, "generateAngles", () => $83c21d34517267ce$export$adec80d12bc0398e);

var $a92Ax = parcelRequire("a92Ax");

var $cwj7p = parcelRequire("cwj7p");
function $83c21d34517267ce$export$adec80d12bc0398e(p, clockwise) {
    const { startRadian: startRadian, endRadian: endRadian } = (0, $a92Ax.default)(p.curr, p.prev, p.next);
    const degree = (0, $cwj7p.default)({
        startRadian: startRadian,
        endRadian: endRadian
    }, clockwise, false);
    return {
        startRadian: startRadian,
        endRadian: endRadian,
        degree: degree
    };
}

});
parcelRegister("a92Ax", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f2e4f2e6d187ae4$export$2e2bcd8739ae039);

var $2h5MD = parcelRequire("2h5MD");
function $1f2e4f2e6d187ae4$export$2e2bcd8739ae039(cCoord, coordStart, coordEnd) {
    const startRadian = (0, $2h5MD.default)(cCoord, coordStart);
    const endRadian = (0, $2h5MD.default)(cCoord, coordEnd);
    return {
        startRadian: startRadian,
        endRadian: endRadian
    };
}

});

parcelRegister("cwj7p", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6eb8af25d6ad3b0$export$2e2bcd8739ae039);

var $74Gga = parcelRequire("74Gga");
function $a6eb8af25d6ad3b0$export$2e2bcd8739ae039({ startRadian: startRadian, endRadian: endRadian }, cClockwise, even = true) {
    let _angle = startRadian - endRadian;
    if (!cClockwise) _angle = endRadian - startRadian;
    let degree = Math.floor((0, $74Gga.default)(_angle));
    degree = degree < 0 ? degree + 360 : degree;
    even && (degree = degree % 2 == 1 ? degree + 1 : degree);
    return degree;
}

});


parcelRegister("eitLW", function(module, exports) {

$parcel$export(module.exports, "default", () => $295d8ae516c805d1$export$2e2bcd8739ae039);

var $erVR3 = parcelRequire("erVR3");

var $16Wgx = parcelRequire("16Wgx");

var $16HUD = parcelRequire("16HUD");

var $gcphA = parcelRequire("gcphA");
class $295d8ae516c805d1$export$2e2bcd8739ae039 {
    CheckboxRenderer;
    isChecked = false;
    checkBoxLabel;
    handleFunc;
    constructor(coord, label, color, useCustomLayer = false, handleFunc = (label, v)=>{}){
        this.CheckboxRenderer = new (0, $gcphA.default)(color, label, useCustomLayer);
        Object.assign(this.CheckboxRenderer, coord);
        this.handleFunc = handleFunc;
        this.addInteractivity();
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).startedCircleAnim, ()=>this.setVisible(false));
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).completedCircleAnim, ()=>this.setVisible(true));
    }
    addToCon = (con)=>con.addChild(this.CheckboxRenderer);
    setScale = (v)=>this.CheckboxRenderer.con.scale.set(v);
    setVisible = (v)=>this.CheckboxRenderer.visible = v;
    addInteractivity() {
        const handleUpFunc = ()=>this.handleCheckbox();
        (0, $16Wgx.default)(this.CheckboxRenderer, {
            handleUpFunc: handleUpFunc
        }, (0, $16HUD.CustomCursorType).pointer, undefined, true);
    }
    handleCheckbox() {
        this.isChecked = !this.isChecked;
        this.handleFunc(this.checkBoxLabel, this.isChecked);
        this.CheckboxRenderer.drawCheckbox(this.isChecked);
    }
    getIsChecked() {
        return {
            label: this.checkBoxLabel,
            isChecked: this.isChecked
        };
    }
    setChecked(v) {
        this.isChecked = v;
        this.CheckboxRenderer.drawCheckbox(this.isChecked);
    }
}

});
parcelRegister("gcphA", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6f182ab57cf75ac$export$2e2bcd8739ae039);

var $iuB9z = parcelRequire("iuB9z");

var $9ec1t = parcelRequire("9ec1t");
class $c6f182ab57cf75ac$export$2e2bcd8739ae039 extends $iuB9z.Container {
    color;
    checkboxLabel;
    Layers;
    con;
    checkedSquare;
    defaultColor;
    constructor(color, checkboxLabel, useCustomLayer = false){
        super(), this.color = color, this.checkboxLabel = checkboxLabel, this.Layers = (0, $9ec1t.default).getInstance(), this.con = this.addChild(new $iuB9z.Container()), this.checkedSquare = this.con.addChild(new $iuB9z.Graphics()), this.defaultColor = 0xFFFFFF, this.addToLayer = ()=>this.Layers.UI.addChild(this);
        this.drawCheckbox(false);
        this.addLabel();
        !useCustomLayer && this.addToLayer();
    }
    addToLayer;
    drawCheckbox(isColored) {
        const fillColor = isColored ? this.color : this.defaultColor;
        this.checkedSquare.clear().roundRect(0, -20, 40, 40, 10).fill(fillColor).stroke({
            width: 2,
            color: 0x000000
        });
    }
    addLabel() {
        const text = new $iuB9z.Text({
            text: this.checkboxLabel
        });
        text.style.fontSize = 36;
        text.style.fill = this.color;
        text.anchor.set(0, .5);
        text.x = 50;
        text.y = 0;
        this.con.addChild(text);
    }
}

});


parcelRegister("beJMG", function(module, exports) {

$parcel$export(module.exports, "getTextureBatchBindGroup", () => $24797d7b1c25d5bc$export$84c26df82650dc9b);

var $awcfo = parcelRequire("awcfo");

var $bLlTJ = parcelRequire("bLlTJ");
"use strict";
const $24797d7b1c25d5bc$var$cachedGroups = {};
function $24797d7b1c25d5bc$export$84c26df82650dc9b(textures, size, maxTextures) {
    let uid = 2166136261;
    for(let i = 0; i < size; i++){
        uid ^= textures[i].uid;
        uid = Math.imul(uid, 16777619);
        uid >>>= 0;
    }
    return $24797d7b1c25d5bc$var$cachedGroups[uid] || $24797d7b1c25d5bc$var$generateTextureBatchBindGroup(textures, size, uid, maxTextures);
}
function $24797d7b1c25d5bc$var$generateTextureBatchBindGroup(textures, size, key, maxTextures) {
    const bindGroupResources = {};
    let bindIndex = 0;
    for(let i = 0; i < maxTextures; i++){
        const texture = i < size ? textures[i] : (0, $bLlTJ.Texture).EMPTY.source;
        bindGroupResources[bindIndex++] = texture.source;
        bindGroupResources[bindIndex++] = texture.style;
    }
    const bindGroup = new (0, $awcfo.BindGroup)(bindGroupResources);
    $24797d7b1c25d5bc$var$cachedGroups[key] = bindGroup;
    return bindGroup;
}

});

parcelRegister("6RGCN", function(module, exports) {

$parcel$export(module.exports, "CanvasPool", () => $cb3b5b020b2ab749$export$e56d0a06781accc9);

var $iCGeI = parcelRequire("iCGeI");

var $NbSCN = parcelRequire("NbSCN");

var $2GH55 = parcelRequire("2GH55");
"use strict";
class $cb3b5b020b2ab749$export$62d9f0b8aada09d7 {
    constructor(canvasOptions){
        this._canvasPool = /* @__PURE__ */ Object.create(null);
        this.canvasOptions = canvasOptions || {};
        this.enableFullScreen = false;
    }
    /**
   * Creates texture with params that were specified in pool constructor.
   * @param pixelWidth - Width of texture in pixels.
   * @param pixelHeight - Height of texture in pixels.
   */ _createCanvasAndContext(pixelWidth, pixelHeight) {
        const canvas = (0, $iCGeI.DOMAdapter).get().createCanvas();
        canvas.width = pixelWidth;
        canvas.height = pixelHeight;
        const context = canvas.getContext("2d");
        return {
            canvas: canvas,
            context: context
        };
    }
    /**
   * Gets a Power-of-Two render texture or fullScreen texture
   * @param minWidth - The minimum width of the render texture.
   * @param minHeight - The minimum height of the render texture.
   * @param resolution - The resolution of the render texture.
   * @returns The new render texture.
   */ getOptimalCanvasAndContext(minWidth, minHeight, resolution = 1) {
        minWidth = Math.ceil(minWidth * resolution - 1e-6);
        minHeight = Math.ceil(minHeight * resolution - 1e-6);
        minWidth = (0, $NbSCN.nextPow2)(minWidth);
        minHeight = (0, $NbSCN.nextPow2)(minHeight);
        const key = (minWidth << 17) + (minHeight << 1);
        if (!this._canvasPool[key]) this._canvasPool[key] = [];
        let canvasAndContext = this._canvasPool[key].pop();
        if (!canvasAndContext) canvasAndContext = this._createCanvasAndContext(minWidth, minHeight);
        return canvasAndContext;
    }
    /**
   * Place a render texture back into the pool.
   * @param canvasAndContext
   */ returnCanvasAndContext(canvasAndContext) {
        const canvas = canvasAndContext.canvas;
        const { width: width, height: height } = canvas;
        const key = (width << 17) + (height << 1);
        canvasAndContext.context.resetTransform();
        canvasAndContext.context.clearRect(0, 0, width, height);
        this._canvasPool[key].push(canvasAndContext);
    }
    clear() {
        this._canvasPool = {};
    }
}
const $cb3b5b020b2ab749$export$e56d0a06781accc9 = new $cb3b5b020b2ab749$export$62d9f0b8aada09d7();
(0, $2GH55.GlobalResourceRegistry).register($cb3b5b020b2ab749$export$e56d0a06781accc9);

});

parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = 'browser';
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ''; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return '/';
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});


var $75RpY = parcelRequire("75RpY");

var $iuB9z = parcelRequire("iuB9z");

var $75RpY = parcelRequire("75RpY");

var $iuB9z = parcelRequire("iuB9z");

var $9ec1t = parcelRequire("9ec1t");
class $129b550e43e52b2b$export$2e2bcd8739ae039 extends $iuB9z.Container {
    GridConfig;
    Layers;
    graphics;
    constructor(GridConfig){
        super(), this.GridConfig = GridConfig, this.Layers = (0, $9ec1t.default).getInstance(), this.graphics = this.addChild(new $iuB9z.Graphics()), this.addToLayer = ()=>this.Layers.BottomUnder.addChild(this);
        this.position.copyFrom(GridConfig);
        this.drawGrid();
        this.addToLayer();
    }
    addToLayer;
    drawGrid() {
        this.graphics.clear();
        const startX = -this.GridConfig.width / 2;
        const startY = -this.GridConfig.height / 2;
        // Vertical Lines
        for(let i = 0; i <= this.GridConfig.width / this.GridConfig.cellSize; i++)this.graphics.moveTo(startX + i * this.GridConfig.cellSize, startY).lineTo(startX + i * this.GridConfig.cellSize, startY + this.GridConfig.height);
        // Horizontal Lines
        for(let j = 0; j <= this.GridConfig.height / this.GridConfig.cellSize; j++)this.graphics.moveTo(startX, startY + j * this.GridConfig.cellSize).lineTo(startX + this.GridConfig.width, startY + j * this.GridConfig.cellSize);
        this.graphics.stroke({
            color: this.GridConfig.lineColor,
            width: this.GridConfig.lineWidth
        });
    }
    static getGlobalCoord(gridConfig, coord) {
        return {
            x: Math.floor(gridConfig.x - gridConfig.width / 2 + coord.x * gridConfig.cellSize),
            y: Math.floor(gridConfig.y - gridConfig.height / 2 + coord.y * gridConfig.cellSize)
        };
    }
}



var $iuB9z = parcelRequire("iuB9z");

var $9ec1t = parcelRequire("9ec1t");

var $75RpY = parcelRequire("75RpY");

var $d0yDD = parcelRequire("d0yDD");

var $aPdzS = parcelRequire("aPdzS");

var $iuB9z = parcelRequire("iuB9z");

var $9ec1t = parcelRequire("9ec1t");
class $06891432b5baa167$export$2e2bcd8739ae039 extends $iuB9z.Graphics {
    Layers = (0, $9ec1t.default).getInstance();
    w;
    lineColor;
    constructor(details){
        super();
        this.w = details && details.width ? details.width : 5;
        this.lineColor = details && details.lineColor ? details.lineColor : 0x000000;
        this.addToLayer();
    }
    addToLayer = ()=>this.Layers.Middle.addChild(this);
    draw(coordStart, coordEnd) {
        this.moveTo(coordStart.x, coordStart.y).lineTo(coordEnd.x, coordEnd.y).stroke({
            width: this.w,
            color: this.lineColor,
            cap: "round"
        });
    }
}


//import { LineEqualSymbol } from "../../../../../../../../src/types/Enum";
var $f443dc34377ca450$export$ec63e05e2ee9f6fc = /*#__PURE__*/ function(DrawingTool) {
    DrawingTool["pencil"] = "PENCIL";
    DrawingTool["point"] = "POINT";
    DrawingTool["line"] = "LINE";
    DrawingTool["clear"] = "CLR";
    DrawingTool["returnBack"] = "RETURN_BACK";
    DrawingTool["empty"] = "EMPTY";
    DrawingTool["answerPoint"] = "ANSWER_POINT";
    DrawingTool["answerLine"] = "ANSWER_LINE";
    DrawingTool["ruler"] = "RULER";
    DrawingTool["protractor"] = "PROTRACTOR";
    DrawingTool["compass"] = "COMPASS";
    return DrawingTool;
}({});
var $f443dc34377ca450$export$fc850f719b5599d5 = /*#__PURE__*/ function(ShapeType) {
    ShapeType["square"] = "SQUARE";
    ShapeType["rectangle"] = "RECTANGLE";
    ShapeType["t"] = "T_SHAPE";
    ShapeType["l"] = "L_SHAPE";
    ShapeType["parallel"] = "PARALLELOGRAM";
    ShapeType["triangle"] = "TRIANGLE";
    ShapeType["rightTriangle"] = "RIGHT_TRIANGLE";
    ShapeType["trapezoid"] = "TRAPEZOID";
    ShapeType["rightTrapezoid"] = "RIGHT_TRAPEZOID";
    return ShapeType;
}({});
var $f443dc34377ca450$export$9fc4ff6699ea78e4 = /*#__PURE__*/ function(ShapeColor) {
    ShapeColor[ShapeColor["black"] = 0] = "black";
    ShapeColor[ShapeColor["red"] = 16711680] = "red";
    return ShapeColor;
}({});
var $f443dc34377ca450$export$51940fbbacba35d4 = /*#__PURE__*/ function(QuestionType) {
    QuestionType["TYPE1"] = "TYPE1";
    QuestionType["TYPE2"] = "TYPE2";
    return QuestionType;
}({});
var $f443dc34377ca450$export$b4d15339b5fb8fcc = /*#__PURE__*/ function(QuestionMode) {
    QuestionMode["test"] = "TEST";
    QuestionMode["practise"] = "PRACTISE";
    return QuestionMode;
}({});
var $f443dc34377ca450$export$cacd6541cfeeb6c1 = /*#__PURE__*/ function(Direction) {
    Direction["clockwise"] = "clockwise";
    Direction["antiClockwise"] = "anti-clockwise";
    return Direction;
}({});


const $601e85a8e725b197$var$ANSWER_COLOR = 0x21D4FE;
function $601e85a8e725b197$export$d45698173a2bdc83(tool, color) {
    switch(tool){
        /*  case DrawingTool.doubleLine: return {
        color: 0xCCCCCC,
        width: 10,
        isEqualSymbol: false
      };*/ /* case DrawingTool.lineWithDirSym: return {
       color: 0xFF0000,
       width: 5,
       isEqualSymbol: true,
       equalSymbol: LineEqualSymbol.Arrow
     };*/ case (0, $f443dc34377ca450$export$ec63e05e2ee9f6fc).answerLine:
            return {
                color: $601e85a8e725b197$var$ANSWER_COLOR,
                width: 8,
                isEqualSymbol: false
            };
        default:
            return {
                color: color,
                width: 5,
                isEqualSymbol: false
            };
    }
}
function $601e85a8e725b197$export$8ade8fb643a685ac(tool) {
    switch(tool){
        case (0, $f443dc34377ca450$export$ec63e05e2ee9f6fc).answerPoint:
            return $601e85a8e725b197$var$ANSWER_COLOR;
        default:
            return 0x000000;
    }
}


class $68ac6a89867e5693$export$2e2bcd8739ae039 {
    static destroyDrawing = (d)=>{
        d && d.parent?.removeChild(d);
        d && d.destroy();
    };
    static createPoint(tool, coord, color) {
        const point = new (0, $aPdzS.default)(coord, color, 15, false);
        point.draw(coord);
        return point;
    }
    static createPencilLine(lineColor) {
        const width = 5;
        return new (0, $06891432b5baa167$export$2e2bcd8739ae039)({
            width: width,
            lineColor: lineColor
        });
    }
    static createLine(color, tool) {
        const l = new (0, $d0yDD.default)((0, $601e85a8e725b197$export$d45698173a2bdc83)(tool, color));
        l.setVisibleOfEqualSymbol(true);
        return l;
    }
    static drawBg(bg) {
        const dim = (0, $75RpY.default).getInstance().getDim();
        bg.clear().moveTo(0, 0).rect(0, 0, dim.WIDTH, dim.HEIGHT).fill({
            color: 0xff0000,
            alpha: 0
        });
    }
}


class $25d5e93b80a9fa04$export$2e2bcd8739ae039 {
    Layers = (0, $9ec1t.default).getInstance();
    drawings = [];
    drawing;
    selectedTool;
    bg;
    drawingColor = 0x000000;
    constructor(){}
    getBg = ()=>this.bg;
    clearBg = ()=>(0, $68ac6a89867e5693$export$2e2bcd8739ae039).destroyDrawing(this.bg);
    drawLine = (sCoord, eCoord)=>this.drawing.graph.draw(sCoord, eCoord);
    pushGraph = (graph)=>this.drawings.push({
            graph: graph,
            id: Date.now()
        });
    getDrawing = ()=>this.drawing;
    setSelectedTool = (s)=>this.selectedTool = s;
    initializePencilLine = ()=>this.addDrawing((0, $68ac6a89867e5693$export$2e2bcd8739ae039).createPencilLine(this.drawingColor));
    initializeLine = ()=>this.addDrawing((0, $68ac6a89867e5693$export$2e2bcd8739ae039).createLine(this.drawingColor, this.selectedTool));
    setDrawingColor = (color)=>this.drawingColor = color;
    clearDrawing = ()=>this.drawing = null;
    drawBg() {
        this.clearBg();
        this.bg = this.Layers.UI.addChild(new $iuB9z.Graphics);
        (0, $68ac6a89867e5693$export$2e2bcd8739ae039).drawBg(this.bg);
        return this.bg;
    }
    delLastDrawing() {
        const d = this.drawings.pop();
        if (d) {
            (0, $68ac6a89867e5693$export$2e2bcd8739ae039).destroyDrawing(d.graph);
            return d.id;
        }
        return null;
    }
    addPoint(coord) {
        const drawing = (0, $68ac6a89867e5693$export$2e2bcd8739ae039).createPoint(this.selectedTool, coord, this.drawingColor);
        this.addDrawing(drawing);
        this.Layers.UI.addChild(drawing);
    }
    clearAll() {
        this.drawings.forEach((d)=>(0, $68ac6a89867e5693$export$2e2bcd8739ae039).destroyDrawing(d.graph));
        this.drawings = [];
    }
    addDrawing(drawing) {
        if (!drawing) return;
        this.drawing = {
            graph: drawing,
            id: Date.now()
        };
        this.drawings.push(this.drawing);
    }
    addExtraDrawing(drwing) {
        if (!drwing) return;
        const drawing = {
            graph: drwing,
            id: Date.now()
        };
        this.drawings.push(drawing);
    }
}



var $erVR3 = parcelRequire("erVR3");

var $iuB9z = parcelRequire("iuB9z");
var $f60d53a2fe365b05$export$cb883390c27ec6dd = /*#__PURE__*/ function(EnumEventBus) {
    EnumEventBus["setSelectedTool"] = "SET_SELECTED_TOOL";
    EnumEventBus["delLastDrawing"] = "DELETE_LAST_DRAWING";
    EnumEventBus["clearAll"] = "CLEAR_All_OF_GRAPHICS";
    EnumEventBus["newQuestion"] = "NEW_QUESTION";
    EnumEventBus["setTracingMode"] = "SET_TRACING_MODE";
    EnumEventBus["animateTracingPaper"] = "ANIMATE_TRACING_PAPER";
    EnumEventBus["animateHint"] = "ANIMATE_HINT";
    EnumEventBus["setShowSolution"] = "SET_SHOW_SOLUTION";
    EnumEventBus["showTestQuestion"] = "SHOW_TEST_QUESTION";
    EnumEventBus["setActiveQuestionType"] = "SET_ACTIVE_QUESTION_TYPE";
    EnumEventBus["questionType"] = "QUESTION_TYPE";
    EnumEventBus["setQuestMode"] = "SET_QUESTION_MODE";
    EnumEventBus["startTest"] = "START_TEST";
    EnumEventBus["openHTPModal"] = "OPEN_HOW_TO_PLAY_MODAL";
    EnumEventBus["startAnswer"] = "START_ANSWER";
    EnumEventBus["saveAnswer"] = "SAVE_ANSWER";
    EnumEventBus["checkAnswer"] = "CHECK_ANSWER";
    EnumEventBus["checkedAnswers"] = "CHECKED_ANSWERS";
    EnumEventBus["setDirection"] = "SET_DIRECTION";
    EnumEventBus["setRotation"] = "SET_ROTATION";
    EnumEventBus["showRuler"] = "SHOW_RULER";
    EnumEventBus["showProtractor"] = "SHOW_PROTRACTOR";
    EnumEventBus["showResults"] = "SHOW_RESULTS";
    EnumEventBus["showCompass"] = "SHOW_COMPASS";
    return EnumEventBus;
}({});
const $f60d53a2fe365b05$export$f6644f0f2c90144b = new (0, $iuB9z.EventEmitter)();


class $3562a92658e51e13$export$2e2bcd8739ae039 {
    constructor(){
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).setPointerDown, (coord)=>this.onPointerDown(coord));
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).setPointerMove, (coord)=>this.onPointerMove(coord));
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).setPointerUp, ()=>this.onPointerUp());
        (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).on((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).setSelectedTool, (tool, color)=>this.setSelectedTool(tool, color));
    }
    setSelectedTool(tool, color) {}
    onPointerDown(coord) {}
    onPointerMove(coord) {}
    onPointerUp() {}
}



function $d779936abd442c13$export$2e2bcd8739ae039(bounds, ceilSize, coord) {
    const hOfCeilSize = ceilSize / 2;
    const gridStartCoord = {
        x: bounds.x - bounds.width / 2,
        y: bounds.y - bounds.height / 2
    };
    const gridEndCoord = {
        x: bounds.x + bounds.width / 2,
        y: bounds.y + bounds.height / 2
    };
    const _x = Math.max(Math.min(gridEndCoord.x, coord.x), gridStartCoord.x);
    const _y = Math.max(Math.min(gridEndCoord.y, coord.y), gridStartCoord.y);
    const x = Math.round((_x - bounds.x) / hOfCeilSize) * hOfCeilSize + bounds.x;
    const y = Math.round((_y - bounds.y) / hOfCeilSize) * hOfCeilSize + bounds.y;
    return {
        x: x,
        y: y
    };
}



var $16Wgx = parcelRequire("16Wgx");

var $kPclf = parcelRequire("kPclf");

var $8Db5v = parcelRequire("8Db5v");

var $16HUD = parcelRequire("16HUD");
class $2669fed17c218541$export$2e2bcd8739ae039 {
    static addBgInteractivity(bg, _onHandleDown, isPencil) {
        const onHandleOver = (_)=>{
            (0, $8Db5v.cursorEventBus).emit((0, $8Db5v.EnumCursorEventBus).setRotation, Math.PI / 4);
        };
        const onHandleDown = (e)=>{
            _onHandleDown((0, $kPclf.default)(e.global));
            (0, $8Db5v.cursorEventBus).emit((0, $8Db5v.EnumCursorEventBus).setRotation, Math.PI / 4);
        };
        (0, $16Wgx.default)(bg, {
            handleOverFunc: onHandleOver,
            handleDownFunc: onHandleDown
        }, isPencil ? (0, $16HUD.CustomCursorType).pencil : (0, $16HUD.CustomCursorType).target);
    }
}




const $63c2c194f5a6a92c$export$a310f85340477585 = [];
const $63c2c194f5a6a92c$export$8eac6cc23bfa2b30 = {
    x: -250,
    y: 50
};
const $63c2c194f5a6a92c$export$4213f7fd0b58a789 = 20;
const $63c2c194f5a6a92c$export$30636d68dd30d3b2 = {
    rotBut: "ROTATION_BUTTON",
    dirBut: "DIRECTION_BUTTON",
    questTypeBut: "QUESTION_TOP_SWITCHER"
};
const $63c2c194f5a6a92c$export$efa38d22ebef7327 = {
    x: 450,
    y: 460,
    width: 720,
    height: 720,
    cellSize: 48,
    lineWidth: 2,
    lineColor: 0x959595
};
const $63c2c194f5a6a92c$export$6d7df9fc320dfb0e = {
    x: 0,
    y: 140,
    width: 560,
    height: 60,
    fillColor: 0x0195b8,
    childFillColor: 0x30c3e6,
    color: 0x00FF00
};
const $63c2c194f5a6a92c$export$4ac00bd64839f05b = {
    header: "Select Sheet",
    x: 0,
    y: 380,
    width: 540,
    height: 60,
    fillColor: 0x0195b8,
    childFillColor: 0x30c3e6,
    color: 0x00FF00
};
const $63c2c194f5a6a92c$export$d013b5727948ec9f = {
    gotoTestMode: {
        x: 135,
        y: 50,
        width: 240,
        height: 60,
        defaultBgColor: 0x66FF99,
        pressedBgColor: 0xDDDDDD,
        fontSize: 28
    },
    genRandomlyQuestion: {
        x: 0,
        y: 230,
        width: 450,
        height: 60,
        defaultBgColor: 0x66FF99,
        pressedBgColor: 0xFFFFFF,
        fontSize: 28
    },
    tracingPaper: {
        x: -140,
        y: 460,
        width: 250,
        height: 60,
        pressedBgColor: 0xFFFFFF
    },
    animate: {
        x: -140,
        y: 540,
        width: 250,
        height: 60,
        pressedBgColor: 0xFFFFFF
    },
    showSolution: {
        x: 140,
        y: 460,
        width: 250,
        height: 60,
        defaultBgColor: 0x66FF99,
        pressedBgColor: 0xFFFFFF
    },
    hint: {
        x: 140,
        y: 540,
        width: 250,
        height: 60,
        pressedBgColor: 0xFFFFFF
    }
};
const $63c2c194f5a6a92c$export$9e9b6a158267785f = {
    TYPE1: {
        coord: {
            x: -220,
            y: 290
        },
        label: "Type1 - Draw",
        color: 0xdd45d0
    },
    TYPE2: {
        coord: {
            x: 10,
            y: 290
        },
        label: "Type2 - Specify",
        color: 0xdd45d0
    }
};
const $63c2c194f5a6a92c$export$9e3f3bbed766482 = {
    directionButton: {
        coord: {
            x: -100,
            y: 390
        },
        opts: {
            fontSize: 24,
            buttonColor: 0x66FF99,
            buttonHeight: 48,
            borderStyle: {
                width: 3,
                color: 0x232323
            }
        }
    },
    rotationButton: {
        coord: {
            x: -90,
            y: 310
        },
        opts: {
            fontSize: 24,
            buttonColor: 0x66FF99,
            buttonHeight: 48,
            borderStyle: {
                width: 3,
                color: 0x232323
            }
        }
    }
};
const $63c2c194f5a6a92c$export$51b86c66d1b1665c = {
    gotoPractiseMode: {
        x: 135,
        y: 50,
        width: 280,
        height: 60,
        defaultBgColor: 0x66FF99,
        pressedBgColor: 0xDDDDDD,
        fontSize: 28
    },
    nextQuestion: {
        x: 0,
        y: 470,
        width: 450,
        height: 60,
        defaultBgColor: 0x66FF99,
        pressedBgColor: 0xFFFFFF,
        fontSize: 28
    },
    giveAnswer: {
        x: -120,
        y: 470,
        width: 210,
        height: 60,
        defaultBgColor: 0x66FF99,
        pressedBgColor: 0xFFFFFF,
        fontSize: 28
    },
    saveAnswer: {
        x: 120,
        y: 470,
        width: 210,
        height: 60,
        defaultBgColor: 0x66FF99,
        pressedBgColor: 0xFFFFFF,
        fontSize: 28
    },
    goToPractise: {
        x: -120,
        y: 470,
        width: 210,
        height: 60,
        defaultBgColor: 0x66FF99,
        pressedBgColor: 0xFFFFFF,
        fontSize: 28
    },
    tryAgain: {
        x: 120,
        y: 470,
        width: 210,
        height: 60,
        defaultBgColor: 0x66FF99,
        pressedBgColor: 0xFFFFFF,
        fontSize: 28
    }
};
const $63c2c194f5a6a92c$export$5528ee5ae3e79a92 = [
    {
        label: "Translation",
        onHandle: ()=>{
            console.log("bu select box item \u0131");
        }
    },
    {
        label: "Reflection 1",
        onHandle: ()=>{
            console.log("bu select box item \u0131");
        }
    },
    {
        label: "Reflection 2",
        onHandle: ()=>{
            console.log("bu select box item \u0131");
        }
    },
    {
        label: "Rotation",
        onHandle: ()=>{
            console.log("bu select box item \u0131");
        }
    },
    {
        label: "Enlargement 1",
        onHandle: ()=>{
            console.log("bu select box item \u0131");
        }
    },
    {
        label: "Enlargement 2",
        onHandle: ()=>{
            console.log("bu select box item \u0131");
        }
    },
    {
        label: "Enlargement- Fractional",
        onHandle: ()=>{
            console.log("bu select box item \u0131");
        }
    },
    {
        label: "Enlargement - Negative",
        onHandle: ()=>{
            console.log("bu select box item \u0131");
        }
    },
    {
        label: "Describing Transformations",
        onHandle: ()=>{
            console.log("bu select box item \u0131");
        }
    },
    {
        label: "Mixed Transformations 1",
        onHandle: ()=>{
            console.log("bu select box item \u0131");
        }
    },
    {
        label: "Mixed Transformations 2",
        onHandle: ()=>{
            console.log("bu select box item \u0131");
        }
    }
];
const $63c2c194f5a6a92c$export$4572f3c647ad65e9 = [
    {
        label: "Open Worksheet",
        onHandle: ()=>{
            console.log("Open worksheet");
        }
    },
    {
        label: "Open Worksheet Solution",
        onHandle: ()=>{
            console.log("pen worksheet solution");
        }
    },
    {
        label: "Open Cheatsheet",
        onHandle: ()=>{
            console.log("Open Cheatsheet");
        }
    },
    {
        label: "Open Past Paper Question",
        onHandle: ()=>{
            console.log("Open Past paper Question");
        }
    }
];




const $b2cdbb9f9be33fa9$export$a9059d6f439f7c78 = (c1, c2)=>c1.x == c2.x && c1.y == c2.y;


function $e51087458325e0a9$export$2e2bcd8739ae039(qAnsLineCoords, answer) {
    if (qAnsLineCoords.length !== answer.answer.length) return false;
    const uAnsLineCoords = [
        ...answer.answer
    ].map((c)=>c.coord);
    const ans = Array(qAnsLineCoords.length).fill(null).map((_, i)=>{
        const line = [
            ...qAnsLineCoords
        ][i];
        const fLine = uAnsLineCoords.find((c)=>{
            return (0, $b2cdbb9f9be33fa9$export$a9059d6f439f7c78)(c[0], line[0]) && (0, $b2cdbb9f9be33fa9$export$a9059d6f439f7c78)(c[1], line[1]) || (0, $b2cdbb9f9be33fa9$export$a9059d6f439f7c78)(c[0], line[1]) && (0, $b2cdbb9f9be33fa9$export$a9059d6f439f7c78)(c[1], line[0]);
        });
        return Boolean(fLine);
    });
    return !ans.includes(false);
}





var $74Gga = parcelRequire("74Gga");


function $30450173a43b74db$export$2e2bcd8739ae039(question, answer) {
    if (answer.answer.length !== 1) return false;
    const qAns = (0, $129b550e43e52b2b$export$2e2bcd8739ae039).getGlobalCoord((0, $63c2c194f5a6a92c$export$efa38d22ebef7327), question.pivotPoint);
    const trueRot = question.rotation;
    const trueDir = trueRot < 0 ? (0, $f443dc34377ca450$export$cacd6541cfeeb6c1).antiClockwise : (0, $f443dc34377ca450$export$cacd6541cfeeb6c1).clockwise;
    const secDir = trueRot < 0 ? (0, $f443dc34377ca450$export$cacd6541cfeeb6c1).clockwise : (0, $f443dc34377ca450$export$cacd6541cfeeb6c1).antiClockwise;
    const angle = Math.abs((0, $74Gga.default)(trueRot));
    const isSameCoord = (0, $b2cdbb9f9be33fa9$export$a9059d6f439f7c78)(qAns, answer.answer[0].coord[0]);
    if (isSameCoord && (angle == answer.rotation && trueDir == answer.direction || angle == 360 - answer.rotation && secDir == answer.direction)) return true;
    return false;
}


function $a92b8f649ae06583$export$582f9e708b7f7daf(shapeCoords) {
    return [
        ...shapeCoords
    ].map((coord, cI)=>{
        const nextCoord = shapeCoords[cI !== shapeCoords.length - 1 ? cI + 1 : 0];
        return [
            coord,
            nextCoord
        ];
    });
}


class $905a2b833cc89373$export$2e2bcd8739ae039 {
    static instance;
    Questions = [];
    Answers = [];
    checkedAnswers;
    rotation = null;
    direction = null;
    constructor(){
        (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).on((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).setRotation, (r)=>this.rotation = r);
        (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).on((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).setDirection, (d)=>this.direction = d);
        (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).on((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).showResults, ()=>this.checkAnswer());
    }
    static getInstance = ()=>{
        if (!$905a2b833cc89373$export$2e2bcd8739ae039.instance) $905a2b833cc89373$export$2e2bcd8739ae039.instance = new $905a2b833cc89373$export$2e2bcd8739ae039();
        return $905a2b833cc89373$export$2e2bcd8739ae039.instance;
    };
    getQuestionCount = ()=>(0, $63c2c194f5a6a92c$export$4213f7fd0b58a789);
    addQuestion = (q)=>this.Questions.push(q);
    getQuestion = (index)=>this.Questions[index];
    getAnswer = (index)=>this.Answers[index];
    getAnswersLength = ()=>this.Answers.length;
    getIsCompleted = ()=>this.Questions.length == (0, $63c2c194f5a6a92c$export$4213f7fd0b58a789);
    addAnswer(answer) {
        const question = this.Questions[this.Answers.length];
        let ans;
        if (question.qType == (0, $f443dc34377ca450$export$51940fbbacba35d4).TYPE1) ans = {
            answer: answer,
            type: (0, $f443dc34377ca450$export$51940fbbacba35d4).TYPE1
        };
        else if (question.qType == (0, $f443dc34377ca450$export$51940fbbacba35d4).TYPE2) ans = {
            answer: answer,
            type: (0, $f443dc34377ca450$export$51940fbbacba35d4).TYPE2,
            rotation: this.rotation,
            direction: this.direction
        };
        this.Answers.push(ans);
        this.rotation = this.direction = null;
    }
    reset() {
        this.Questions = [];
        this.Answers = [];
        this.checkedAnswers = [];
    }
    checkAnswer() {
        this.checkedAnswers = [
            ...this.Questions
        ].map((question, qI)=>{
            if (question.qType == (0, $f443dc34377ca450$export$51940fbbacba35d4).TYPE1 && this.Answers[qI].type == (0, $f443dc34377ca450$export$51940fbbacba35d4).TYPE1) {
                const answer = this.Answers[qI];
                if (answer.answer.length == 0) return null;
                const rotShapeCoord = [
                    ...question.rotatedShapePoints
                ].map((c)=>(0, $129b550e43e52b2b$export$2e2bcd8739ae039).getGlobalCoord((0, $63c2c194f5a6a92c$export$efa38d22ebef7327), c));
                const qAnsLinesCoords = (0, $a92b8f649ae06583$export$582f9e708b7f7daf)(rotShapeCoord);
                return (0, $e51087458325e0a9$export$2e2bcd8739ae039)(qAnsLinesCoords, answer);
            } else {
                const answer = this.Answers[qI];
                if (answer.answer.length === 0 && !answer.direction && !answer.rotation) return null;
                return (0, $30450173a43b74db$export$2e2bcd8739ae039)(question, answer);
            }
        });
        (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).emit((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).checkedAnswers, this.checkedAnswers);
    }
}



var $d0yDD = parcelRequire("d0yDD");

var $erVR3 = parcelRequire("erVR3");

var $8Db5v = parcelRequire("8Db5v");

var $iuB9z = parcelRequire("iuB9z");

var $9ec1t = parcelRequire("9ec1t");

var $ckaL5 = parcelRequire("ckaL5");
const $4ceed94b29c2b11f$var$RULER_HEIGHT = 128;
const $4ceed94b29c2b11f$var$CM_UNIT = 60;
const $4ceed94b29c2b11f$var$CM_LINE_HEIGHT = 30;
const $4ceed94b29c2b11f$var$GRADUATIONS_OFFSET = 20;
const $4ceed94b29c2b11f$var$getRulerWidth = (cmAmount)=>cmAmount * $4ceed94b29c2b11f$var$CM_UNIT + $4ceed94b29c2b11f$var$GRADUATIONS_OFFSET * 2;
class $4ceed94b29c2b11f$export$2e2bcd8739ae039 {
    static getGraduationCoord(i, cmAmount, isBack) {
        const w = $4ceed94b29c2b11f$var$getRulerWidth(cmAmount);
        return {
            x: -w / 2 + $4ceed94b29c2b11f$var$CM_UNIT * i + $4ceed94b29c2b11f$var$GRADUATIONS_OFFSET,
            y: isBack ? $4ceed94b29c2b11f$var$RULER_HEIGHT / 2 + 2 : -$4ceed94b29c2b11f$var$RULER_HEIGHT / 2
        };
    }
    static drawBg(bg, cmAmount) {
        const w = $4ceed94b29c2b11f$var$getRulerWidth(cmAmount);
        const h = $4ceed94b29c2b11f$var$RULER_HEIGHT;
        bg.moveTo(-w / 2, -h / 2).roundRect(-w / 2, -h / 2, w, h, 10).fill({
            color: (0, $ckaL5.PINK_ANGLE_COLORS)[0],
            alpha: .6
        });
    }
    static drawNumbers(numbers, cmAmount) {
        const w = $4ceed94b29c2b11f$var$getRulerWidth(cmAmount);
        const startX = -w / 2;
        const y = -$4ceed94b29c2b11f$var$RULER_HEIGHT / 2;
        numbers.forEach((num, number)=>{
            num.text = number;
            num.anchor.set(.5);
            num.x = startX + $4ceed94b29c2b11f$var$CM_UNIT * number + $4ceed94b29c2b11f$var$GRADUATIONS_OFFSET;
            num.y = y + $4ceed94b29c2b11f$var$CM_LINE_HEIGHT + 12;
            num.style.fontSize = 20;
        });
    }
    static drawgraduations(graduations, cmAmount) {
        const w = $4ceed94b29c2b11f$var$getRulerWidth(cmAmount);
        Array(cmAmount + 1).fill(null).forEach((_, i)=>{
            // START Drawing CMs
            const { x: x, y: y } = this.getGraduationCoord(i, cmAmount, false);
            graduations.moveTo(x, y).lineTo(x, y + $4ceed94b29c2b11f$var$CM_LINE_HEIGHT);
            // END Drawing CMs
            if (i < cmAmount) {
                // START Drawing MM lines in between CMs
                const unitMMX = $4ceed94b29c2b11f$var$CM_UNIT / 10;
                Array(10).fill(null).forEach((_, mi)=>{
                    const mmX = x + unitMMX * (mi + 1);
                    const mmY = y + $4ceed94b29c2b11f$var$CM_LINE_HEIGHT / 3 * (mi == 4 ? 2 : 1);
                    graduations.moveTo(mmX, y).lineTo(mmX, mmY);
                });
            // END Drawing MM lines in between CMs
            }
        });
        graduations.stroke({
            width: 1,
            color: 0x000000
        });
    }
    static drawFlipButton(flipButton) {
        const coord = {
            x: 0,
            y: 9
        };
        flipButton.moveTo(coord.x, coord.y).circle(coord.x, coord.y, 25).fill({
            color: 0xff0000,
            alpha: 0
        }).moveTo(coord.x - 8, coord.y - 6).lineTo(coord.x + 8, coord.y - 6).lineTo(coord.x, coord.y + 6).lineTo(coord.x - 8, coord.y - 6).fill(0x333333);
    }
    static drawRotateButton(rotateButton, isLeft, cmAmount) {
        const totalW = $4ceed94b29c2b11f$var$getRulerWidth(cmAmount);
        const w = $4ceed94b29c2b11f$var$GRADUATIONS_OFFSET + $4ceed94b29c2b11f$var$CM_UNIT;
        const startX = isLeft ? -totalW / 2 : totalW / 2 - w;
        const startY = -$4ceed94b29c2b11f$var$RULER_HEIGHT / 2;
        rotateButton.moveTo(startX, startY).roundRect(startX, startY, w, $4ceed94b29c2b11f$var$RULER_HEIGHT, 10).fill({
            color: 0x000000,
            alpha: 0
        });
    }
    static drawGrabButton(grabButton, cmAmount) {
        const totalW = $4ceed94b29c2b11f$var$getRulerWidth(cmAmount);
        const offsetW = $4ceed94b29c2b11f$var$GRADUATIONS_OFFSET + $4ceed94b29c2b11f$var$CM_UNIT;
        const w = totalW - 2 * offsetW;
        const h = -$4ceed94b29c2b11f$var$RULER_HEIGHT / 2;
        const startX = -totalW / 2 + offsetW;
        grabButton.moveTo(startX, h).rect(startX, h, w, $4ceed94b29c2b11f$var$RULER_HEIGHT).fill({
            color: 0xff0000,
            alpha: 0
        });
    }
    static drawDrawingArea(drawingArea, cmAmount, isBack) {
        const totalW = $4ceed94b29c2b11f$var$getRulerWidth(cmAmount) - 2 * $4ceed94b29c2b11f$var$GRADUATIONS_OFFSET;
        const h = $4ceed94b29c2b11f$var$RULER_HEIGHT / 4;
        const startY = isBack ? h * 2 : -h * 3;
        drawingArea.moveTo(-totalW / 2, startY).rect(-totalW / 2, startY, totalW, h).fill({
            color: 0xff0000,
            alpha: 0
        });
    }
}



var $2UGuq = parcelRequire("2UGuq");

var $kPclf = parcelRequire("kPclf");

var $eP48i = parcelRequire("eP48i");

var $2h5MD = parcelRequire("2h5MD");
const $e0b6806628171210$var$RULER_CM_AMOUNT = 15;
class $e0b6806628171210$export$2e2bcd8739ae039 extends $iuB9z.Container {
    Layers = (0, $9ec1t.default).getInstance();
    bg = this.addChild(new $iuB9z.Graphics());
    graduations = this.addChild(new $iuB9z.Graphics());
    numbers = Array($e0b6806628171210$var$RULER_CM_AMOUNT + 1).fill(null).map(()=>this.addChild(new $iuB9z.Text()));
    drawingArea = this.addChild(new $iuB9z.Graphics());
    backDrawingArea = this.addChild(new $iuB9z.Graphics());
    grabButton = this.addChild(new $iuB9z.Graphics());
    flipButton = this.addChild(new $iuB9z.Graphics());
    rotateRightButton = this.addChild(new $iuB9z.Graphics());
    rotateLeftButton = this.addChild(new $iuB9z.Graphics());
    constructor(){
        super();
        this.addToLayer();
        this.deactiveEventMode();
    }
    addToLayer = ()=>this.Layers.UITop.addChild(this);
    deactiveEventMode = ()=>[
            this.bg,
            this.graduations,
            ...this.numbers
        ].forEach((elm)=>elm.eventMode = 'none');
    getGraduationBounds(isBack) {
        const w = this.graduations.width;
        const glb = this.graduations.getGlobalPosition();
        const _pstn = (0, $4ceed94b29c2b11f$export$2e2bcd8739ae039).getGraduationCoord(0, $e0b6806628171210$var$RULER_CM_AMOUNT, isBack);
        const __startCoord = (0, $kPclf.default)({
            x: glb.x + _pstn.x,
            y: glb.y + _pstn.y
        });
        const distance = (0, $eP48i.default)(__startCoord, glb);
        const rad1 = (0, $2h5MD.default)(__startCoord, glb);
        const _startCoord = (0, $2UGuq.default)(this.rotation + Math.PI + rad1, distance);
        const _endCoord = (0, $2UGuq.default)(this.rotation, w);
        const start = (0, $kPclf.default)({
            x: glb.x + _startCoord.x,
            y: glb.y + _startCoord.y
        });
        const end = (0, $kPclf.default)({
            x: start.x + _endCoord.x,
            y: start.y + _endCoord.y
        });
        return {
            start: start,
            end: end
        };
    }
    draw() {
        (0, $4ceed94b29c2b11f$export$2e2bcd8739ae039).drawBg(this.bg, $e0b6806628171210$var$RULER_CM_AMOUNT);
        (0, $4ceed94b29c2b11f$export$2e2bcd8739ae039).drawgraduations(this.graduations, $e0b6806628171210$var$RULER_CM_AMOUNT);
        (0, $4ceed94b29c2b11f$export$2e2bcd8739ae039).drawNumbers(this.numbers, $e0b6806628171210$var$RULER_CM_AMOUNT);
        (0, $4ceed94b29c2b11f$export$2e2bcd8739ae039).drawFlipButton(this.flipButton);
        (0, $4ceed94b29c2b11f$export$2e2bcd8739ae039).drawRotateButton(this.rotateRightButton, false, $e0b6806628171210$var$RULER_CM_AMOUNT);
        (0, $4ceed94b29c2b11f$export$2e2bcd8739ae039).drawRotateButton(this.rotateLeftButton, true, $e0b6806628171210$var$RULER_CM_AMOUNT);
        (0, $4ceed94b29c2b11f$export$2e2bcd8739ae039).drawGrabButton(this.grabButton, $e0b6806628171210$var$RULER_CM_AMOUNT);
        (0, $4ceed94b29c2b11f$export$2e2bcd8739ae039).drawDrawingArea(this.drawingArea, $e0b6806628171210$var$RULER_CM_AMOUNT, false);
        (0, $4ceed94b29c2b11f$export$2e2bcd8739ae039).drawDrawingArea(this.backDrawingArea, $e0b6806628171210$var$RULER_CM_AMOUNT, true);
    }
}



var $d0yDD = parcelRequire("d0yDD");

var $2h5MD = parcelRequire("2h5MD");

var $darcK = parcelRequire("darcK");

var $kPclf = parcelRequire("kPclf");
function $a5e99a647a57680d$export$2e2bcd8739ae039(Point, startCoord, endCoord) {
    const v = {
        x: endCoord.x - startCoord.x,
        y: endCoord.y - startCoord.y
    };
    const w = {
        x: Point.x - startCoord.x,
        y: Point.y - startCoord.y
    };
    const vSqMag = v.x * v.x + v.y * v.y;
    if (vSqMag === 0) return startCoord;
    let t = (w.x * v.x + w.y * v.y) / vSqMag;
    t = Math.max(0, Math.min(1, t));
    return {
        x: startCoord.x + t * v.x,
        y: startCoord.y + t * v.y
    };
}



var $16Wgx = parcelRequire("16Wgx");

var $16HUD = parcelRequire("16HUD");

var $dWkAg = parcelRequire("dWkAg");
const $056aaa6d1208f6db$var$DEFAULT_COORD = {
    x: 400,
    y: 480
};
class $056aaa6d1208f6db$export$2e2bcd8739ae039 {
    getDrawing;
    RulerRenderer;
    isFlipped;
    isGrabbing;
    isRotating;
    isRotatingLeft;
    isDrawingLine;
    mStartCoord;
    grabDelta;
    bounds;
    drawing;
    lineColor;
    constructor(getDrawing){
        this.getDrawing = getDrawing;
        this.RulerRenderer = new (0, $e0b6806628171210$export$2e2bcd8739ae039)();
        this.isFlipped = false;
        this.isGrabbing = false;
        this.isRotating = false;
        this.isDrawingLine = false;
        this.lineColor = 0x000000;
        this.setVisible = (v)=>this.RulerRenderer.visible = v;
        this.getVisible = ()=>this.RulerRenderer.visible;
        this.setColor = (color)=>this.lineColor = color;
        this.RulerRenderer.draw();
        Object.assign(this.RulerRenderer, $056aaa6d1208f6db$var$DEFAULT_COORD);
        this.addInteractivities();
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).setPointerMove, (coord)=>this.handlePointerMove(coord));
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).setPointerUp, (_)=>this.handlePointerUp());
    }
    setVisible;
    getVisible;
    setColor;
    addInteractivities() {
        (0, $16Wgx.default)(this.RulerRenderer.flipButton, {
            handleDownFunc: (_)=>this.handleDownFlipButton()
        }, (0, $16HUD.CustomCursorType).pointer);
        (0, $16Wgx.default)(this.RulerRenderer.grabButton, {
            handleDownFunc: (e)=>this.handleDownGrabButton(e)
        }, (0, $16HUD.CustomCursorType).grab);
        (0, $16Wgx.default)(this.RulerRenderer.rotateRightButton, {
            handleDownFunc: (e)=>this.handleDownRotateButton(e, false)
        }, (0, $16HUD.CustomCursorType).rotate);
        (0, $16Wgx.default)(this.RulerRenderer.rotateLeftButton, {
            handleDownFunc: (e)=>this.handleDownRotateButton(e, true)
        }, (0, $16HUD.CustomCursorType).rotate);
        (0, $16Wgx.default)(this.RulerRenderer.drawingArea, {
            handleOverFunc: (_)=>this.handleOverDrawingArea(false),
            handleDownFunc: (e)=>this.handleDownDrawingArea(e, false)
        }, (0, $16HUD.CustomCursorType).pencil);
        (0, $16Wgx.default)(this.RulerRenderer.backDrawingArea, {
            handleOverFunc: (_)=>this.handleOverDrawingArea(true),
            handleDownFunc: (e)=>this.handleDownDrawingArea(e, true)
        }, (0, $16HUD.CustomCursorType).pencil);
    }
    handleOverDrawingArea(isBack) {
        const rot = this.RulerRenderer.rotation + (isBack ? Math.PI : 0);
        (0, $8Db5v.cursorEventBus).emit((0, $8Db5v.EnumCursorEventBus).setRotation, rot);
        this.drawing = new (0, $d0yDD.default)({
            color: this.lineColor,
            width: 5,
            isEqualSymbol: false
        });
    }
    handleDownDrawingArea(e, isBack) {
        const coord = (0, $kPclf.default)(e.global);
        const Coords = this.RulerRenderer.getGraduationBounds(isBack);
        this.isDrawingLine = true;
        this.mStartCoord = (0, $a5e99a647a57680d$export$2e2bcd8739ae039)(coord, Coords.start, Coords.end);
        this.bounds = Coords;
        (0, $erVR3.rootEventBus).emit((0, $erVR3.EnumRootEventBus).setRulerLineStartCoord);
    }
    handleDownFlipButton() {
        this.RulerRenderer.rotation = (0, $darcK.normalizeRadian)(this.RulerRenderer.rotation + Math.PI);
        this.isFlipped = !this.isFlipped;
    }
    handleDownRotateButton(e, isLeft) {
        this.isRotating = true;
        this.isRotatingLeft = isLeft;
        this.mStartCoord = (0, $kPclf.default)(e.global);
        this.handleEventMode(false);
    }
    handleDownGrabButton(e) {
        this.isGrabbing = true;
        this.mStartCoord = (0, $kPclf.default)(e.global);
        this.grabDelta = (0, $kPclf.default)({
            x: this.RulerRenderer.x - this.mStartCoord.x,
            y: this.RulerRenderer.y - this.mStartCoord.y
        });
        this.handleEventMode(false);
    }
    handlePointerMove(coord) {
        if (this.isGrabbing) {
            this.RulerRenderer.x = coord.x + this.grabDelta.x;
            this.RulerRenderer.y = coord.y + this.grabDelta.y;
        } else if (this.isRotating) {
            const rulerCoord = {
                x: this.RulerRenderer.x,
                y: this.RulerRenderer.y
            };
            const rad = (0, $2h5MD.default)(coord, rulerCoord);
            this.RulerRenderer.rotation = rad + (this.isFlipped && this.isRotatingLeft ? 0 : this.isRotatingLeft ? 0 : Math.PI);
        } else if (this.isDrawingLine) {
            const projectedPoint = (0, $a5e99a647a57680d$export$2e2bcd8739ae039)(coord, this.bounds.start, this.bounds.end);
            this.drawing.draw(this.mStartCoord, projectedPoint);
        }
    }
    handlePointerUp() {
        this.mStartCoord = undefined;
        this.isGrabbing = false;
        this.isRotating = false;
        this.isDrawingLine = false;
        this.bounds = undefined;
        this.handleEventMode(true);
        if (this.getVisible() && this.drawing && !(0, $dWkAg.areCoordsEqual)([
            this.drawing.coordStart
        ], [
            this.drawing.coordEnd
        ])) {
            this.getDrawing(this.drawing);
            this.drawing = undefined;
        }
    }
    handleEventMode(v) {
        [
            this.RulerRenderer.flipButton,
            this.RulerRenderer.grabButton,
            this.RulerRenderer.rotateRightButton,
            this.RulerRenderer.rotateLeftButton
        ].forEach((elm)=>elm.eventMode = v ? 'static' : 'none');
    }
}



var $erVR3 = parcelRequire("erVR3");

var $iuB9z = parcelRequire("iuB9z");

var $9ec1t = parcelRequire("9ec1t");

var $iuB9z = parcelRequire("iuB9z");

var $2UGuq = parcelRequire("2UGuq");

var $74Gga = parcelRequire("74Gga");
const $1375e54837642d5c$var$PINK_ANGLE_COLOR = 0xFC99C4;
const $1375e54837642d5c$var$RADIUS = 400;
const $1375e54837642d5c$var$OFFSET_RADIAN = Math.PI / 180 * 2.5;
const $1375e54837642d5c$var$STROKE_COLOR = 0x444444;
const $1375e54837642d5c$var$STROKE_WIDTH = 1.5;
const $1375e54837642d5c$var$GRAD_CONFIG = {
    lineWidth: 44,
    subLineWidth: 28,
    dashLineWidth: 10,
    semiCircle: {
        big: 320,
        sub: 275,
        small: 40
    }
};
class $1375e54837642d5c$export$2e2bcd8739ae039 {
    static drawBackground(background) {
        const startRad = Math.PI - $1375e54837642d5c$var$OFFSET_RADIAN;
        const endRad = $1375e54837642d5c$var$OFFSET_RADIAN;
        const startCoord = (0, $2UGuq.default)(startRad, $1375e54837642d5c$var$RADIUS);
        background.moveTo(startCoord.x, startCoord.y).arc(0, 0, $1375e54837642d5c$var$RADIUS, startRad, endRad).lineTo(startCoord.x, startCoord.y).fill({
            color: $1375e54837642d5c$var$PINK_ANGLE_COLOR,
            alpha: .6
        });
    }
    static drawGraduations(graduations) {
        $1375e54837642d5c$var$drawGraduationLines(graduations);
        $1375e54837642d5c$var$drawSemiCircles(graduations);
        $1375e54837642d5c$var$drawInnerLines(graduations);
    }
    static drawAngleLabels(container) {
        const angleLabels = [];
        const unitRad = Math.PI / 18;
        const outerRadius = $1375e54837642d5c$var$GRAD_CONFIG.semiCircle.big + 20;
        const innerRadius = $1375e54837642d5c$var$GRAD_CONFIG.semiCircle.big - 20;
        Array(19).fill(null).forEach((_, i)=>{
            const currentRad = unitRad * i;
            const angleValue1 = (0, $74Gga.default)(currentRad);
            const angleValue2 = (0, $74Gga.default)(Math.PI - currentRad);
            if (angleValue1 === 90) {
                const angle90Label = container.addChild($1375e54837642d5c$var$createAngleLabel(currentRad, $1375e54837642d5c$var$GRAD_CONFIG.semiCircle.big, angleValue1));
                angle90Label.style.fontSize = 28;
                angleLabels.push(angle90Label);
            } else {
                const outerAngleLabel = container.addChild($1375e54837642d5c$var$createAngleLabel(currentRad, outerRadius, angleValue1));
                const innerAngleLabel = container.addChild($1375e54837642d5c$var$createAngleLabel(currentRad, innerRadius, angleValue2));
                angleLabels.push(outerAngleLabel, innerAngleLabel);
            }
        });
        return angleLabels;
    }
    static drawMarkAngleButton(markAngleButton, rotation, color = "yellow") {
        const buttonLength = 32;
        const lineLength = 12;
        const startRad = rotation - $1375e54837642d5c$var$OFFSET_RADIAN;
        const endRad = rotation + $1375e54837642d5c$var$OFFSET_RADIAN;
        const startCoord = (0, $2UGuq.default)(startRad, $1375e54837642d5c$var$RADIUS);
        const endCoord = (0, $2UGuq.default)(endRad, $1375e54837642d5c$var$RADIUS);
        const startOuterCoord = (0, $2UGuq.default)(startRad, $1375e54837642d5c$var$RADIUS + buttonLength);
        const lineStartCoord = (0, $2UGuq.default)(rotation, $1375e54837642d5c$var$RADIUS);
        const lineEndCoord = (0, $2UGuq.default)(rotation, $1375e54837642d5c$var$RADIUS + lineLength);
        markAngleButton.clear().moveTo(startCoord.x, startCoord.y).lineTo(startOuterCoord.x, startOuterCoord.y).arc(0, 0, $1375e54837642d5c$var$RADIUS + buttonLength, startRad, endRad).lineTo(endCoord.x, endCoord.y).arc(0, 0, $1375e54837642d5c$var$RADIUS, startRad, endRad).fill({
            color: color,
            alpha: .5
        }).moveTo(lineStartCoord.x, lineStartCoord.y).lineTo(lineEndCoord.x, lineEndCoord.y).stroke({
            width: 2,
            color: 0x000000
        });
    }
    static drawRotateButtons(rotateLeftButton, rotateRightButton) {
        const startLeftRad = -(Math.PI + $1375e54837642d5c$var$OFFSET_RADIAN);
        const endLeftRad = startLeftRad + Math.PI / 12;
        const startLeftCoord = (0, $2UGuq.default)(startLeftRad, $1375e54837642d5c$var$RADIUS);
        const endLeftCoord = (0, $2UGuq.default)(endLeftRad, $1375e54837642d5c$var$RADIUS);
        const startRightRad = Math.PI / 180 + $1375e54837642d5c$var$OFFSET_RADIAN;
        const endRightRad = startRightRad - Math.PI / 12;
        const startRightCoord = (0, $2UGuq.default)(startRightRad, $1375e54837642d5c$var$RADIUS);
        const endRightCoord = (0, $2UGuq.default)(endRightRad, $1375e54837642d5c$var$RADIUS);
        $1375e54837642d5c$var$drawRotateButton(rotateLeftButton, startLeftCoord, endLeftCoord, startLeftRad, endLeftRad, true);
        $1375e54837642d5c$var$drawRotateButton(rotateRightButton, startRightCoord, endRightCoord, startRightRad, endRightRad, false);
    }
}
function $1375e54837642d5c$var$drawRotateButton(rotateButton, startCoord, endCoord, startRad, endRad, isLeft) {
    const centerX = (isLeft ? -1 : 1) * $1375e54837642d5c$var$RADIUS / 3;
    rotateButton.moveTo(centerX, startCoord.y).lineTo(startCoord.x, startCoord.y).arc(0, 0, $1375e54837642d5c$var$RADIUS, startRad, endRad, !isLeft).lineTo(centerX, endCoord.y).lineTo(centerX, startCoord.y).fill({
        color: 0x000000,
        alpha: 0
    });
}
function $1375e54837642d5c$var$drawGraduationLines(graduations) {
    const unitRad = Math.PI / 36;
    Array(37).fill(null).forEach((_, i)=>{
        const rad = Math.PI + unitRad * i;
        const startCoord = (0, $2UGuq.default)(rad, $1375e54837642d5c$var$RADIUS);
        const endCoord = (0, $2UGuq.default)(rad, $1375e54837642d5c$var$RADIUS - (i === 18 ? $1375e54837642d5c$var$GRAD_CONFIG.lineWidth + 12 : $1375e54837642d5c$var$GRAD_CONFIG.lineWidth));
        graduations.moveTo(startCoord.x, startCoord.y).lineTo(endCoord.x, endCoord.y).stroke({
            width: $1375e54837642d5c$var$STROKE_WIDTH,
            color: $1375e54837642d5c$var$STROKE_COLOR
        });
        if (i === 36) return;
        $1375e54837642d5c$var$drawSubGraduationLines(graduations, rad);
    });
}
function $1375e54837642d5c$var$drawSubGraduationLines(graduations, baseRad) {
    const subUnitRad = Math.PI / 180;
    Array(5).fill(null).forEach((_, i)=>{
        if (i === 4) return;
        const subRad = baseRad + subUnitRad * (i + 1);
        const startCoord = (0, $2UGuq.default)(subRad, $1375e54837642d5c$var$RADIUS);
        const endCoord = (0, $2UGuq.default)(subRad, $1375e54837642d5c$var$RADIUS - $1375e54837642d5c$var$GRAD_CONFIG.subLineWidth);
        graduations.moveTo(startCoord.x, startCoord.y).lineTo(endCoord.x, endCoord.y).stroke({
            width: $1375e54837642d5c$var$STROKE_WIDTH,
            color: $1375e54837642d5c$var$STROKE_COLOR
        });
    });
}
function $1375e54837642d5c$var$drawSemiCircles(graduations) {
    const bigCircleStart = (0, $2UGuq.default)(Math.PI, $1375e54837642d5c$var$GRAD_CONFIG.semiCircle.big);
    const bigCircleSecondStart = (0, $2UGuq.default)(-Math.PI / 180 * 85, $1375e54837642d5c$var$GRAD_CONFIG.semiCircle.big);
    const subCircleStart = (0, $2UGuq.default)(Math.PI, $1375e54837642d5c$var$GRAD_CONFIG.semiCircle.sub);
    const smallCircleStart = (0, $2UGuq.default)(Math.PI, $1375e54837642d5c$var$GRAD_CONFIG.semiCircle.small);
    graduations.moveTo(bigCircleStart.x, bigCircleStart.y).arc(0, 0, $1375e54837642d5c$var$GRAD_CONFIG.semiCircle.big, Math.PI, -Math.PI / 180 * 95).moveTo(bigCircleSecondStart.x, bigCircleSecondStart.y).arc(0, 0, $1375e54837642d5c$var$GRAD_CONFIG.semiCircle.big, -Math.PI / 180 * 85, 0).moveTo(subCircleStart.x, subCircleStart.y).arc(0, 0, $1375e54837642d5c$var$GRAD_CONFIG.semiCircle.sub, Math.PI, 0).moveTo(smallCircleStart.x, smallCircleStart.y).arc(0, 0, $1375e54837642d5c$var$GRAD_CONFIG.semiCircle.small, Math.PI, 0).stroke({
        width: $1375e54837642d5c$var$STROKE_WIDTH,
        color: $1375e54837642d5c$var$STROKE_COLOR
    });
}
function $1375e54837642d5c$var$drawInnerLines(graduations) {
    const unitRad = Math.PI / 18;
    Array(19).fill(null).forEach((_, i)=>{
        const rad = Math.PI + unitRad * i;
        const innerEndRadius = [
            0,
            9,
            18
        ].includes(i) ? 0 : $1375e54837642d5c$var$GRAD_CONFIG.semiCircle.small;
        const innerStartRadius = $1375e54837642d5c$var$GRAD_CONFIG.semiCircle.sub + (i !== 9 ? $1375e54837642d5c$var$GRAD_CONFIG.dashLineWidth / 2 : $1375e54837642d5c$var$GRAD_CONFIG.dashLineWidth);
        const dashStartCoord = (0, $2UGuq.default)(rad, $1375e54837642d5c$var$GRAD_CONFIG.semiCircle.big + $1375e54837642d5c$var$GRAD_CONFIG.dashLineWidth / 2);
        const dashEndCoord = (0, $2UGuq.default)(rad, $1375e54837642d5c$var$GRAD_CONFIG.semiCircle.big - $1375e54837642d5c$var$GRAD_CONFIG.dashLineWidth / 2);
        const innerStartCoord = (0, $2UGuq.default)(rad, innerStartRadius);
        const innerEndCoord = (0, $2UGuq.default)(rad, innerEndRadius);
        graduations.moveTo(innerStartCoord.x, innerStartCoord.y).lineTo(innerEndCoord.x, innerEndCoord.y).stroke({
            width: $1375e54837642d5c$var$STROKE_WIDTH,
            color: $1375e54837642d5c$var$STROKE_COLOR
        });
        if (i === 9) return;
        graduations.moveTo(dashStartCoord.x, dashStartCoord.y).lineTo(dashEndCoord.x, dashEndCoord.y).stroke({
            width: $1375e54837642d5c$var$STROKE_WIDTH,
            color: $1375e54837642d5c$var$STROKE_COLOR
        });
    });
}
function $1375e54837642d5c$var$createAngleLabel(baseRad, radius, angleValue) {
    const labelRad = Math.PI + baseRad;
    const labelCoord = (0, $2UGuq.default)(labelRad, radius);
    const label = new $iuB9z.Text();
    label.text = angleValue;
    label.style.fontSize = 19;
    label.anchor.set(.5);
    label.rotation = baseRad - Math.PI / 2;
    Object.assign(label, labelCoord);
    return label;
}


class $d237b238e46c9b66$export$2e2bcd8739ae039 extends $iuB9z.Container {
    Layers = (0, $9ec1t.default).getInstance();
    bg = this.addChild(new $iuB9z.Graphics());
    rotateLButton = this.addChild(new $iuB9z.Graphics());
    rotateRButton = this.addChild(new $iuB9z.Graphics());
    markAngleLButton = this.addChild(new $iuB9z.Graphics);
    markAngleRButton = this.addChild(new $iuB9z.Graphics);
    graduations = this.addChild(new $iuB9z.Graphics());
    Angles;
    constructor(){
        super();
        this.x = 500;
        this.y = 600;
        this.addToLayer();
        this.draw();
    }
    addToLayer = ()=>this.Layers.UITop.addChild(this);
    deactiveEventMode = ()=>[
            this.graduations,
            ...this.Angles
        ].forEach((elm)=>elm.eventMode = 'none');
    draw() {
        (0, $1375e54837642d5c$export$2e2bcd8739ae039).drawBackground(this.bg);
        (0, $1375e54837642d5c$export$2e2bcd8739ae039).drawGraduations(this.graduations);
        (0, $1375e54837642d5c$export$2e2bcd8739ae039).drawRotateButtons(this.rotateLButton, this.rotateRButton);
        this.Angles = (0, $1375e54837642d5c$export$2e2bcd8739ae039).drawAngleLabels(this);
        this.drawMarkAngleBtn(this.markAngleRButton, 0, 0x00ff00);
        this.drawMarkAngleBtn(this.markAngleLButton, Math.PI, "yellow");
        this.deactiveEventMode();
    }
    drawMarkAngleBtn(btn, rot, c) {
        (0, $1375e54837642d5c$export$2e2bcd8739ae039).drawMarkAngleButton(btn, rot, c);
    }
}



var $16Wgx = parcelRequire("16Wgx");

var $2h5MD = parcelRequire("2h5MD");

var $darcK = parcelRequire("darcK");

var $16HUD = parcelRequire("16HUD");
class $2d9b984ab4721f9a$export$2e2bcd8739ae039 {
    ProtractorRenderer = new (0, $d237b238e46c9b66$export$2e2bcd8739ae039)();
    isGrabbing = false;
    isRotating = false;
    isRotatingLeft = false;
    isMarkingAngle = false;
    isMarkingLeft = false;
    mStartCoord;
    grabDelta;
    mStartDeltaRad;
    constructor(){
        this.addInteractivities();
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).setPointerMove, (coord)=>this.handlePointerMove(coord));
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).setPointerUp, ()=>this.handlePointerUp());
    }
    setVisible = (v)=>this.ProtractorRenderer.visible = v;
    addInteractivities() {
        (0, $16Wgx.default)(this.ProtractorRenderer.bg, {
            handleDownFunc: (e)=>this.handleDownGrabButton(e)
        }, (0, $16HUD.CustomCursorType).grab);
        (0, $16Wgx.default)(this.ProtractorRenderer.rotateLButton, {
            handleDownFunc: (e)=>this.handleDownRotateButton(e, true)
        }, (0, $16HUD.CustomCursorType).rotate);
        (0, $16Wgx.default)(this.ProtractorRenderer.rotateRButton, {
            handleDownFunc: (e)=>this.handleDownRotateButton(e, false)
        }, (0, $16HUD.CustomCursorType).rotate);
        (0, $16Wgx.default)(this.ProtractorRenderer.markAngleLButton, {
            handleDownFunc: (_)=>this.handleDownMarkAngleButton(true)
        }, (0, $16HUD.CustomCursorType).grab);
        (0, $16Wgx.default)(this.ProtractorRenderer.markAngleRButton, {
            handleDownFunc: (_)=>this.handleDownMarkAngleButton(false)
        }, (0, $16HUD.CustomCursorType).grab);
    }
    handlePointerMove(coord) {
        const center = {
            x: this.ProtractorRenderer.x,
            y: this.ProtractorRenderer.y
        };
        if (this.isGrabbing) {
            this.ProtractorRenderer.x = coord.x + this.grabDelta.x;
            this.ProtractorRenderer.y = coord.y + this.grabDelta.y;
        } else if (this.isRotating) {
            const rad = (0, $2h5MD.default)(center, coord) + this.mStartDeltaRad;
            this.ProtractorRenderer.rotation = this.isRotatingLeft ? -Math.PI + rad : rad;
        } else if (this.isMarkingAngle) {
            const one = Math.PI / 180;
            const marker = this.isMarkingLeft ? this.ProtractorRenderer.markAngleLButton : this.ProtractorRenderer.markAngleRButton;
            const pRot = (0, $darcK.normalizeRadian)(this.ProtractorRenderer.rotation);
            const rot = (0, $darcK.normalizeRadian)(Math.floor((0, $2h5MD.default)(center, coord) / one) * one);
            const max = (0, $darcK.normalizeRadian)(pRot);
            const min = (0, $darcK.normalizeRadian)(-(Math.PI + one) + pRot);
            if (rot <= max && rot >= min) this.ProtractorRenderer.drawMarkAngleBtn(marker, rot - pRot, this.isMarkingLeft ? "yellow" : 0x00ff00);
        }
    }
    handlePointerUp() {
        this.isGrabbing = false;
        this.isRotating = false;
        this.isMarkingAngle = false;
        this.handleEventMode(true);
    }
    handleDownGrabButton(e) {
        this.isGrabbing = true;
        this.mStartCoord = {
            x: e.global.x,
            y: e.global.y
        };
        this.grabDelta = {
            x: this.ProtractorRenderer.x - this.mStartCoord.x,
            y: this.ProtractorRenderer.y - this.mStartCoord.y
        };
        this.handleEventMode(false);
    }
    handleDownRotateButton(e, isLeft) {
        const center = {
            x: this.ProtractorRenderer.x,
            y: this.ProtractorRenderer.y
        };
        this.isRotating = true;
        this.isRotatingLeft = isLeft;
        this.mStartCoord = {
            x: e.global.x,
            y: e.global.y
        };
        const _rad = (0, $2h5MD.default)(center, this.mStartCoord);
        this.mStartDeltaRad = this.ProtractorRenderer.rotation - (isLeft ? Math.PI + _rad : _rad);
        this.handleEventMode(false);
    }
    handleDownMarkAngleButton(isLeft) {
        this.isMarkingAngle = true;
        this.isMarkingLeft = isLeft;
    }
    handleEventMode(v) {
        [
            this.ProtractorRenderer.bg,
            this.ProtractorRenderer.rotateLButton,
            this.ProtractorRenderer.rotateRButton
        ].forEach((elm)=>elm.eventMode = v ? 'static' : 'none');
    }
}



var $erVR3 = parcelRequire("erVR3");

var $iuB9z = parcelRequire("iuB9z");

var $9ec1t = parcelRequire("9ec1t");

var $2UGuq = parcelRequire("2UGuq");
function $375c4344ce19e0d7$export$2e2bcd8739ae039(currRad, lastRad) {
    let isClockwise;
    if (currRad - lastRad > Math.PI * 1.95) isClockwise = true;
    else if (currRad - lastRad < -Math.PI * 1.95) isClockwise = false;
    else isClockwise = currRad < lastRad;
    return isClockwise;
}


class $d68e91f4a08f0293$export$2e2bcd8739ae039 extends $iuB9z.Graphics {
    Layers = (0, $9ec1t.default).getInstance();
    color = 0x000000;
    lWidth = 3;
    center;
    autoRemove = true;
    hasCenterPoint = false;
    constructor(Props){
        super();
        Object.assign(this, Props);
        this.addToLayer();
    }
    addToLayer = ()=>this.Layers.Middle.addChild(this);
    setDetails = (details)=>Object.assign(this, details);
    draw(center, radius, startRad, currRad) {
        const isClockwise = (0, $375c4344ce19e0d7$export$2e2bcd8739ae039)(currRad, startRad);
        const startCoord = (0, $2UGuq.default)(startRad, radius);
        this.autoRemove && this.clear();
        this.center !== center && this.hasCenterPoint && this.circle(center.x, center.y, 5).fill(this.color);
        this.moveTo(center.x + startCoord.x, center.y + startCoord.y).arc(center.x, center.y, radius, startRad, currRad, isClockwise).stroke({
            width: this.lWidth,
            color: this.color
        });
        this.center = center;
    }
}



var $iuB9z = parcelRequire("iuB9z");

var $9ec1t = parcelRequire("9ec1t");
function $6bbc95881fca7ea5$export$2e2bcd8739ae039(offsetX, offsetY, rad) {
    return {
        x: offsetX * Math.cos(rad) - offsetY * Math.sin(rad),
        y: offsetX * Math.sin(rad) + offsetY * Math.cos(rad)
    };
}



var $2h5MD = parcelRequire("2h5MD");

var $ijoTh = parcelRequire("ijoTh");

var $eP48i = parcelRequire("eP48i");
const $cea83fa517fdafe2$var$BLUE = 0x0195b8;
const $cea83fa517fdafe2$var$DARK_BLUE = 0x015f78;
class $cea83fa517fdafe2$export$2e2bcd8739ae039 {
    static drawKnob(knob, knobCoord, startCoord, endCoord) {
        const rotRadian = (0, $2h5MD.default)(startCoord, endCoord);
        knob.x = knobCoord.x;
        knob.y = knobCoord.y;
        knob.clear().moveTo(-8, -80).rect(-8, -80, 14, 40).roundRect(-20, -40, 40, 76, 14).fill($cea83fa517fdafe2$var$DARK_BLUE).circle(0, 0, 8).fill(0xDDDDDD);
        knob.rotation = rotRadian;
        return knobCoord;
    }
    static drawNeedleLeg(needleLeg, startCoord, knobCoord, TOTAL_H) {
        const w = 18;
        const h = TOTAL_H - 22;
        const rotRadian = (0, $2h5MD.default)(startCoord, knobCoord) + Math.PI / 2;
        const nLP1 = (0, $6bbc95881fca7ea5$export$2e2bcd8739ae039)(-w / 2, -21, rotRadian);
        const nLP2 = (0, $6bbc95881fca7ea5$export$2e2bcd8739ae039)(w / 2, -21, rotRadian);
        const nLP3 = (0, $6bbc95881fca7ea5$export$2e2bcd8739ae039)(w / 2, -h - 23, rotRadian);
        const nLP4 = (0, $6bbc95881fca7ea5$export$2e2bcd8739ae039)(-w / 2, -h - 23, rotRadian);
        needleLeg.clear().moveTo(startCoord.x + nLP1.x, startCoord.y + nLP1.y).lineTo(startCoord.x + nLP2.x, startCoord.y + nLP2.y).lineTo(startCoord.x + nLP3.x, startCoord.y + nLP3.y).lineTo(startCoord.x + nLP4.x, startCoord.y + nLP4.y).lineTo(startCoord.x + nLP1.x, startCoord.y + nLP1.y).stroke({
            color: 0x000000,
            width: 2
        }).fill($cea83fa517fdafe2$var$BLUE);
        const lP1 = (0, $6bbc95881fca7ea5$export$2e2bcd8739ae039)(0, -35, rotRadian);
        const lP2 = (0, $6bbc95881fca7ea5$export$2e2bcd8739ae039)(0, -h - 10, rotRadian);
        needleLeg.moveTo(startCoord.x + lP1.x, startCoord.y + lP1.y).lineTo(startCoord.x + lP2.x, startCoord.y + lP2.y).stroke({
            color: 0x282828,
            alpha: .5,
            width: 1
        });
        const pP1 = (0, $6bbc95881fca7ea5$export$2e2bcd8739ae039)(-4, -23, rotRadian);
        const pP2 = (0, $6bbc95881fca7ea5$export$2e2bcd8739ae039)(4, -23, rotRadian);
        const pP3 = (0, $6bbc95881fca7ea5$export$2e2bcd8739ae039)(0, 0, rotRadian);
        needleLeg.moveTo(startCoord.x + pP1.x, startCoord.y + pP1.y).lineTo(startCoord.x + pP2.x, startCoord.y + pP2.y).lineTo(startCoord.x + pP3.x, startCoord.y + pP3.y).lineTo(startCoord.x + pP1.x, startCoord.y + pP1.y).stroke({
            color: 0x000000,
            width: 1
        }).fill(0xe0e0e0);
    }
    static drawPencilLeg(pencilLeg, knobCoord, endCoord, TOTAL_H) {
        const w = 18;
        const h = TOTAL_H - 122;
        const thickness = 28;
        const rotRadian = (0, $2h5MD.default)(knobCoord, endCoord) - Math.PI / 2;
        const nLP1 = (0, $6bbc95881fca7ea5$export$2e2bcd8739ae039)(-w / 2, 0, rotRadian);
        const nLP2 = (0, $6bbc95881fca7ea5$export$2e2bcd8739ae039)(w / 2, 0, rotRadian);
        const nLP3 = (0, $6bbc95881fca7ea5$export$2e2bcd8739ae039)(w / 2, h - 20, rotRadian);
        const nLP4 = (0, $6bbc95881fca7ea5$export$2e2bcd8739ae039)(w / 2 + 60, h - thickness + 13, rotRadian);
        const nLP5 = (0, $6bbc95881fca7ea5$export$2e2bcd8739ae039)(w / 2 + 55, h + 13, rotRadian);
        const nLP6 = (0, $6bbc95881fca7ea5$export$2e2bcd8739ae039)(-w / 2, h, rotRadian);
        pencilLeg.clear().moveTo(knobCoord.x + nLP1.x, knobCoord.y + nLP1.y).lineTo(knobCoord.x + nLP2.x, knobCoord.y + nLP2.y).lineTo(knobCoord.x + nLP3.x, knobCoord.y + nLP3.y).lineTo(knobCoord.x + nLP4.x, knobCoord.y + nLP4.y).lineTo(knobCoord.x + nLP5.x, knobCoord.y + nLP5.y).lineTo(knobCoord.x + nLP6.x, knobCoord.y + nLP6.y).lineTo(knobCoord.x + nLP1.x, knobCoord.y + nLP1.y).stroke({
            color: 0x000000,
            width: 2
        }).fill($cea83fa517fdafe2$var$BLUE);
        const lP = (0, $6bbc95881fca7ea5$export$2e2bcd8739ae039)(0, h - 10, rotRadian);
        pencilLeg.moveTo(knobCoord.x, knobCoord.y).lineTo(knobCoord.x + lP.x, knobCoord.y + lP.y).stroke({
            color: 0x282828,
            alpha: .5,
            width: 1
        });
        const rP1 = (0, $6bbc95881fca7ea5$export$2e2bcd8739ae039)(-8, 10, rotRadian);
        const rP2 = (0, $6bbc95881fca7ea5$export$2e2bcd8739ae039)(-22, 9, rotRadian);
        const rP3 = (0, $6bbc95881fca7ea5$export$2e2bcd8739ae039)(-14, -(thickness + 11), rotRadian);
        const rP4 = (0, $6bbc95881fca7ea5$export$2e2bcd8739ae039)(0, -(thickness + 10), rotRadian);
        pencilLeg.moveTo(knobCoord.x + nLP5.x + rP1.x, knobCoord.y + nLP5.y + rP1.y).lineTo(knobCoord.x + nLP5.x + rP2.x, knobCoord.y + nLP5.y + rP2.y).lineTo(knobCoord.x + nLP5.x + rP3.x, knobCoord.y + nLP5.y + rP3.y).lineTo(knobCoord.x + nLP5.x + rP4.x, knobCoord.y + nLP5.y + rP4.y).lineTo(knobCoord.x + nLP5.x + rP1.x, knobCoord.y + nLP5.y + rP1.y).fill($cea83fa517fdafe2$var$DARK_BLUE);
    }
    static drawPencil(pencil, color, knobCoord, endCoord) {
        const rotRadian = (0, $2h5MD.default)(knobCoord, endCoord) - Math.PI / 16 * 7;
        // Tip
        const pP1 = (0, $6bbc95881fca7ea5$export$2e2bcd8739ae039)(13, -39, rotRadian);
        const pP2 = (0, $6bbc95881fca7ea5$export$2e2bcd8739ae039)(-13, -39, rotRadian);
        pencil.clear().moveTo(endCoord.x, endCoord.y).lineTo(endCoord.x + pP1.x, endCoord.y + pP1.y).lineTo(endCoord.x + pP2.x, endCoord.y + pP2.y).lineTo(endCoord.x, endCoord.y).fill(0xffffff).stroke({
            width: 2.5,
            color: 0x000000
        });
        //Graphite Core
        const gP1 = (0, $6bbc95881fca7ea5$export$2e2bcd8739ae039)(3, -9, rotRadian);
        const gP2 = (0, $6bbc95881fca7ea5$export$2e2bcd8739ae039)(-3, -9, rotRadian);
        pencil.moveTo(endCoord.x, endCoord.y).lineTo(endCoord.x + gP1.x, endCoord.y + gP1.y).lineTo(endCoord.x + gP2.x, endCoord.y + gP2.y).lineTo(endCoord.x, endCoord.y).fill(color).stroke({
            width: 2.5,
            color: color
        });
        // Barrel
        const bP3 = (0, $6bbc95881fca7ea5$export$2e2bcd8739ae039)(-13, -280, rotRadian);
        const bP4 = (0, $6bbc95881fca7ea5$export$2e2bcd8739ae039)(13, -280, rotRadian);
        pencil.moveTo(endCoord.x + pP1.x, endCoord.y + pP1.y).lineTo(endCoord.x + pP2.x, endCoord.y + pP2.y).lineTo(endCoord.x + bP3.x, endCoord.y + bP3.y).lineTo(endCoord.x + bP4.x, endCoord.y + bP4.y).lineTo(endCoord.x + pP1.x, endCoord.y + pP1.y).stroke({
            width: 2.5,
            color: 0x000000
        }).fill(color);
    }
    static drawLock(lock, startCoord, knobCoord, endCoord, isActive) {
        const thickness = 13;
        const strokeColor = isActive ? 0x383838 : 0xAAAAAA;
        const fillColor = isActive ? $cea83fa517fdafe2$var$BLUE : 0xFFFFFF;
        const shakleRad = isActive ? Math.PI / 3 : Math.PI * 5 / 6;
        const rotRadian = (0, $2h5MD.default)(startCoord, endCoord);
        const centerOfNeedleLeg = (0, $ijoTh.default)(startCoord, knobCoord);
        const centerOfPencilLeg = (0, $ijoTh.default)(endCoord, knobCoord);
        const centerOfLock = (0, $ijoTh.default)(centerOfNeedleLeg, centerOfPencilLeg);
        const distanceBtwLegs = (0, $eP48i.default)(centerOfNeedleLeg, centerOfPencilLeg);
        const distanceBtwNeedleAndCenter = (0, $eP48i.default)(centerOfNeedleLeg, centerOfLock);
        Object.assign(lock, centerOfNeedleLeg);
        lock.clear()// line
        .rect(0, -thickness / 2, distanceBtwLegs, thickness).stroke({
            width: 3,
            color: strokeColor
        }).fill(fillColor)// circle
        .circle(distanceBtwNeedleAndCenter, 0, 18).stroke({
            width: 5,
            color: strokeColor
        }).fill(fillColor)// lock symbol
        .moveTo(distanceBtwNeedleAndCenter, 2).arc(distanceBtwNeedleAndCenter, -7, 6, Math.PI / 2, Math.PI / 2 - shakleRad).stroke({
            width: 4,
            color: strokeColor,
            cap: "round"
        }).moveTo(distanceBtwNeedleAndCenter - 10, -5).roundRect(distanceBtwNeedleAndCenter - 10, -5, 20, 18, 3).fill(strokeColor).circle(distanceBtwNeedleAndCenter, 3, 3.5).fill(fillColor).rotation = rotRadian;
    }
}



var $2h5MD = parcelRequire("2h5MD");

var $ijoTh = parcelRequire("ijoTh");

var $eP48i = parcelRequire("eP48i");


var $darcK = parcelRequire("darcK");
function $6d5014d66548ec3a$export$2e2bcd8739ae039(startCoord, endCoord, totalH) {
    const midCoord = (0, $ijoTh.default)(startCoord, endCoord);
    const distance = (0, $eP48i.default)(startCoord, midCoord);
    const radian = (0, $darcK.normalizeRadian)(Math.PI / 2 + (0, $2h5MD.default)(startCoord, endCoord));
    const h = Math.sqrt(Math.pow(totalH, 2) - Math.pow(distance, 2));
    const offset = (0, $6bbc95881fca7ea5$export$2e2bcd8739ae039)(-h, 0, radian);
    return {
        x: Math.floor(midCoord.x + offset.x),
        y: Math.floor(midCoord.y + offset.y)
    };
}


class $4b67d97b69402dd3$export$2e2bcd8739ae039 extends $iuB9z.Container {
    totalH;
    Layers;
    lock;
    needleLeg;
    pencil;
    pencilLeg;
    knob;
    isLockActive;
    isLockActiveTmprary;
    startCoord;
    endCoord;
    pencilColor;
    constructor(totalH){
        super(), this.totalH = totalH, this.Layers = (0, $9ec1t.default).getInstance(), this.lock = this.addChild(new $iuB9z.Graphics()), this.needleLeg = this.addChild(new $iuB9z.Graphics()), this.pencil = this.addChild(new $iuB9z.Graphics()), this.pencilLeg = this.addChild(new $iuB9z.Graphics()), this.knob = this.addChild(new $iuB9z.Graphics()), this.isLockActive = false, this.isLockActiveTmprary = false, this.startCoord = {
            x: 0,
            y: 0
        }, this.endCoord = {
            x: 0,
            y: 0
        }, this.pencilColor = 0x000000, this.addToLayer = ()=>this.Layers.UITop.addChild(this), this.clearAll = ()=>[
                this.knob,
                this.needleLeg,
                this.pencilLeg,
                this.pencil,
                this.lock
            ].forEach((e)=>e.clear()), this.setPencilColor = (color)=>this.pencilColor = color;
        this.addToLayer();
    }
    addToLayer;
    clearAll;
    setPencilColor;
    draw(startCoord, endCoord) {
        startCoord && (this.startCoord = startCoord);
        endCoord && (this.endCoord = endCoord);
        const knobCoord = (0, $6d5014d66548ec3a$export$2e2bcd8739ae039)(this.startCoord, this.endCoord, this.totalH);
        (0, $cea83fa517fdafe2$export$2e2bcd8739ae039).drawKnob(this.knob, knobCoord, this.startCoord, this.endCoord);
        (0, $cea83fa517fdafe2$export$2e2bcd8739ae039).drawNeedleLeg(this.needleLeg, this.startCoord, knobCoord, this.totalH);
        (0, $cea83fa517fdafe2$export$2e2bcd8739ae039).drawPencilLeg(this.pencilLeg, knobCoord, this.endCoord, this.totalH);
        (0, $cea83fa517fdafe2$export$2e2bcd8739ae039).drawPencil(this.pencil, this.pencilColor, knobCoord, this.endCoord);
        (0, $cea83fa517fdafe2$export$2e2bcd8739ae039).drawLock(this.lock, this.startCoord, knobCoord, this.endCoord, this.isLockActiveTmprary || this.isLockActive);
    }
}



var $16Wgx = parcelRequire("16Wgx");

var $2h5MD = parcelRequire("2h5MD");

var $eP48i = parcelRequire("eP48i");
function $b4b3588b0f8c275a$export$2e2bcd8739ae039(startCoord, newEndCoord, totalH) {
    const max = 1.7 * totalH;
    const min = 108;
    const distance = (0, $eP48i.default)(startCoord, newEndCoord);
    if (distance > max) return $b4b3588b0f8c275a$var$getFollowerCoord(startCoord, newEndCoord, max);
    else if (distance < min) return $b4b3588b0f8c275a$var$getFollowerCoord(startCoord, newEndCoord, min);
    return newEndCoord;
}
function $b4b3588b0f8c275a$var$getFollowerCoord(startCoord, newEndCoord, distance) {
    const rad = (0, $2h5MD.default)(startCoord, newEndCoord);
    const eCoord = {
        x: Math.floor(startCoord.x + Math.cos(rad) * distance),
        y: Math.floor(startCoord.y + Math.sin(rad) * distance)
    };
    return eCoord;
}


const $0f87ba35c4bc009f$var$INITIAL_START_COORD = {
    x: 400,
    y: 600
};
const $0f87ba35c4bc009f$var$INITIAL_END_COORD = {
    x: 700,
    y: 600
};
const $0f87ba35c4bc009f$var$INITIAL_RADIAN = Math.PI / 3.5;
class $0f87ba35c4bc009f$export$2e2bcd8739ae039 {
    static handlePointerMove(This, coord) {
        if (!This.pStartCoord) return;
        const deltaX = coord.x - This.pStartCoord.x;
        const deltaY = coord.y - This.pStartCoord.y;
        if (This.isKnobPressed) This.handleKnobPointerMove(coord);
        else if (This.isNeedleLegPressed) This.handleNeedleLegPointerMove(deltaX, deltaY);
        else if (This.isPencilLegPressed) This.handlePencilLegPointerMove(coord, deltaX, deltaY);
    }
    static handlePointerUp(This) {
        This.initialStartCoord = {
            ...This.startCoord
        };
        This.initialEndCoord = {
            ...This.endCoord
        };
        This.isKnobPressed = false;
        This.isNeedleLegPressed = false;
        This.isPencilLegPressed = false;
        This.handleLockActTmprary(false);
        This.handleEventMode(true);
    //This.onUpHandle();
    }
    static resetValues(This) {
        This.initialStartCoord = $0f87ba35c4bc009f$var$INITIAL_START_COORD;
        This.startCoord = $0f87ba35c4bc009f$var$INITIAL_START_COORD;
        This.initialEndCoord = $0f87ba35c4bc009f$var$INITIAL_END_COORD;
        This.endCoord = $0f87ba35c4bc009f$var$INITIAL_END_COORD;
        This.radian = $0f87ba35c4bc009f$var$INITIAL_RADIAN;
    }
}



var $2h5MD = parcelRequire("2h5MD");

var $eP48i = parcelRequire("eP48i");

var $kPclf = parcelRequire("kPclf");

var $16HUD = parcelRequire("16HUD");
const $8e4a78b49346eafc$var$TOTAL_H = 360;
class $8e4a78b49346eafc$export$2e2bcd8739ae039 {
    getDrawing;
    CompassRenderer;
    initialStartCoord;
    initialEndCoord;
    startCoord;
    endCoord;
    radian;
    isKnobPressed;
    isNeedleLegPressed;
    isPencilLegPressed;
    pStartCoord;
    drawing;
    startRad;
    arcColor;
    constructor(getDrawing){
        this.getDrawing = getDrawing;
        this.CompassRenderer = new (0, $4b67d97b69402dd3$export$2e2bcd8739ae039)($8e4a78b49346eafc$var$TOTAL_H);
        this.isKnobPressed = false;
        this.isNeedleLegPressed = false;
        this.isPencilLegPressed = false;
        this.arcColor = 0x000000;
        this.setColor = (color)=>{
            this.arcColor = color;
            this.CompassRenderer.setPencilColor(color);
            this.CompassRenderer.draw();
        };
        this.handlePointerUp = ()=>(0, $0f87ba35c4bc009f$export$2e2bcd8739ae039).handlePointerUp(this);
        this.resetValues = ()=>(0, $0f87ba35c4bc009f$export$2e2bcd8739ae039).resetValues(this);
        this.resetValues();
        this.addInteractivities();
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).setPointerMove, (coord)=>this.handlePointerMove(coord));
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).setPointerUp, ()=>this.handlePointerUp());
    }
    setColor;
    handlePointerUp;
    resetValues;
    initializeDrawing() {
        this.drawing = new (0, $d68e91f4a08f0293$export$2e2bcd8739ae039)({
            color: this.arcColor,
            lWidth: 3,
            autoRemove: false,
            hasCenterPoint: true
        });
        this.getDrawing(this.drawing);
    }
    addInteractivities() {
        const getHandleDownFunc = (e, onHandle)=>{
            this.pStartCoord = (0, $kPclf.default)({
                x: e.global.x,
                y: e.global.y
            });
            this.handleEventMode(false);
            onHandle();
        };
        const handleDownNeedleFunc = (e)=>getHandleDownFunc(e, ()=>this.isNeedleLegPressed = true);
        const handleDownPencilLegFunc = (e)=>getHandleDownFunc(e, ()=>{
                this.isPencilLegPressed = true;
                this.CompassRenderer.isLockActive && this.initializeDrawing();
            });
        const handleDownKnobFunc = (e)=>getHandleDownFunc(e, ()=>{
                this.isKnobPressed = true;
                this.initializeDrawing();
                this.handleLockActTmprary(true);
            });
        const handleDownLockFunc = (e)=>getHandleDownFunc(e, ()=>{
                this.CompassRenderer.isLockActive = !this.CompassRenderer.isLockActive;
                this.CompassRenderer.draw(this.startCoord, this.endCoord);
                this.handleEventMode(true);
            });
        (0, $16Wgx.default)(this.CompassRenderer.lock, {
            handleDownFunc: handleDownLockFunc
        }, (0, $16HUD.CustomCursorType).pointer);
        (0, $16Wgx.default)(this.CompassRenderer.knob, {
            handleDownFunc: handleDownKnobFunc
        }, (0, $16HUD.CustomCursorType).grab);
        (0, $16Wgx.default)(this.CompassRenderer.needleLeg, {
            handleDownFunc: handleDownNeedleFunc
        }, (0, $16HUD.CustomCursorType).grab);
        (0, $16Wgx.default)(this.CompassRenderer.pencilLeg, {
            handleDownFunc: handleDownPencilLegFunc
        }, (0, $16HUD.CustomCursorType).grab);
        (0, $16Wgx.default)(this.CompassRenderer.pencil, {
            handleDownFunc: handleDownPencilLegFunc
        }, (0, $16HUD.CustomCursorType).grab);
    }
    handleLockActTmprary(v) {
        this.CompassRenderer.isLockActiveTmprary = v;
        this.CompassRenderer.draw(this.startCoord, this.endCoord);
    }
    handlePointerMove(coord) {
        (0, $0f87ba35c4bc009f$export$2e2bcd8739ae039).handlePointerMove(this, coord);
        this.CompassRenderer.draw(this.startCoord, this.endCoord);
    }
    setVisible(v) {
        this.CompassRenderer.visible = v;
        this.resetValues();
        v ? this.CompassRenderer.draw(this.startCoord, this.endCoord) : this.CompassRenderer.clearAll();
    }
    handleKnobPointerMove(coord) {
        const startRad = (0, $2h5MD.default)(this.initialStartCoord, this.pStartCoord);
        const radStartAndEnd = (0, $2h5MD.default)(this.initialStartCoord, this.initialEndCoord);
        const rad = (0, $2h5MD.default)(this.initialStartCoord, coord);
        const deltaRad = Number((rad - startRad + radStartAndEnd).toFixed(4));
        const d = (0, $eP48i.default)(this.initialStartCoord, this.initialEndCoord);
        this.endCoord = {
            x: Math.floor(this.startCoord.x + Math.cos(deltaRad) * d),
            y: Math.floor(this.startCoord.y + Math.sin(deltaRad) * d)
        };
        const sRad = (0, $2h5MD.default)(this.initialStartCoord, this.initialEndCoord);
        const currRad = (0, $2h5MD.default)(this.initialStartCoord, this.endCoord);
        !this.startRad && (this.startRad = sRad);
        this.drawing.draw(this.startCoord, d, this.startRad, currRad);
        this.startRad = currRad;
    }
    handleNeedleLegPointerMove(deltaX, deltaY) {
        this.startCoord = {
            x: Math.max(this.initialStartCoord.x + deltaX, 0),
            y: Math.max(this.initialStartCoord.y + deltaY, 0)
        };
        this.endCoord = {
            x: Math.max(this.initialEndCoord.x + deltaX, 0),
            y: Math.max(this.initialEndCoord.y + deltaY, 0)
        };
    }
    handlePencilLegPointerMove(coord, deltaX, deltaY) {
        if (this.CompassRenderer.isLockActive) return this.handleKnobPointerMove(coord);
        const newEndCoord = {
            x: Math.max(this.initialEndCoord.x + deltaX, 0),
            y: Math.max(this.initialEndCoord.y + deltaY, 0)
        };
        this.endCoord = (0, $b4b3588b0f8c275a$export$2e2bcd8739ae039)(this.startCoord, newEndCoord, $8e4a78b49346eafc$var$TOTAL_H);
        this.startRad = (0, $2h5MD.default)(this.startCoord, this.endCoord);
    }
    handleEventMode(v) {
        [
            this.CompassRenderer.knob,
            this.CompassRenderer.needleLeg,
            this.CompassRenderer.pencilLeg,
            this.CompassRenderer.pencil,
            this.CompassRenderer.lock
        ].forEach((elm)=>elm.eventMode = v ? 'static' : 'none');
    }
}



var $iuB9z = parcelRequire("iuB9z");
var $3a1e36f612556c4f$export$37042196a764db52 = /*#__PURE__*/ function(EnumColorOptEventBus) {
    EnumColorOptEventBus["selectedColor"] = "SELECTED_COLOR";
    return EnumColorOptEventBus;
}({});
const $3a1e36f612556c4f$export$b4e79357afe2d23 = new (0, $iuB9z.EventEmitter)();



var $8Db5v = parcelRequire("8Db5v");
class $ec8565cdab3711ad$export$2e2bcd8739ae039 extends (0, $3562a92658e51e13$export$2e2bcd8739ae039) {
    GridConfig;
    DrawingRenderer;
    TestQuestionManager;
    selectedTool;
    isStarted;
    coordStart;
    coordEnd;
    isAnswer;
    answer;
    Ruler;
    protractor;
    Compass;
    constructor(GridConfig){
        super(), this.GridConfig = GridConfig, this.DrawingRenderer = new (0, $25d5e93b80a9fa04$export$2e2bcd8739ae039)(), this.TestQuestionManager = (0, $905a2b833cc89373$export$2e2bcd8739ae039).getInstance(), this.selectedTool = (0, $f443dc34377ca450$export$ec63e05e2ee9f6fc).empty, this.isStarted = false, this.coordStart = {
            x: 0,
            y: 0
        }, this.coordEnd = {
            x: 0,
            y: 0
        }, this.isAnswer = false, this.answer = [], this.Ruler = new (0, $056aaa6d1208f6db$export$2e2bcd8739ae039)((line)=>this.DrawingRenderer.addExtraDrawing(line)), this.protractor = new (0, $2d9b984ab4721f9a$export$2e2bcd8739ae039)(), this.Compass = new (0, $8e4a78b49346eafc$export$2e2bcd8739ae039)((arc)=>{
            this.DrawingRenderer.addExtraDrawing(arc);
        }), this.isEmpty = ()=>this.selectedTool === (0, $f443dc34377ca450$export$ec63e05e2ee9f6fc).empty, this.isPointTool = ()=>this.selectedTool.includes("POINT"), this.isLineTool = ()=>this.selectedTool.includes("LINE"), this.isPencilTool = ()=>this.selectedTool.includes("PENCIL"), this.onPointerUp = ()=>{
            if (!this.isStarted) return;
            this.addAnswer();
            this.isStarted = false;
        };
        this.Ruler.setVisible(false);
        this.protractor.setVisible(false);
        this.Compass.setVisible(false);
        (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).on((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).clearAll, ()=>this.deleteAllElms());
        (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).on((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).delLastDrawing, ()=>this.deletelastElm());
        (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).on((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).setQuestMode, ()=>this.DrawingRenderer.clearAll());
        (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).on((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).startAnswer, (v)=>this.startAnswer(v));
        (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).on((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).saveAnswer, ()=>this.saveAnswer());
        (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).on((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).showTestQuestion, (i)=>this.drawAnswer(i));
        (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).on((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).showRuler, (v)=>this.Ruler.setVisible(v));
        (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).on((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).showProtractor, (v)=>this.protractor.setVisible(v));
        (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).on((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).showCompass, (v)=>this.Compass.setVisible(v));
        (0, $3a1e36f612556c4f$export$b4e79357afe2d23).on((0, $3a1e36f612556c4f$export$37042196a764db52).selectedColor, (color)=>this.setSelectedColor(color));
    }
    isEmpty;
    isPointTool;
    isLineTool;
    isPencilTool;
    setSelectedColor(color) {
        this.DrawingRenderer.setDrawingColor(color);
        (0, $8Db5v.cursorEventBus).emit((0, $8Db5v.EnumCursorEventBus).setColor, color);
        this.Compass.setColor(color);
        this.Ruler.setColor(color);
    }
    startAnswer(v) {
        this.isAnswer = v;
        this.coordStart = this.coordEnd = {
            x: 0,
            y: 0
        };
    }
    saveAnswer() {
        this.TestQuestionManager.addAnswer(this.answer);
        this.answer = [];
        this.isAnswer = false;
        this.DrawingRenderer.clearDrawing();
    }
    setSelectedTool(tool, color) {
        this.selectedTool = tool;
        this.DrawingRenderer.setSelectedTool(this.selectedTool);
        const isPencil = this.isPencilTool();
        if (this.isLineTool() || isPencil || this.isPointTool()) {
            const bg = this.DrawingRenderer.drawBg();
            (0, $2669fed17c218541$export$2e2bcd8739ae039).addBgInteractivity(bg, (coord)=>this.onPointerDown(coord), isPencil);
        } else if (this.isEmpty) this.DrawingRenderer.clearBg();
    }
    onPointerDown(coord) {
        if (this.isEmpty()) ;
        else if (this.isPointTool()) {
            this.DrawingRenderer.addPoint((0, $d779936abd442c13$export$2e2bcd8739ae039)(this.GridConfig, this.GridConfig.cellSize, coord));
            if (this.isAnswer) {
                const drawing = this.DrawingRenderer.getDrawing();
                const ans = {
                    coord: [
                        {
                            x: drawing.graph.x,
                            y: drawing.graph.y
                        }
                    ],
                    id: drawing.id
                };
                this.answer.push(ans);
            }
        } else {
            this.isStarted = true;
            this.coordStart = this.coordEnd = coord;
            if (this.isPencilTool()) this.DrawingRenderer.initializePencilLine();
            else {
                this.coordStart = (0, $d779936abd442c13$export$2e2bcd8739ae039)(this.GridConfig, this.GridConfig.cellSize, coord);
                this.DrawingRenderer.initializeLine();
            }
        }
    }
    onPointerMove(coord) {
        if (!this.isStarted || !this.DrawingRenderer.getDrawing()) return;
        if (this.isLineTool()) {
            this.coordEnd = (0, $d779936abd442c13$export$2e2bcd8739ae039)(this.GridConfig, this.GridConfig.cellSize, coord);
            this.DrawingRenderer.drawLine(this.coordStart, this.coordEnd);
        } else if (this.isPencilTool()) {
            this.coordEnd = coord;
            this.DrawingRenderer.drawLine(this.coordStart, this.coordEnd);
            this.coordStart = coord;
        }
    }
    onPointerUp;
    addAnswer() {
        if (this.coordStart.x === this.coordEnd.x && this.coordStart.y === this.coordEnd.y) return;
        const drawing = this.DrawingRenderer.getDrawing();
        if (drawing && drawing.graph instanceof (0, $d0yDD.default) && this.isAnswer) this.answer.push({
            coord: [
                this.coordStart,
                this.coordEnd
            ],
            id: drawing.id
        });
    }
    deletelastElm() {
        const id = this.DrawingRenderer.delLastDrawing();
        id && (this.answer = this.answer.filter((a)=>a.id !== id));
    }
    deleteAllElms() {
        this.DrawingRenderer.clearAll();
        this.answer = [];
    }
    drawAnswer(index) {
        this.DrawingRenderer.clearAll();
        const answer = this.TestQuestionManager.getAnswer(index);
        if (answer.type === (0, $f443dc34377ca450$export$51940fbbacba35d4).TYPE1) {
            this.DrawingRenderer.setSelectedTool((0, $f443dc34377ca450$export$ec63e05e2ee9f6fc).answerLine);
            answer.answer.forEach((a)=>{
                this.DrawingRenderer.initializeLine();
                this.DrawingRenderer.drawLine(a.coord[0], a.coord[1]);
            });
            return;
        }
        this.DrawingRenderer.setSelectedTool((0, $f443dc34377ca450$export$ec63e05e2ee9f6fc).answerPoint);
        answer.answer.forEach((a)=>this.DrawingRenderer.addPoint(a.coord[0]));
    }
}



var $iuB9z = parcelRequire("iuB9z");

var $9ec1t = parcelRequire("9ec1t");



var $9ec1t = parcelRequire("9ec1t");


var $aPdzS = parcelRequire("aPdzS");

class $171a828006f6bac5$export$2e2bcd8739ae039 extends (0, $aPdzS.default) {
    constructor(color = (0, $f443dc34377ca450$export$9fc4ff6699ea78e4).black){
        super({
            x: -1,
            y: -1
        }, color, 15, false);
    }
    drawPoint(pointCoord, origin, qType) {
        this.clear();
        if (origin && origin.x == this.x && origin.y == this.y) return;
        this.draw(pointCoord);
    }
}



var $iuB9z = parcelRequire("iuB9z");

class $c7fa2b98fafa4828$export$2e2bcd8739ae039 extends $iuB9z.Container {
    shape = this.addChild(new $iuB9z.Graphics());
    shapeLabel;
    color;
    constructor(text, color){
        super();
        this.color = color;
        this.addLabel(text);
    }
    setShapeLabelRot = (rot)=>this.shapeLabel.rotation = rot;
    drawLabel = (coord)=>Object.assign(this.shapeLabel, coord);
    addLabel(text) {
        this.shapeLabel = this.addChild(new $iuB9z.Text({
            text: text
        }));
        this.shapeLabel.anchor.set(.5);
        this.shapeLabel.style = {
            fontSize: 30,
            fontWeight: "600",
            fill: this.color
        };
        this.clearLabel();
    }
    draw(shapeCoords, centerCoord, qType) {
        this.drawShape(shapeCoords);
        qType == (0, $f443dc34377ca450$export$51940fbbacba35d4).TYPE2 ? this.drawLabel(centerCoord) : this.clearLabel();
    }
    drawShape(shapeCoords) {
        this.shape.clear();
        shapeCoords.forEach((c, cI)=>{
            if (cI == 0) return this.shape.moveTo(c.x, c.y);
            this.shape.lineTo(c.x, c.y);
            if (cI == shapeCoords.length - 1) this.shape.lineTo(shapeCoords[0].x, shapeCoords[0].y).stroke({
                width: 7,
                color: this.color,
                cap: "round"
            });
        });
    }
    clearAll() {
        this.shape.clear();
        this.clearLabel();
    }
    clearLabel() {
        this.shapeLabel.x = -100;
        this.shapeLabel.y = -100;
        this.shapeLabel.rotation = 0;
    }
}



class $0aba4ac0d1762a6f$export$2e2bcd8739ae039 {
    Layers = (0, $9ec1t.default).getInstance();
    shape = this.Layers.Top.addChild(new (0, $c7fa2b98fafa4828$export$2e2bcd8739ae039)("A", (0, $f443dc34377ca450$export$9fc4ff6699ea78e4).black));
    rotatedShape = this.Layers.Top.addChild(new (0, $c7fa2b98fafa4828$export$2e2bcd8739ae039)("B", (0, $f443dc34377ca450$export$9fc4ff6699ea78e4).red));
    pivotPoint = this.Layers.Top.addChild(new (0, $171a828006f6bac5$export$2e2bcd8739ae039)());
    rotatedShapeCoords;
    rotatedCenterCoord;
    qType;
    pivotCoord;
    rotation;
    origin;
    constructor(){
        (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).on((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).setShowSolution, (v)=>this.handleSolution(v));
    }
    handleSolution(v) {
        if (!v) return this.qType == (0, $f443dc34377ca450$export$51940fbbacba35d4).TYPE1 ? this.rotatedShape.clearAll() : this.pivotPoint.clear();
        if (this.qType == (0, $f443dc34377ca450$export$51940fbbacba35d4).TYPE1) {
            this.rotatedShape.setShapeLabelRot(this.rotation);
            return this.rotatedShape.draw(this.rotatedShapeCoords, this.rotatedCenterCoord, this.qType);
        }
        this.drawPoint((0, $f443dc34377ca450$export$9fc4ff6699ea78e4).red);
    }
    draw({ shapeCoords: shapeCoords, rotatedShapeCoords: rotatedShapeCoords, centerCoord: centerCoord, rotatedCenterCoord: rotatedCenterCoord, pivotCoord: pivotCoord, rotation: rotation, qType: qType, origin: origin }) {
        this.rotatedShapeCoords = rotatedShapeCoords;
        this.rotatedCenterCoord = rotatedCenterCoord;
        this.pivotCoord = pivotCoord;
        this.rotation = rotation;
        this.qType = qType;
        this.origin = origin;
        this.clearAll();
        this.rotatedShape.parent.removeChild(this.rotatedShape);
        this.pivotPoint.parent.removeChild(this.pivotPoint);
        if (qType === (0, $f443dc34377ca450$export$51940fbbacba35d4).TYPE1) {
            this.Layers.UI.addChild(this.rotatedShape);
            this.Layers.Top.addChild(this.pivotPoint);
            this.shape.draw(shapeCoords, centerCoord, qType);
            return this.drawPoint((0, $f443dc34377ca450$export$9fc4ff6699ea78e4).black);
        }
        this.Layers.Top.addChild(this.rotatedShape);
        this.Layers.UI.addChild(this.pivotPoint);
        this.shape.draw(shapeCoords, centerCoord, qType);
        this.rotatedShape.setShapeLabelRot(this.rotation);
        this.rotatedShape.draw(rotatedShapeCoords, rotatedCenterCoord, qType);
    }
    clearAll() {
        this.shape.clearAll();
        this.rotatedShape.clearAll();
        this.pivotPoint.clear();
    }
    drawPoint(color) {
        this.pivotPoint.setColor(color);
        this.pivotPoint.drawPoint(this.pivotCoord, this.origin, this.qType);
    }
}



var $9ec1t = parcelRequire("9ec1t");


var $d0yDD = parcelRequire("d0yDD");

var $g4gW0 = parcelRequire("g4gW0");


var $61Efw = parcelRequire("61Efw");

var $eP48i = parcelRequire("eP48i");
function $b2aba5c1f41e3481$export$2e2bcd8739ae039(shapeCoord, pivotCoord, radian) {
    const distance = (0, $eP48i.default)(shapeCoord, pivotCoord);
    return (0, $61Efw.default)(pivotCoord, distance, radian);
}



var $61Efw = parcelRequire("61Efw");

var $2h5MD = parcelRequire("2h5MD");
function $67aedb3a86c8cf76$export$2e2bcd8739ae039(centerofLine, pivotCoord, rotation) {
    const radian = (0, $2h5MD.default)(centerofLine, pivotCoord);
    return rotation == -Math.PI || rotation == Math.PI ? pivotCoord : (0, $61Efw.default)(pivotCoord, 60, radian);
}



var $2h5MD = parcelRequire("2h5MD");

var $jZEcn = parcelRequire("jZEcn");

var $iD90R = parcelRequire("iD90R");

var $erVR3 = parcelRequire("erVR3");

var $ijoTh = parcelRequire("ijoTh");
class $09ce1aaddc60fbee$export$2e2bcd8739ae039 {
    static async drawLinesType1(gridConfig, Question, elements) {
        const { pivotPoint: pivotPoint, shapePoints: shapePoints, rotation: rotation } = Question;
        const sCoords = shapePoints.map((c)=>(0, $129b550e43e52b2b$export$2e2bcd8739ae039).getGlobalCoord(gridConfig, c));
        const pivotCoord = (0, $129b550e43e52b2b$export$2e2bcd8739ae039).getGlobalCoord(gridConfig, pivotPoint);
        for(let index = 0; index < sCoords.length; index++){
            const sCoord = sCoords[index];
            await this.drawLineType1(elements[index], sCoord, pivotCoord, rotation);
        }
        return await new Promise((res)=>res());
    }
    static async drawLineType1(elements, sCoord, pivotCoord, rotation) {
        const lines = [
            elements[0],
            elements[1]
        ];
        const angle = elements[2];
        Object.assign(angle, pivotCoord);
        lines.push(angle);
        await (0, $iD90R.drawLineAnim)(lines[0], sCoord, pivotCoord);
        await this.animateLineType1(lines[1], lines[2], sCoord, pivotCoord, rotation);
        return new Promise((res)=>res());
    }
    static async animateLineType1(line, angle, sCoord, pivotCoord, rotation) {
        const startRadian = (0, $2h5MD.default)(pivotCoord, sCoord);
        const onUpdate = (radian)=>{
            const endCoord = (0, $b2aba5c1f41e3481$export$2e2bcd8739ae039)(sCoord, pivotCoord, radian);
            const deg = (0, $jZEcn.generateAngles)({
                curr: pivotCoord,
                prev: rotation > 0 ? sCoord : endCoord,
                next: rotation > 0 ? endCoord : sCoord
            }, false).degree;
            line.draw(pivotCoord, endCoord);
            angle.draw(pivotCoord, startRadian, radian, deg, rotation > 0 ? false : true);
        };
        const onComplete = async ()=>{
            await (0, $iD90R.addCustomDelay)(450);
            angle.setVisible(false);
        };
        await (0, $iD90R.movePointAnim)(startRadian, startRadian + rotation, onUpdate, onComplete);
    }
    static async drawLinesType2(lines, indexes, pivPoint, gridConfig, { shapePoints: shapePoints, rotatedShapePoints: rotatedShapePoints, pivotPoint: pivotPoint, rotation: rotation }) {
        const sCoords = [
            ...shapePoints
        ].map((c)=>(0, $129b550e43e52b2b$export$2e2bcd8739ae039).getGlobalCoord(gridConfig, c));
        const rSCoords = [
            ...rotatedShapePoints
        ].map((c)=>(0, $129b550e43e52b2b$export$2e2bcd8739ae039).getGlobalCoord(gridConfig, c));
        const pivotCoord = (0, $129b550e43e52b2b$export$2e2bcd8739ae039).getGlobalCoord(gridConfig, pivotPoint);
        pivPoint.visible = false;
        pivPoint.draw(pivotCoord);
        for(let cI = 0; cI < indexes.length; cI++){
            const _lines = lines[cI];
            const sCoord = sCoords[indexes[cI]];
            const rSCoord = rSCoords[indexes[cI]];
            const center = (0, $ijoTh.default)(sCoord, rSCoord);
            const extendedEndCoord = (0, $67aedb3a86c8cf76$export$2e2bcd8739ae039)(center, pivotCoord, rotation);
            await (0, $iD90R.drawLineAnim)(_lines[0], sCoord, rSCoord);
            await (0, $iD90R.drawLineAnim)(_lines[1], center, extendedEndCoord);
        }
        await (0, $iD90R.drawPointsAnim)([
            pivPoint
        ]);
    }
    static async drawRotatedShape(lines, gridConfig, _rotatedShapeCoords) {
        const rotatedShapeCoords = _rotatedShapeCoords.map((c)=>(0, $129b550e43e52b2b$export$2e2bcd8739ae039).getGlobalCoord(gridConfig, c));
        for(let cI = 0; cI < rotatedShapeCoords.length; cI++){
            const coord = rotatedShapeCoords[cI];
            const l = rotatedShapeCoords.length;
            const nextCoord = rotatedShapeCoords[cI + 1 >= l ? 0 : cI + 1];
            const line = lines[cI];
            await (0, $iD90R.drawLineAnim)(line, coord, nextCoord);
        }
        return await new Promise((res)=>res());
    }
    static removeAll(elements) {
        if (elements.length == 0) return;
        const parent = elements[0].parent;
        elements.forEach((l)=>{
            parent?.removeChild(l);
            l.destroy();
        });
    }
    static cancelHintAnim(elements) {
        (0, $erVR3.rootEventBus).emit((0, $erVR3.EnumRootEventBus).cancelledCircleAnim);
        setTimeout(()=>this.removeAll(elements), 10);
    }
}




var $9bc6e23412bbb12e$export$aeadcbe618d2a165 = /*#__PURE__*/ function(InfoBoxBgColor) {
    //0x000000,
    InfoBoxBgColor[InfoBoxBgColor["blue"] = 13098221] = "blue";
    //0x50E3C2,
    InfoBoxBgColor[InfoBoxBgColor["green"] = 12118406] = "green";
    InfoBoxBgColor[InfoBoxBgColor["yellow"] = 16641207] = "yellow";
    InfoBoxBgColor[InfoBoxBgColor["orange"] = 16496738] = "orange";
    //0xD0021B,
    //0xBD10E0,
    //0x9013FE,
    //0x417505,
    //0x223344,
    InfoBoxBgColor[InfoBoxBgColor["pink"] = 16554436] = "pink";
    return InfoBoxBgColor;
}({});



var $2h5MD = parcelRequire("2h5MD");
function $86bfbf89fc759474$export$2e2bcd8739ae039(shapeCoords, rShapeCoord) {
    const slopeArr = [
        ...shapeCoords
    ].map((c, cI)=>(0, $2h5MD.default)(c, rShapeCoord[cI]));
    const secondIndex = [
        ...slopeArr
    ].map((s, sI)=>sI !== 0 && s !== slopeArr[0] ? sI : -1).filter((a)=>a !== -1)[0];
    return [
        0,
        secondIndex
    ];
}


const $5ece2895811339e2$var$infoBoxProps = {
    title: "HINT:",
    info: "This is a important info",
    bgColor: (0, $9bc6e23412bbb12e$export$aeadcbe618d2a165).orange,
    coord: {
        x: 126,
        y: 140
    },
    width: 290,
    height: 90
};
class $5ece2895811339e2$export$2e2bcd8739ae039 {
    Layers = (0, $9ec1t.default).getInstance();
    GridConfig;
    Question;
    elements = [];
    constructor(){
        (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).on((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).animateHint, (v)=>v ? this.showHint() : (0, $09ce1aaddc60fbee$export$2e2bcd8739ae039).cancelHintAnim(this.elements));
    }
    setHint(GridConfig, Question) {
        (0, $09ce1aaddc60fbee$export$2e2bcd8739ae039).removeAll(this.elements);
        this.GridConfig = GridConfig;
        this.Question = Question;
    }
    async showHint() {
        (0, $09ce1aaddc60fbee$export$2e2bcd8739ae039).removeAll(this.elements);
        this.Question.qType == (0, $f443dc34377ca450$export$51940fbbacba35d4).TYPE1 ? this.showHintType1() : this.showHintType2();
    }
    async showHintType1() {
        let elements = [];
        [
            ...this.Question.shapePoints
        ].map((_, cI)=>{
            const lines = Array(2).fill("").map(()=>new (0, $d0yDD.default)({
                    color: 0xf94f6f,
                    width: 4
                }));
            const angle = new (0, $g4gW0.default)(`angle-${cI}`, {
                color: 0xf94f6f,
                textColor: 0xf94f6f
            });
            elements.push([
                ...lines,
                angle
            ]);
            this.elements.push(...lines, angle);
        });
        const shapeLines = [
            ...this.Question.shapePoints
        ].map((_)=>new (0, $d0yDD.default)({
                width: 5,
                color: 0x000000
            }));
        this.elements.push(...shapeLines);
        await (0, $09ce1aaddc60fbee$export$2e2bcd8739ae039).drawLinesType1(this.GridConfig, this.Question, elements);
        await (0, $09ce1aaddc60fbee$export$2e2bcd8739ae039).drawRotatedShape(shapeLines, this.GridConfig, this.Question.rotatedShapePoints);
    }
    async showHintType2() {
        let Lines = [];
        const indexes = (0, $86bfbf89fc759474$export$2e2bcd8739ae039)([
            ...this.Question.shapePoints
        ], [
            ...this.Question.rotatedShapePoints
        ]);
        [
            ...indexes
        ].map((_)=>{
            const lines = Array(2).fill(null).map((_)=>new (0, $d0yDD.default)({
                    color: 0xf94f6f,
                    width: 4
                }));
            Lines.push(lines);
            this.elements.push(...lines);
        });
        const pivotPoint = this.Layers.Top.addChild(new (0, $171a828006f6bac5$export$2e2bcd8739ae039)((0, $f443dc34377ca450$export$9fc4ff6699ea78e4).red));
        this.elements.push(pivotPoint);
        (0, $09ce1aaddc60fbee$export$2e2bcd8739ae039).drawLinesType2(Lines, indexes, pivotPoint, this.GridConfig, this.Question);
    }
}



var $iuB9z = parcelRequire("iuB9z");

var $9ec1t = parcelRequire("9ec1t");
function $0c5d9f55a54005b0$export$2e2bcd8739ae039(shapeCoords, pivotCoord, cellSize) {
    const sortedX = [
        ...shapeCoords,
        pivotCoord
    ].sort((a, b)=>a.x - b.x);
    const sortedY = [
        ...shapeCoords,
        pivotCoord
    ].sort((a, b)=>a.y - b.y);
    const minCoord = {
        x: sortedX[0].x - 2 * cellSize,
        y: sortedY[0].y - 2 * cellSize
    };
    const maxCoord = {
        x: sortedX[sortedX.length - 1].x + 2 * cellSize,
        y: sortedY[sortedY.length - 1].y + 2 * cellSize
    };
    return [
        {
            x: minCoord.x,
            y: minCoord.y
        },
        {
            x: maxCoord.x,
            y: minCoord.y
        },
        {
            x: maxCoord.x,
            y: maxCoord.y
        },
        {
            x: minCoord.x,
            y: maxCoord.y
        }
    ];
}


function $6e2a9d9b0605d09b$export$2e2bcd8739ae039(coord, pivotCoord, rotRadian) {
    const dx = coord.x - pivotCoord.x;
    const dy = coord.y - pivotCoord.y;
    return {
        x: pivotCoord.x + (dx * Math.cos(rotRadian) - dy * Math.sin(rotRadian)),
        y: pivotCoord.y + (dx * Math.sin(rotRadian) + dy * Math.cos(rotRadian))
    };
}


function $f44e54316a9e1c68$export$2e2bcd8739ae039(bgCoords, totalRot) {
    const length = 96;
    return {
        x: bgCoords[0].x + Math.cos(totalRot + Math.PI / 4) * length,
        y: bgCoords[0].y + Math.sin(totalRot + Math.PI / 4) * length
    };
}



var $2h5MD = parcelRequire("2h5MD");

const $95fef1ef3ecc2f0a$var$TRACING_COLOR = 0x0000FF;
class $95fef1ef3ecc2f0a$export$2e2bcd8739ae039 extends $iuB9z.Container {
    Layers = (0, $9ec1t.default).getInstance();
    bg = this.addChild(new $iuB9z.Graphics());
    shape = this.addChild(new $iuB9z.Graphics());
    pivotPls = this.addChild(new $iuB9z.Graphics());
    rotateSymbol = this.addChild(new $iuB9z.Graphics());
    constructor(){
        super();
        this.addToLayer();
    }
    addToLayer = ()=>this.Layers.UI.addChild(this);
    clearAll = ()=>[
            this.bg,
            this.shape,
            this.pivotPls,
            this.rotateSymbol
        ].forEach((g)=>g.clear());
    setInteractivity(v) {
        this.eventMode = v ? "static" : "none";
    }
    drawPivotPls(pivotCoord, rotRadian) {
        const PlusLength = 16;
        const lX1 = Math.cos(rotRadian) * PlusLength;
        const lY1 = Math.sin(rotRadian) * PlusLength;
        const lX2 = Math.cos(rotRadian + Math.PI / 2) * PlusLength;
        const lY2 = Math.sin(rotRadian + Math.PI / 2) * PlusLength;
        const pC = {
            ...pivotCoord
        };
        this.pivotPls.clear().moveTo(pC.x + lX1, pC.y + lY1).lineTo(pC.x - lX1, pC.y - lY1).moveTo(pC.x + lX2, pC.y + lY2).lineTo(pC.x - lX2, pC.y - lY2).stroke({
            width: 7,
            color: $95fef1ef3ecc2f0a$var$TRACING_COLOR,
            cap: "round"
        });
    }
    drawShape(shapeCoords, pivotCoord, rotRadian) {
        const rotatedCoords = shapeCoords.map((coord)=>(0, $6e2a9d9b0605d09b$export$2e2bcd8739ae039)(coord, pivotCoord, rotRadian));
        this.shape.clear();
        rotatedCoords.forEach((coord, cI)=>{
            if (cI == 0) this.shape.moveTo(coord.x, coord.y);
            else {
                this.shape.lineTo(coord.x, coord.y);
                if (cI == rotatedCoords.length - 1) this.shape.lineTo(rotatedCoords[0].x, rotatedCoords[0].y).stroke({
                    color: $95fef1ef3ecc2f0a$var$TRACING_COLOR,
                    width: 7,
                    cap: "round"
                });
            }
        });
    }
    drawBg(gridCellSize, shapeCoords, pivotCoord, rotRadian) {
        const corners = (0, $0c5d9f55a54005b0$export$2e2bcd8739ae039)(shapeCoords, pivotCoord, gridCellSize);
        const rotatedCorners = corners.map((coord)=>(0, $6e2a9d9b0605d09b$export$2e2bcd8739ae039)(coord, pivotCoord, rotRadian));
        this.bg.clear().moveTo(rotatedCorners[0].x, rotatedCorners[0].y).lineTo(rotatedCorners[1].x, rotatedCorners[1].y).lineTo(rotatedCorners[2].x, rotatedCorners[2].y).lineTo(rotatedCorners[3].x, rotatedCorners[3].y).lineTo(rotatedCorners[0].x, rotatedCorners[0].y).fill({
            color: 0x000000,
            alpha: .25
        });
        return rotatedCorners;
    }
    drawRotateSymbol(bgCoords, totalRotation) {
        const radius = 64;
        const center = (0, $f44e54316a9e1c68$export$2e2bcd8739ae039)(bgCoords, totalRotation);
        const rotRadian = (0, $2h5MD.default)(bgCoords[0], bgCoords[1]);
        const startRadian = -Math.PI / 6 * 5 + rotRadian;
        const endRadian = -Math.PI / 6 * 4 + rotRadian;
        // 1. Calc Coords
        const startCoord = {
            x: center.x + Math.cos(startRadian) * radius,
            y: center.y + Math.sin(startRadian) * radius
        };
        const endCoord = {
            x: center.x + Math.cos(endRadian) * radius,
            y: center.y + Math.sin(endRadian) * radius
        };
        this.rotateSymbol.clear()// Arc
        .moveTo(startCoord.x, startCoord.y).arc(center.x, center.y, radius, startRadian, endRadian).stroke({
            color: 0x000000,
            width: 7,
            cap: "round"
        });
        // --- START ARROW ---
        const sP1 = (0, $6bbc95881fca7ea5$export$2e2bcd8739ae039)(5, 3, rotRadian);
        const sP2 = (0, $6bbc95881fca7ea5$export$2e2bcd8739ae039)(-5, 9, rotRadian);
        const sP3 = (0, $6bbc95881fca7ea5$export$2e2bcd8739ae039)(-4, -4, rotRadian);
        this.rotateSymbol.moveTo(startCoord.x, startCoord.y).lineTo(startCoord.x + sP1.x, startCoord.y + sP1.y).lineTo(startCoord.x + sP2.x, startCoord.y + sP2.y).lineTo(startCoord.x + sP3.x, startCoord.y + sP3.y);
        // --- END ARROW ---
        const eP1 = (0, $6bbc95881fca7ea5$export$2e2bcd8739ae039)(3, 5, rotRadian);
        const eP2 = (0, $6bbc95881fca7ea5$export$2e2bcd8739ae039)(9, -5, rotRadian);
        const eP3 = (0, $6bbc95881fca7ea5$export$2e2bcd8739ae039)(-4, -4, rotRadian);
        this.rotateSymbol.moveTo(endCoord.x, endCoord.y).lineTo(endCoord.x + eP1.x, endCoord.y + eP1.y).lineTo(endCoord.x + eP2.x, endCoord.y + eP2.y).lineTo(endCoord.x + eP3.x, endCoord.y + eP3.y).stroke({
            color: 0x000000,
            width: 5,
            cap: "round"
        }).fill(0x000000);
    }
}



var $erVR3 = parcelRequire("erVR3");


var $2h5MD = parcelRequire("2h5MD");

var $6m47o = parcelRequire("6m47o");

var $1PAc2 = parcelRequire("1PAc2");
class $4674b3228c65a80d$export$2e2bcd8739ae039 extends (0, $1PAc2.default) {
    Anim = (0, $1PAc2.default).getInstance();
    isStopped = false;
    constructor(deltaRad, duration, onUpdate, onComp, resolve){
        super();
        const radian = {
            v: 0
        };
        this.rootEventBus.on(this.EnumRootEventBus.cancelledCircleAnim, ()=>this.isStopped = true);
        if (this.Anim.getIsCancelled()) {
            resolve();
            return;
        }
        new (0, $6m47o.default).Tween({
            ...radian
        }).to({
            v: deltaRad
        }, duration).easing((0, $6m47o.default).Easing.Linear.None).onUpdate((radianObj)=>{
            if (this.isStopped) {
                onComp();
                return;
            }
            onUpdate(radianObj.v);
        }).onComplete(()=>onComp()).start();
    }
}



function $5e73b1e86b07eef9$export$2e2bcd8739ae039(rotRadian, onUpdate) {
    const duration = Math.abs(rotRadian / (Math.PI / 2) * 1000);
    return new Promise((res)=>{
        const rotateAnim = new (0, $4674b3228c65a80d$export$2e2bcd8739ae039)(rotRadian, duration, onUpdate, res, res);
        (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).on((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).setTracingMode, (v)=>!v ? rotateAnim.isStopped = true : "");
    });
}



var $16Wgx = parcelRequire("16Wgx");

var $16HUD = parcelRequire("16HUD");
class $59a79eddbba8e940$export$2e2bcd8739ae039 {
    TracingPaperRenderer = new (0, $95fef1ef3ecc2f0a$export$2e2bcd8739ae039)();
    gridCellSize = 0;
    pivotCoord;
    shapeCoords;
    rotRadian;
    isPressing;
    startRadian = 0;
    deltaRadian = 0;
    shapeRotation = 0;
    constructor(gridCellSize){
        this.gridCellSize = gridCellSize;
        this.addInteractivity();
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).setPointerMove, (c)=>this.handlePointerMove(c));
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).setPointerUp, ()=>this.handlePointerUp());
        (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).on((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).setTracingMode, (v)=>this.handleTracingMode(v));
        (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).on((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).animateTracingPaper, (v)=>this.animatePaper(v));
    }
    handleTracingMode(v) {
        if (v) return this.setPaper();
        this.startRadian = 0;
        this.deltaRadian = 0;
        this.shapeRotation = 0;
        this.TracingPaperRenderer.clearAll();
    }
    async animatePaper(v) {
        if (v) {
            this.shapeRotation = 0;
            this.deltaRadian = 0;
            await (0, $5e73b1e86b07eef9$export$2e2bcd8739ae039)(this.rotRadian, (r)=>{
                this.shapeRotation = r;
                this.setPaper();
            });
        }
    }
    setShapeDetails(shapeCoords, pivotCoord, rotRadian) {
        this.shapeCoords = shapeCoords;
        this.pivotCoord = pivotCoord;
        this.rotRadian = rotRadian;
        (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).emit((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).setTracingMode, false);
    }
    setInteractivity(v) {
        this.TracingPaperRenderer.setInteractivity(v);
        this.isPressing = !v;
    }
    addInteractivity() {
        const handleDownFunc = (e)=>{
            this.setInteractivity(false);
            this.startRadian = (0, $2h5MD.default)(e.global, this.pivotCoord);
        };
        (0, $16Wgx.default)(this.TracingPaperRenderer, {
            handleDownFunc: handleDownFunc
        }, (0, $16HUD.CustomCursorType).grab);
    }
    handlePointerUp() {
        this.shapeRotation = this.shapeRotation + this.deltaRadian;
        this.setInteractivity(true);
    }
    handlePointerMove(coord) {
        if (!this.isPressing) return;
        const radian = (0, $2h5MD.default)(coord, this.pivotCoord);
        this.deltaRadian = radian - this.startRadian;
        this.setPaper();
    }
    setPaper() {
        const totalRotation = this.shapeRotation + this.deltaRadian;
        const rotatedBgCoords = this.TracingPaperRenderer.drawBg(this.gridCellSize, [
            ...this.shapeCoords
        ], {
            ...this.pivotCoord
        }, totalRotation);
        this.TracingPaperRenderer.drawShape([
            ...this.shapeCoords
        ], {
            ...this.pivotCoord
        }, totalRotation);
        this.TracingPaperRenderer.drawPivotPls({
            ...this.pivotCoord
        }, totalRotation);
        this.TracingPaperRenderer.drawRotateSymbol(rotatedBgCoords, totalRotation);
    }
}



var $iuB9z = parcelRequire("iuB9z");

var $9ec1t = parcelRequire("9ec1t");

var $d0yDD = parcelRequire("d0yDD");

var $dWG0X = parcelRequire("dWG0X");
function $459b5e3b6ea48f29$export$2e2bcd8739ae039(lineCoords, cellSize) {
    return lineCoords.endCoords.map((coord)=>{
        const delta = {
            width: coord.x - lineCoords.originCoord.x,
            height: coord.y - lineCoords.originCoord.y
        };
        const unitdim = {
            x: delta.width / cellSize,
            y: delta.height / cellSize
        };
        const totalUnit = Math.abs((delta.width + delta.height) / cellSize) || 0;
        return Array(totalUnit).fill("").map((_, i)=>{
            const size = (i + 1) * cellSize;
            return {
                x: (unitdim.x == 0 ? -30 : unitdim.x / Math.abs(unitdim.x) * size) + lineCoords.originCoord.x,
                y: (unitdim.y == 0 ? 30 : unitdim.y / Math.abs(unitdim.y) * size) + lineCoords.originCoord.y
            };
        });
    });
}


function $078604307ed76275$export$2e2bcd8739ae039(GridConfig, lineCoords, coord) {
    const unitX = (lineCoords.originCoord.x - coord.x) / GridConfig.cellSize;
    const unitY = (lineCoords.originCoord.y - coord.y) / GridConfig.cellSize;
    return Math.floor(Math.abs(unitX) > Math.abs(unitY) ? -unitX : unitY);
}


const $9cfbccab6f62a972$var$defaultNumCoord = {
    x: -100,
    y: -100
};
class $9cfbccab6f62a972$export$2e2bcd8739ae039 extends $iuB9z.Container {
    GridConfig;
    Layers;
    pvtPoint;
    lines;
    numbers;
    constructor(GridConfig){
        super(), this.GridConfig = GridConfig, this.Layers = (0, $9ec1t.default).getInstance(), this.pvtPoint = this.addChild(new $iuB9z.Graphics()), this.lines = Array(4).fill(null).map(()=>this.addLine()), this.numbers = Array(50).fill(null).map(()=>this.drawNumberCon()), this.addToLayer = ()=>this.Layers.Middle.addChild(this);
        this.addToLayer();
    }
    addToLayer;
    drawNumberCon() {
        const con = new $iuB9z.Container();
        const circle = new $iuB9z.Graphics().circle(0, 0, 15).fill(0xFFFFFF);
        con.numberText = new $iuB9z.Text();
        con.numberText.anchor.set(.5);
        con.addChild(circle, con.numberText);
        this.addChild(con);
        return con;
    }
    addLine() {
        const line = new (0, $d0yDD.default)({
            arrowCap: (0, $dWG0X.ArrowCap).End,
            width: 6,
            color: 0x000000
        });
        line.parent.removeChild(line);
        return this.addChild(line);
    }
    drawCircle(originCoord) {
        this.pvtPoint.clear().circle(originCoord.x, originCoord.y, 14).stroke({
            width: 3,
            color: 0xAAAAAA
        });
    }
    setNumbers(lineCoords) {
        const numberConCoords = (0, $459b5e3b6ea48f29$export$2e2bcd8739ae039)(lineCoords, this.GridConfig.cellSize).filter((cArr)=>cArr.length > 0);
        numberConCoords.forEach((coords, coordsI)=>coords.forEach((coord, coordI)=>{
                const num = this.numbers[coordsI * coords.length + coordI];
                num.position.copyFrom(coord);
                num.numberText.text = (0, $078604307ed76275$export$2e2bcd8739ae039)(this.GridConfig, lineCoords, coord);
            }));
    }
    drawLines(lineCoords) {
        for(let index = 0; index < lineCoords.endCoords.length; index++){
            const coord = lineCoords.endCoords[index];
            if (lineCoords.originCoord.x != coord.x || lineCoords.originCoord.y != coord.y) this.lines[index].draw(lineCoords.originCoord, coord);
        }
    }
    reset() {
        this.numbers.forEach((num)=>num.position.copyFrom($9cfbccab6f62a972$var$defaultNumCoord));
        this.lines.forEach((l)=>l.clear());
    }
}


function $82a26c6c7836ff76$export$2e2bcd8739ae039(GridConfig, originPoint) {
    const GF = GridConfig;
    return {
        originCoord: {
            x: GF.x - GF.width / 2 + originPoint.x * GF.cellSize,
            y: GF.y - GF.height / 2 + originPoint.y * GF.cellSize
        },
        endCoords: [
            {
                x: GF.x - GF.width / 2,
                y: GF.y - GF.height / 2 + originPoint.y * GF.cellSize
            },
            {
                x: GF.x + GF.width / 2,
                y: GF.y - GF.height / 2 + originPoint.y * GF.cellSize
            },
            {
                x: GF.x - GF.width / 2 + originPoint.x * GF.cellSize,
                y: GF.y + GF.height / 2
            },
            {
                x: GF.x - GF.width / 2 + originPoint.x * GF.cellSize,
                y: GF.y - GF.height / 2
            }
        ]
    };
}


class $522bb9437de29270$export$2e2bcd8739ae039 {
    GridConfig;
    CoordinatePanelRenderer;
    originPoint;
    constructor(GridConfig){
        this.GridConfig = GridConfig;
        this.originPoint = {
            x: -1,
            y: -1
        };
        this.CoordinatePanelRenderer = new (0, $9cfbccab6f62a972$export$2e2bcd8739ae039)(this.GridConfig);
    }
    draw(originPoint) {
        if (!originPoint || this.originPoint.x == originPoint.x && this.originPoint.y == originPoint.y) return;
        this.originPoint = originPoint;
        const lineCoords = (0, $82a26c6c7836ff76$export$2e2bcd8739ae039)(this.GridConfig, originPoint);
        this.CoordinatePanelRenderer.reset();
        this.CoordinatePanelRenderer.setNumbers(lineCoords);
        this.CoordinatePanelRenderer.drawLines(lineCoords);
        this.CoordinatePanelRenderer.drawCircle(lineCoords.originCoord);
    }
}




class $17195d95ce0736c9$export$2e2bcd8739ae039 {
    static addDescConfig(questionDesc, gridConfig) {
        questionDesc.style = {
            wordWrap: true,
            wordWrapWidth: gridConfig.width
        };
        const coord = {
            x: gridConfig.x - gridConfig.width / 2,
            y: gridConfig.y - gridConfig.height / 2 - 50
        };
        Object.assign(questionDesc, coord);
    }
    static getEmptyQuestion() {
        return {
            qType: (0, $f443dc34377ca450$export$51940fbbacba35d4).TYPE1,
            desc: "",
            shapeType: (0, $f443dc34377ca450$export$fc850f719b5599d5).l,
            shapePoints: [],
            rotatedShapePoints: [],
            centerPoint: {},
            pivotPoint: {},
            origin: {},
            rotation: 0
        };
    }
}




function $39399ccb2a8cf523$export$2e2bcd8739ae039(gridConfig, startPoint, pivotPoint, offsets) {
    const radians = [
        Math.PI / 2,
        -Math.PI / 2,
        -Math.PI
    ];
    const u = gridConfig.width / gridConfig.cellSize - offsets[2];
    const v = gridConfig.height / gridConfig.cellSize - offsets[3];
    const possibleRadianIndexs = [
        ...radians
    ].map((r)=>(0, $6e2a9d9b0605d09b$export$2e2bcd8739ae039)(startPoint, pivotPoint, r)).map((c, cI)=>c.x < u && c.x > offsets[0] + 2 && c.y < v && c.y > offsets[1] + 2 ? cI : null).filter((e)=>e !== null);
    const randomIndex = possibleRadianIndexs[Math.floor(Math.random() * possibleRadianIndexs.length)];
    return radians[randomIndex];
}



function $cca43846304fc232$export$2e2bcd8739ae039(prevShapeType) {
    const shapes = Object.values((0, $f443dc34377ca450$export$fc850f719b5599d5));
    prevShapeType && shapes.splice(shapes.indexOf(prevShapeType), 1);
    return shapes[Math.floor(Math.random() * shapes.length)];
}


function $7952d811e23a177b$export$2e2bcd8739ae039(gridConfig) {
    const offset = 3;
    const u = Math.abs(gridConfig.width / gridConfig.cellSize - offset * 2);
    const v = Math.abs(gridConfig.height / gridConfig.cellSize - offset * 2);
    return {
        x: Math.floor(Math.random() * u) + offset,
        y: Math.floor(Math.random() * v) + offset
    };
}


function $ce82f7598d608ee2$export$2e2bcd8739ae039(gridConfig, offsets) {
    const u = gridConfig.width / gridConfig.cellSize - offsets[2];
    const v = gridConfig.height / gridConfig.cellSize - offsets[3];
    return {
        x: Math.floor(Math.random() * u) + offsets[0],
        y: Math.floor(Math.random() * v) + offsets[1]
    };
}



function $eb81863fb8eb61c0$export$2e2bcd8739ae039(type, startCoord) {
    if (type == (0, $f443dc34377ca450$export$fc850f719b5599d5).l) return $eb81863fb8eb61c0$var$genL(startCoord);
    else if (type == (0, $f443dc34377ca450$export$fc850f719b5599d5).parallel) return $eb81863fb8eb61c0$var$genParallel(startCoord);
    else if (type == (0, $f443dc34377ca450$export$fc850f719b5599d5).rectangle) return $eb81863fb8eb61c0$var$genRect(startCoord);
    else if (type == (0, $f443dc34377ca450$export$fc850f719b5599d5).rightTrapezoid) return $eb81863fb8eb61c0$var$genRightTrapezoid(startCoord);
    else if (type == (0, $f443dc34377ca450$export$fc850f719b5599d5).rightTriangle) return $eb81863fb8eb61c0$var$genRightTri(startCoord);
    else if (type == (0, $f443dc34377ca450$export$fc850f719b5599d5).square) return $eb81863fb8eb61c0$var$genSquare(startCoord);
    else if (type == (0, $f443dc34377ca450$export$fc850f719b5599d5).t) return $eb81863fb8eb61c0$var$genT(startCoord);
    else if (type == (0, $f443dc34377ca450$export$fc850f719b5599d5).trapezoid) return $eb81863fb8eb61c0$var$genTrapezoid(startCoord);
    else if (type == (0, $f443dc34377ca450$export$fc850f719b5599d5).triangle) return $eb81863fb8eb61c0$var$genTri(startCoord);
    return $eb81863fb8eb61c0$var$genSquare(startCoord);
}
function $eb81863fb8eb61c0$var$genL(startCoord) {
    return {
        shapePoints: [
            startCoord,
            {
                x: startCoord.x + 1,
                y: startCoord.y
            },
            {
                x: startCoord.x + 1,
                y: startCoord.y + 2
            },
            {
                x: startCoord.x + 2,
                y: startCoord.y + 2
            },
            {
                x: startCoord.x + 2,
                y: startCoord.y + 3
            },
            {
                x: startCoord.x,
                y: startCoord.y + 3
            }
        ],
        centerPoint: {
            x: startCoord.x + .5,
            y: startCoord.y + 2.5
        }
    };
}
function $eb81863fb8eb61c0$var$genT(startCoord) {
    return {
        shapePoints: [
            startCoord,
            {
                x: startCoord.x + 3,
                y: startCoord.y
            },
            {
                x: startCoord.x + 3,
                y: startCoord.y + 1
            },
            {
                x: startCoord.x + 2,
                y: startCoord.y + 1
            },
            {
                x: startCoord.x + 2,
                y: startCoord.y + 3
            },
            {
                x: startCoord.x + 1,
                y: startCoord.y + 3
            },
            {
                x: startCoord.x + 1,
                y: startCoord.y + 1
            },
            {
                x: startCoord.x,
                y: startCoord.y + 1
            }
        ],
        centerPoint: {
            x: startCoord.x + 1.5,
            y: startCoord.y + .5
        }
    };
}
function $eb81863fb8eb61c0$var$genParallel(startCoord) {
    return {
        shapePoints: [
            startCoord,
            {
                x: startCoord.x + 2,
                y: startCoord.y
            },
            {
                x: startCoord.x + 1,
                y: startCoord.y + 3
            },
            {
                x: startCoord.x - 1,
                y: startCoord.y + 3
            }
        ],
        centerPoint: {
            x: startCoord.x + .5,
            y: startCoord.y + 1.5
        }
    };
}
function $eb81863fb8eb61c0$var$genRect(startCoord) {
    return {
        shapePoints: [
            startCoord,
            {
                x: startCoord.x + 3,
                y: startCoord.y
            },
            {
                x: startCoord.x + 3,
                y: startCoord.y + 2
            },
            {
                x: startCoord.x,
                y: startCoord.y + 2
            }
        ],
        centerPoint: {
            x: startCoord.x + 1.5,
            y: startCoord.y + 1
        }
    };
}
function $eb81863fb8eb61c0$var$genSquare(startCoord) {
    return {
        shapePoints: [
            startCoord,
            {
                x: startCoord.x + 2,
                y: startCoord.y
            },
            {
                x: startCoord.x + 2,
                y: startCoord.y + 2
            },
            {
                x: startCoord.x,
                y: startCoord.y + 2
            }
        ],
        centerPoint: {
            x: startCoord.x + 1,
            y: startCoord.y + 1
        }
    };
}
function $eb81863fb8eb61c0$var$genTri(startCoord) {
    return {
        shapePoints: [
            startCoord,
            {
                x: startCoord.x + 2,
                y: startCoord.y + 3
            },
            {
                x: startCoord.x - 2,
                y: startCoord.y + 3
            }
        ],
        centerPoint: {
            x: startCoord.x,
            y: startCoord.y + 2
        }
    };
}
function $eb81863fb8eb61c0$var$genRightTri(startCoord) {
    return {
        shapePoints: [
            startCoord,
            {
                x: startCoord.x + 2,
                y: startCoord.y + 3
            },
            {
                x: startCoord.x,
                y: startCoord.y + 3
            }
        ],
        centerPoint: {
            x: startCoord.x + .5,
            y: startCoord.y + 2
        }
    };
}
function $eb81863fb8eb61c0$var$genTrapezoid(startCoord) {
    return {
        shapePoints: [
            startCoord,
            {
                x: startCoord.x + 2,
                y: startCoord.y
            },
            {
                x: startCoord.x + 3,
                y: startCoord.y + 3
            },
            {
                x: startCoord.x - 1,
                y: startCoord.y + 3
            }
        ],
        centerPoint: {
            x: startCoord.x + 1,
            y: startCoord.y + 1.5
        }
    };
}
function $eb81863fb8eb61c0$var$genRightTrapezoid(startCoord) {
    return {
        shapePoints: [
            startCoord,
            {
                x: startCoord.x + 2,
                y: startCoord.y
            },
            {
                x: startCoord.x + 3,
                y: startCoord.y + 3
            },
            {
                x: startCoord.x,
                y: startCoord.y + 3
            }
        ],
        centerPoint: {
            x: startCoord.x + 1,
            y: startCoord.y + 1.5
        }
    };
}



function $a56631d8cbf353de$export$2e2bcd8739ae039(shapeType) {
    let offsets = [
        1,
        1,
        3,
        3
    ];
    if (shapeType == (0, $f443dc34377ca450$export$fc850f719b5599d5).parallel || shapeType == (0, $f443dc34377ca450$export$fc850f719b5599d5).trapezoid) offsets = [
        1,
        1,
        4,
        3
    ];
    else if (shapeType == (0, $f443dc34377ca450$export$fc850f719b5599d5).triangle) offsets = [
        2,
        2,
        2,
        3
    ];
    return offsets;
}



function $bf9a702042df32aa$export$2e2bcd8739ae039(pivotPoint, shapePoints, rotation) {
    return [
        ...shapePoints
    ].map((c)=>(0, $6e2a9d9b0605d09b$export$2e2bcd8739ae039)(c, pivotPoint, rotation));
}



function $a396bf50f79950e9$export$2e2bcd8739ae039(QuestionTypes) {
    const questionTypes = Object.entries(QuestionTypes).filter((t)=>t[1]).map((t)=>t[0]);
    return (0, $f443dc34377ca450$export$51940fbbacba35d4)[questionTypes[Math.floor(Math.random() * questionTypes.length)]];
}



var $74Gga = parcelRequire("74Gga");

function $83cb751d42520a50$export$2e2bcd8739ae039(qType, rotation) {
    if (qType == (0, $f443dc34377ca450$export$51940fbbacba35d4).TYPE1) {
        const dir = rotation < 0 ? (0, $f443dc34377ca450$export$cacd6541cfeeb6c1).antiClockwise : (0, $f443dc34377ca450$export$cacd6541cfeeb6c1).clockwise;
        return `Rotate the shape ${Math.abs((0, $74Gga.default)(rotation))} degrees ${dir} about point.`;
    } else if (qType == (0, $f443dc34377ca450$export$51940fbbacba35d4).TYPE2) return "Describe the single transformation from shape A to shape B.";
}


function $4fc2b55013e6d257$export$2e2bcd8739ae039(prevQuestion = {}, QuestionTypes) {
    const shapeType = (0, $cca43846304fc232$export$2e2bcd8739ae039)(prevQuestion?.shapeType);
    const offsets = (0, $a56631d8cbf353de$export$2e2bcd8739ae039)(shapeType);
    const pivotPoint = (0, $7952d811e23a177b$export$2e2bcd8739ae039)((0, $63c2c194f5a6a92c$export$efa38d22ebef7327));
    const startPoint = (0, $ce82f7598d608ee2$export$2e2bcd8739ae039)((0, $63c2c194f5a6a92c$export$efa38d22ebef7327), offsets);
    const rotation = (0, $39399ccb2a8cf523$export$2e2bcd8739ae039)((0, $63c2c194f5a6a92c$export$efa38d22ebef7327), startPoint, pivotPoint, offsets);
    if (!rotation) return $4fc2b55013e6d257$export$2e2bcd8739ae039(prevQuestion, QuestionTypes);
    const { shapePoints: shapePoints, centerPoint: centerPoint } = (0, $eb81863fb8eb61c0$export$2e2bcd8739ae039)(shapeType, startPoint);
    const rotatedShapePoints = (0, $bf9a702042df32aa$export$2e2bcd8739ae039)(pivotPoint, shapePoints, rotation);
    const qType = (0, $a396bf50f79950e9$export$2e2bcd8739ae039)(QuestionTypes);
    const desc = (0, $83cb751d42520a50$export$2e2bcd8739ae039)(qType, rotation);
    const origin = {
        x: 0,
        y: (0, $63c2c194f5a6a92c$export$efa38d22ebef7327).height / (0, $63c2c194f5a6a92c$export$efa38d22ebef7327).cellSize
    };
    return {
        qType: qType,
        desc: desc,
        shapeType: shapeType,
        shapePoints: shapePoints,
        rotatedShapePoints: rotatedShapePoints,
        centerPoint: centerPoint,
        pivotPoint: pivotPoint,
        origin: origin,
        rotation: rotation
    };
}




class $6c4ac80e5941a264$export$2e2bcd8739ae039 extends $iuB9z.Container {
    GridConfig;
    Layers;
    TestQuestionManager;
    Question;
    QuestionDesc;
    CoordinatePanel;
    TracingPaper;
    HintManager;
    ShapeManager;
    QuestionTypes;
    isTest;
    constructor(GridConfig){
        super(), this.GridConfig = GridConfig, this.Layers = (0, $9ec1t.default).getInstance(), this.TestQuestionManager = (0, $905a2b833cc89373$export$2e2bcd8739ae039).getInstance(), this.QuestionDesc = this.addChild(new $iuB9z.Text()), this.HintManager = new (0, $5ece2895811339e2$export$2e2bcd8739ae039)(), this.ShapeManager = new (0, $0aba4ac0d1762a6f$export$2e2bcd8739ae039)(), this.QuestionTypes = {
            TYPE1: true,
            TYPE2: true
        }, this.isTest = false, this.addToLayer = ()=>this.Layers.Top.addChild(this), this.setQuestionTypes = (d)=>{
            this.QuestionTypes = d;
        };
        this.TracingPaper = new (0, $59a79eddbba8e940$export$2e2bcd8739ae039)(this.GridConfig.cellSize);
        this.CoordinatePanel = new (0, $522bb9437de29270$export$2e2bcd8739ae039)(this.GridConfig);
        (0, $17195d95ce0736c9$export$2e2bcd8739ae039).addDescConfig(this.QuestionDesc, this.GridConfig);
        this.addToLayer();
        this.generateQuestion();
        (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).on((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).setActiveQuestionType, (d)=>this.setQuestionTypes(d));
        (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).on((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).newQuestion, ()=>this.generateQuestion());
        (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).on((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).startTest, ()=>this.generateQuestion());
        (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).on((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).showTestQuestion, (i)=>this.showTestQuestion(i));
        (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).on((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).setQuestMode, (v)=>{
            this.isTest = v == (0, $f443dc34377ca450$export$b4d15339b5fb8fcc).test;
            this.TestQuestionManager.reset();
            this.generateQuestion(true);
        });
    }
    addToLayer;
    setQuestionTypes;
    showTestQuestion(qIndex) {
        this.Question = this.TestQuestionManager.getQuestion(qIndex);
        this.setQuestion();
    }
    generateQuestion(isEmpty = false) {
        this.Question = isEmpty ? (0, $17195d95ce0736c9$export$2e2bcd8739ae039).getEmptyQuestion() : (0, $4fc2b55013e6d257$export$2e2bcd8739ae039)(this.Question, this.QuestionTypes);
        this.setQuestion();
        !isEmpty && (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).emit((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).questionType, this.Question.qType);
        if (this.isTest && !isEmpty) this.TestQuestionManager.addQuestion({
            ...this.Question
        });
    }
    setQuestion() {
        const pivotCoord = (0, $129b550e43e52b2b$export$2e2bcd8739ae039).getGlobalCoord(this.GridConfig, this.Question.pivotPoint);
        const shapeCoords = this.Question.shapePoints.map((c)=>(0, $129b550e43e52b2b$export$2e2bcd8739ae039).getGlobalCoord(this.GridConfig, c));
        const rotatedShapeCoords = this.Question.rotatedShapePoints.map((c)=>(0, $129b550e43e52b2b$export$2e2bcd8739ae039).getGlobalCoord(this.GridConfig, c));
        const centerCoord = (0, $129b550e43e52b2b$export$2e2bcd8739ae039).getGlobalCoord(this.GridConfig, this.Question.centerPoint);
        const rotatedCenterCoord = (0, $6e2a9d9b0605d09b$export$2e2bcd8739ae039)(centerCoord, pivotCoord, this.Question.rotation);
        this.TracingPaper.setShapeDetails(shapeCoords, pivotCoord, this.Question.rotation);
        this.HintManager.setHint(this.GridConfig, this.Question);
        this.ShapeManager.draw({
            shapeCoords: shapeCoords,
            rotatedShapeCoords: rotatedShapeCoords,
            centerCoord: centerCoord,
            rotatedCenterCoord: rotatedCenterCoord,
            pivotCoord: pivotCoord,
            rotation: this.Question.rotation,
            qType: this.Question.qType,
            origin: this.Question.origin
        });
        this.CoordinatePanel.draw(this.Question.origin);
        this.QuestionDesc.text = this.Question.desc;
    }
}



class $f4e93496f8d935cb$export$2e2bcd8739ae039 extends $iuB9z.Container {
    Game = (0, $75RpY.default).getInstance();
    dim = this.Game.getDim();
    constructor(){
        super();
        const gridConfig = $f4e93496f8d935cb$var$getGridConfig(this.dim);
        new (0, $129b550e43e52b2b$export$2e2bcd8739ae039)(gridConfig);
        new (0, $ec8565cdab3711ad$export$2e2bcd8739ae039)(gridConfig);
        new (0, $6c4ac80e5941a264$export$2e2bcd8739ae039)(gridConfig);
    }
}
function $f4e93496f8d935cb$var$getGridConfig({ WIDTH: WIDTH, HEIGHT: HEIGHT }) {
    const gridConfig = {
        ...(0, $63c2c194f5a6a92c$export$efa38d22ebef7327)
    };
    WIDTH < HEIGHT && (gridConfig.x = WIDTH / 2);
    return gridConfig;
}



var $iuB9z = parcelRequire("iuB9z");

var $75RpY = parcelRequire("75RpY");

var $9ec1t = parcelRequire("9ec1t");
class $c5e393fa88a2b6ba$export$2e2bcd8739ae039 extends $iuB9z.Container {
    static instance;
    Game = (0, $75RpY.default).getInstance();
    Layers = (0, $9ec1t.default).getInstance();
    dim = this.Game.getDim();
    bg = this.addChild(new $iuB9z.Graphics());
    constructor(){
        super();
        if (!$c5e393fa88a2b6ba$export$2e2bcd8739ae039.instance) $c5e393fa88a2b6ba$export$2e2bcd8739ae039.instance = this;
        this.addToLayer();
        this.addPanelBg();
        this.position.copyFrom(this.getCoord());
    }
    static getInstance = ()=>$c5e393fa88a2b6ba$export$2e2bcd8739ae039.instance;
    addToLayer = ()=>this.Layers.UITop.addChild(this);
    addPanelBg() {
        const size = this.getBgSize();
        this.bg.roundRect(-size.width / 2, 0, size.width, size.height, 10).fill(0xFFFFCC).stroke({
            color: 0x000000,
            width: 3
        }).eventMode = "none";
    }
    getBgSize() {
        const isVertical = this.dim.WIDTH < this.dim.HEIGHT;
        return {
            width: isVertical ? 720 : 600,
            height: isVertical ? 840 : 840
        };
    }
    getCoord() {
        if (this.dim.WIDTH < this.dim.HEIGHT) return {
            x: this.dim.WIDTH / 2,
            y: this.dim.HEIGHT / 2
        };
        return {
            x: this.dim.WIDTH / 2 + 400,
            y: 30
        };
    }
}




var $iuB9z = parcelRequire("iuB9z");



var $erVR3 = parcelRequire("erVR3");


var $eitLW = parcelRequire("eitLW");


var $iuB9z = parcelRequire("iuB9z");

var $dWG0X = parcelRequire("dWG0X");

var $16Wgx = parcelRequire("16Wgx");

var $iuB9z = parcelRequire("iuB9z");
class $9b9a65bf0e92457c$export$2e2bcd8739ae039 {
    drawButtonBg(buttonBg, buttonStyle, color, updateBg, border) {
        updateBg && buttonBg.clear().roundRect(-buttonStyle.width / 2, -buttonStyle.height / 2, buttonStyle.width, buttonStyle.height, buttonStyle.borderRadius || 10).fill(color);
        (typeof border === "undefined" || border) && buttonBg.stroke({
            color: 0x000000,
            width: 3
        });
    }
    static generateText(label, fontSize, fill) {
        const text = new $iuB9z.Text({
            text: label
        });
        text.style = {
            fill: fill,
            fontSize: fontSize,
            fontWeight: "500"
        };
        text.anchor.set(.5);
        return text;
    }
}



var $7oAU9 = parcelRequire("7oAU9");

var $16HUD = parcelRequire("16HUD");
class $035d220cf9b861a9$export$2e2bcd8739ae039 extends $iuB9z.Container {
    buttonStyle;
    ButtonRenderer;
    icon;
    onHandleFunc;
    onHandleSecondFunc;
    updateBg;
    buttonBg;
    isOn;
    constructor(buttonStyle, icon, updateBg = true, onHandleFunc, onHandleSecondFunc){
        super(), this.buttonStyle = buttonStyle, this.ButtonRenderer = new (0, $9b9a65bf0e92457c$export$2e2bcd8739ae039)(), this.updateBg = true, this.buttonBg = new $iuB9z.Graphics(), this.isOn = false, this.closeButton = ()=>this.handleDefaultButton(false), this.handleDefaultPosition = ()=>this.handleButton(false, this.buttonStyle.defaultBgColor, this.updateBg);
        this.icon = icon;
        this.position.copyFrom(buttonStyle);
        if (!this.buttonStyle.defaultBgColor) buttonStyle.defaultBgColor = (0, $dWG0X.SwitcherBgColors).defaultBgColor;
        if (!this.buttonStyle.pressedBgColor) buttonStyle.pressedBgColor = (0, $dWG0X.SwitcherBgColors).pressedBgColor;
        this.onHandleFunc = onHandleFunc;
        this.onHandleSecondFunc = onHandleSecondFunc;
        this.updateBg = updateBg;
        this.createButton(this.icon);
        this.addInteractivity();
    }
    closeButton;
    handleDefaultPosition;
    setDisabled(v) {
        this.eventMode = v ? "none" : "static";
        this.filters = v ? [
            (0, $7oAU9.disabledfilter)
        ] : [];
    }
    handlePressedButton() {
        this.handleButton(true, this.buttonStyle.pressedBgColor, this.updateBg);
        this.onHandleFunc();
    }
    handleDefaultButton(withCB = true) {
        this.handleButton(false, this.buttonStyle.defaultBgColor, this.updateBg);
        withCB && this.onHandleSecondFunc();
    }
    handleButton(isOn, fillColor, update) {
        this.isOn = isOn;
        this.ButtonRenderer.drawButtonBg(this.buttonBg, this.buttonStyle, fillColor, update, this.buttonStyle.border);
    }
    createButton(icon) {
        const button = new $iuB9z.Container();
        this.handleButton(false, this.buttonStyle.defaultBgColor, true);
        icon instanceof $iuB9z.Text && icon.anchor.set(.5);
        button.addChild(this.buttonBg, icon);
        this.addChild(button);
    }
    addInteractivity() {
        const handleDownFunc = ()=>this.isOn ? this.handleDefaultButton() : this.handlePressedButton();
        (0, $16Wgx.default)(this, {
            handleDownFunc: handleDownFunc
        }, (0, $16HUD.CustomCursorType).pointer, undefined, true);
    }
    static generateText = (label, fontSize, fill = 0x333333)=>(0, $9b9a65bf0e92457c$export$2e2bcd8739ae039).generateText(label, fontSize, fill);
}



function $d2ff14cd0958f199$export$2e2bcd8739ae039(label, onHandleFunc, onHandleSecondFunc, style, updateBg = true, isClosable = true) {
    const textSprite = (0, $035d220cf9b861a9$export$2e2bcd8739ae039).generateText(label, style.fontSize || 28);
    const button = new (0, $035d220cf9b861a9$export$2e2bcd8739ae039)(style, textSprite, updateBg, onHandleFunc, onHandleSecondFunc);
    (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).on((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).newQuestion, ()=>isClosable ? button.closeButton() : "");
    return button;
}



class $af81f312419f67e3$export$2e2bcd8739ae039 {
    static genGoToTestModeButton() {
        let button;
        const onHandleFunc = ()=>{
            (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).emit((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).setQuestMode, (0, $f443dc34377ca450$export$b4d15339b5fb8fcc).test);
            setTimeout(()=>button.closeButton(), 200);
        };
        const onHandleSecondFunc = ()=>{};
        const sButtonStyle = (0, $63c2c194f5a6a92c$export$d013b5727948ec9f).gotoTestMode;
        button = (0, $d2ff14cd0958f199$export$2e2bcd8739ae039)("Go To Test Mode", onHandleFunc, onHandleSecondFunc, sButtonStyle, undefined, false);
        return button;
    }
    static genGenRandomlyQuestionButton() {
        let button;
        const onHandleFunc = ()=>{
            (0, $erVR3.rootEventBus).emit((0, $erVR3.EnumRootEventBus).cancelledCircleAnim);
            (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).emit((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).newQuestion);
            (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).emit((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).clearAll);
            setTimeout(()=>button.closeButton(), 200);
        };
        const onHandleSecondFunc = ()=>{};
        const sButtonStyle = (0, $63c2c194f5a6a92c$export$d013b5727948ec9f).genRandomlyQuestion;
        button = (0, $d2ff14cd0958f199$export$2e2bcd8739ae039)("Generate Randomly Question", onHandleFunc, onHandleSecondFunc, sButtonStyle, undefined, false);
        return button;
    }
    static genShowSolutionButton() {
        const onHandleFunc = ()=>(0, $f60d53a2fe365b05$export$f6644f0f2c90144b).emit((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).setShowSolution, true);
        const onHandleSecondFunc = ()=>(0, $f60d53a2fe365b05$export$f6644f0f2c90144b).emit((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).setShowSolution, false);
        const sButtonStyle = (0, $63c2c194f5a6a92c$export$d013b5727948ec9f).showSolution;
        return (0, $d2ff14cd0958f199$export$2e2bcd8739ae039)("Show Solution", onHandleFunc, onHandleSecondFunc, sButtonStyle);
    }
    static genTracingPaperButton() {
        const onHandleFunc = ()=>(0, $f60d53a2fe365b05$export$f6644f0f2c90144b).emit((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).setTracingMode, true);
        const onHandleSecondFunc = ()=>(0, $f60d53a2fe365b05$export$f6644f0f2c90144b).emit((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).setTracingMode, false);
        const sButtonStyle = (0, $63c2c194f5a6a92c$export$d013b5727948ec9f).tracingPaper;
        const button = (0, $d2ff14cd0958f199$export$2e2bcd8739ae039)("Tracing Paper", onHandleFunc, onHandleSecondFunc, sButtonStyle);
        (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).on((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).setTracingMode, (v)=>!v ? button.closeButton() : "");
        return button;
    }
    static genAnimateButton() {
        let button;
        const onHandleFunc = ()=>{
            (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).emit((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).animateTracingPaper, true);
            setTimeout(()=>button.closeButton(), 200);
        };
        const onHandleSecondFunc = ()=>(0, $f60d53a2fe365b05$export$f6644f0f2c90144b).emit((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).animateTracingPaper, false);
        const sButtonStyle = (0, $63c2c194f5a6a92c$export$d013b5727948ec9f).animate;
        button = (0, $d2ff14cd0958f199$export$2e2bcd8739ae039)("Animate", onHandleFunc, onHandleSecondFunc, sButtonStyle);
        button.visible = false;
        return button;
    }
    static genHintButton() {
        const onHandleFunc = ()=>{
            (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).emit((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).animateHint, true);
            (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).emit((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).setTracingMode, false);
        };
        const onHandleSecondFunc = ()=>(0, $f60d53a2fe365b05$export$f6644f0f2c90144b).emit((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).animateHint, false);
        const sButtonStyle = (0, $63c2c194f5a6a92c$export$d013b5727948ec9f).hint;
        return (0, $d2ff14cd0958f199$export$2e2bcd8739ae039)("Show Hint", onHandleFunc, onHandleSecondFunc, sButtonStyle);
    }
    static genTypeCheckbox(type, _handleFunc) {
        const config = (0, $63c2c194f5a6a92c$export$9e9b6a158267785f)[type];
        const handleFunc = (l, v)=>_handleFunc(v);
        const checkbox = new (0, $eitLW.default)(config.coord, config.label, config.color, true, handleFunc);
        checkbox.setChecked(true);
        checkbox.setScale(.7);
        return checkbox;
    }
}



var $iuB9z = parcelRequire("iuB9z");

var $6m47o = parcelRequire("6m47o");

var $9ec1t = parcelRequire("9ec1t");

var $iuB9z = parcelRequire("iuB9z");
class $8f06501bcb3117cd$export$2e2bcd8739ae039 {
    static genItemCon(_config, label, index) {
        const config = {
            ..._config
        };
        const con = new $iuB9z.Container();
        if (index) config.y = index * config.height - 16;
        const labelCoord = {
            x: config.x - config.width / 2 + 10,
            y: config.y
        };
        con.addChild(this.genBg(config, index ? true : false), this.genLabel(label, labelCoord));
        return con;
    }
    static genBg(config, isChild) {
        const x = config.x - config.width / 2;
        const y = config.y - config.height / 2;
        const rect = new $iuB9z.Graphics().rect(x, y, config.width, config.height).fill({
            color: !isChild ? config.fillColor : config.childFillColor
        }).stroke({
            color: 0x000000,
            width: isChild ? 2 : 6
        });
        isChild;
        return rect;
    }
    static genLabel(_label, coord) {
        const label = new $iuB9z.Text({
            text: _label
        });
        label.anchor.set(0, .5);
        Object.assign(label, coord);
        return label;
    }
    static genArrow(graphic, config, direction) {
        const arrowCoord = {
            x: config.x + config.width / 2 - 20,
            y: config.y
        };
        const offsetY = direction == "up" ? -5 : 5;
        graphic.clear().moveTo(arrowCoord.x, arrowCoord.y - offsetY).lineTo(arrowCoord.x + 10, arrowCoord.y + offsetY).lineTo(arrowCoord.x - 10, arrowCoord.y + offsetY);
        graphic.fill(0x000000);
    }
    static genMask(config, length) {
        const x = config.x - config.width / 2 - 4;
        const y = config.y - config.height / 2 - 3;
        const w = config.width + 8;
        const h = config.height * (length + 1.5);
        const graphic = new $iuB9z.Graphics().rect(x, y, w, h).fill(0xFF0000);
        return graphic;
    }
}



var $6m47o = parcelRequire("6m47o");

var $1PAc2 = parcelRequire("1PAc2");
class $26f52a1404854032$export$2e2bcd8739ae039 extends (0, $1PAc2.default) {
    constructor(Container, properties, duration, _easing){
        super();
        const easing = _easing || (0, $6m47o.default).Easing.Linear.None;
        new (0, $6m47o.default).Tween(Container).to(properties, duration).easing(easing).start();
    }
}



var $16Wgx = parcelRequire("16Wgx");

var $16HUD = parcelRequire("16HUD");
class $739ee575fda47f65$export$2e2bcd8739ae039 extends $iuB9z.Container {
    Layers = (0, $9ec1t.default).getInstance();
    items;
    selectedItemIndex;
    config;
    arrow = new $iuB9z.Graphics();
    SelectBoxMainCon = new $iuB9z.Container();
    SelectBoxCon = new $iuB9z.Container();
    SelectBoxItemCon = new $iuB9z.Container();
    defaultSBICY;
    constructor(items, selectedItemIndex, config){
        super();
        this.items = items;
        this.selectedItemIndex = selectedItemIndex;
        this.config = config;
        this.defaultSBICY = -(this.config.height * this.items.length + 10);
        this.addSelectBoxItem(this.items[this.selectedItemIndex]);
        this.addContainers();
        this.addList();
        this.addMask();
        this.addToLayer();
    }
    addContainers() {
        this.SelectBoxMainCon.addChild(this.SelectBoxItemCon, this.SelectBoxCon);
        this.SelectBoxItemCon.y = this.defaultSBICY;
        this.addChild(this.SelectBoxMainCon);
    }
    addToLayer = ()=>this.Layers.UI.addChild(this);
    addList = ()=>this.items.forEach((item, index)=>this.addSelectBoxItem(item, index + 1));
    addMask = ()=>this.SelectBoxMainCon.mask = this.addChild((0, $8f06501bcb3117cd$export$2e2bcd8739ae039).genMask(this.config, this.items.length));
    addSelectBoxItem(sbItem, index) {
        let con = index ? this.SelectBoxItemCon : this.SelectBoxCon;
        const label = index ? sbItem.label : this.config.header ? this.config.header : sbItem.label;
        const item = con.addChild((0, $8f06501bcb3117cd$export$2e2bcd8739ae039).genItemCon(this.config, label, index));
        if (!index) {
            (0, $8f06501bcb3117cd$export$2e2bcd8739ae039).genArrow(this.arrow, this.config, "up");
            con.addChild(this.arrow);
        }
        const handleDownFunc = ()=>{
            if (!index) {
                let target = this.defaultSBICY;
                if (this.SelectBoxItemCon.y == this.defaultSBICY) {
                    target = this.config.y + 20;
                    (0, $8f06501bcb3117cd$export$2e2bcd8739ae039).genArrow(this.arrow, this.config, "down");
                } else {
                    this.defaultSBICY;
                    (0, $8f06501bcb3117cd$export$2e2bcd8739ae039).genArrow(this.arrow, this.config, "up");
                }
                new (0, $26f52a1404854032$export$2e2bcd8739ae039)(this.SelectBoxItemCon, {
                    "y": target
                }, 800, (0, $6m47o.default).Easing.Quadratic.Out);
            } else if (index != this.selectedItemIndex + 1) sbItem.onHandle();
        };
        (0, $16Wgx.default)(item, {
            handleDownFunc: handleDownFunc
        }, (0, $16HUD.CustomCursorType).pointer);
    }
}




class $d49b4bd55920a39a$export$2e2bcd8739ae039 extends $iuB9z.Container {
    Panel = (0, $c5e393fa88a2b6ba$export$2e2bcd8739ae039).getInstance();
    AnimateButton;
    SelectBox;
    SheetSelectBox;
    qTCheckboxArr = [];
    qCboxesStatus = {
        [`${(0, $f443dc34377ca450$export$51940fbbacba35d4).TYPE1}`]: true,
        [`${(0, $f443dc34377ca450$export$51940fbbacba35d4).TYPE2}`]: true
    };
    constructor(){
        super();
        this.addCheckBoxes();
        this.addButtons();
        this.addToLayer();
        (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).on((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).setTracingMode, (v)=>this.AnimateButton.visible = v);
    }
    addToLayer = ()=>this.Panel.addChild(this);
    addButtons() {
        this.addChild((0, $af81f312419f67e3$export$2e2bcd8739ae039).genGoToTestModeButton(), (0, $af81f312419f67e3$export$2e2bcd8739ae039).genGenRandomlyQuestionButton(), (0, $af81f312419f67e3$export$2e2bcd8739ae039).genShowSolutionButton(), (0, $af81f312419f67e3$export$2e2bcd8739ae039).genTracingPaperButton(), (0, $af81f312419f67e3$export$2e2bcd8739ae039).genHintButton());
        this.AnimateButton = this.addChild((0, $af81f312419f67e3$export$2e2bcd8739ae039).genAnimateButton());
        this.SheetSelectBox = this.addChild(new (0, $739ee575fda47f65$export$2e2bcd8739ae039)((0, $63c2c194f5a6a92c$export$4572f3c647ad65e9), 0, (0, $63c2c194f5a6a92c$export$4ac00bd64839f05b)));
        this.SelectBox = this.addChild(new (0, $739ee575fda47f65$export$2e2bcd8739ae039)((0, $63c2c194f5a6a92c$export$5528ee5ae3e79a92), 3, (0, $63c2c194f5a6a92c$export$6d7df9fc320dfb0e)));
    }
    addCheckBoxes() {
        const handleFunc = (type, v)=>{
            this.qCboxesStatus[`${type}`] = v;
            if (!this.qCboxesStatus.TYPE1 && !this.qCboxesStatus.TYPE2) {
                const is1 = type == (0, $f443dc34377ca450$export$51940fbbacba35d4).TYPE1;
                this.qCboxesStatus[`${is1 ? (0, $f443dc34377ca450$export$51940fbbacba35d4).TYPE2 : (0, $f443dc34377ca450$export$51940fbbacba35d4).TYPE1}`] = true;
                this.qTCheckboxArr[is1 ? "1" : "0"].setChecked(true);
            }
            (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).emit((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).setActiveQuestionType, this.qCboxesStatus);
        };
        this.qTCheckboxArr = [
            (0, $f443dc34377ca450$export$51940fbbacba35d4).TYPE1,
            (0, $f443dc34377ca450$export$51940fbbacba35d4).TYPE2
        ].map((t)=>(0, $af81f312419f67e3$export$2e2bcd8739ae039).genTypeCheckbox(t, (v)=>handleFunc(t, v)));
        this.qTCheckboxArr.forEach((c)=>c.addToCon(this));
    }
}



var $iuB9z = parcelRequire("iuB9z");




var $iuB9z = parcelRequire("iuB9z");


var $ad4ha = parcelRequire("ad4ha");

var $2UGuq = parcelRequire("2UGuq");
function $fdfff4aaf7bc5207$export$47ed31abc613cf55(text) {
    const header = new $iuB9z.Text({
        text: text
    });
    header.style = {
        fontWeight: "600",
        fontSize: 30
    };
    header.anchor.set(.5);
    header.position.set(0, -68);
    header.eventMode = "none";
    return header;
}
function $fdfff4aaf7bc5207$export$898bcedaee477986() {
    const graphs = {
        line: new $iuB9z.Graphics(),
        point: new $iuB9z.Graphics(),
        pencil: new $iuB9z.Graphics(),
        compass: new $iuB9z.Graphics()
    };
    const line = $fdfff4aaf7bc5207$export$2e2bcd8739ae039.drawStandartLine(graphs.line, 0x000000);
    //const linedouble = DrawingToolsManagerFactory.drawLine(9, 0xCCCCCC);
    //const lineWithDirSym = DrawingToolsManagerFactory.drawLineWithDirSym(6, 0xFF0000);
    const point = $fdfff4aaf7bc5207$export$2e2bcd8739ae039.drawPoint(graphs.point, 0x000000);
    const CLR = $fdfff4aaf7bc5207$export$2e2bcd8739ae039.createCLRText();
    const returnBack = $fdfff4aaf7bc5207$export$2e2bcd8739ae039.drawreturn();
    const pencil = $fdfff4aaf7bc5207$export$2e2bcd8739ae039.drawPencilIcon(graphs.pencil, 0x000000);
    const ruler = $fdfff4aaf7bc5207$export$2e2bcd8739ae039.drawRuler();
    const protractor = $fdfff4aaf7bc5207$export$2e2bcd8739ae039.drawProtractor();
    const compass = $fdfff4aaf7bc5207$export$2e2bcd8739ae039.drawCompass(graphs.compass, 0x000000);
    return [
        // { icon: linedouble, name: DrawingTool.doubleLine },
        {
            icon: line,
            name: (0, $f443dc34377ca450$export$ec63e05e2ee9f6fc).line
        },
        {
            icon: pencil,
            name: (0, $f443dc34377ca450$export$ec63e05e2ee9f6fc).pencil
        },
        {
            icon: point,
            name: (0, $f443dc34377ca450$export$ec63e05e2ee9f6fc).point
        },
        {
            icon: returnBack,
            name: (0, $f443dc34377ca450$export$ec63e05e2ee9f6fc).returnBack
        },
        // { icon: lineWithDirSym, name: DrawingTool.lineWithDirSym },
        {
            icon: protractor,
            name: (0, $f443dc34377ca450$export$ec63e05e2ee9f6fc).protractor
        },
        {
            icon: ruler,
            name: (0, $f443dc34377ca450$export$ec63e05e2ee9f6fc).ruler
        },
        {
            icon: compass,
            name: (0, $f443dc34377ca450$export$ec63e05e2ee9f6fc).compass
        },
        {
            icon: CLR,
            name: (0, $f443dc34377ca450$export$ec63e05e2ee9f6fc).clear
        }
    ];
}
class $fdfff4aaf7bc5207$export$2e2bcd8739ae039 {
    static drawStandartLine(line, color) {
        return this.drawLine(line, 6, color);
    }
    static drawLine(line, width, color) {
        return line.clear().moveTo(-15, 15).lineTo(15, -15).stroke({
            color: color,
            width: width,
            cap: "round"
        });
    }
    /* static drawLineWithDirSym(width: number, color: number) {
     return this.drawLine(width, color)
       .moveTo(-12, -3)
       .lineTo(3, -3)
       .lineTo(3, 12)
       .stroke({ color, width, cap: "round" })
   }*/ static drawPoint(circle, color) {
        return circle.clear().circle(0, 0, 13).fill(color);
    }
    static createCLRText() {
        const clrText = new $iuB9z.Text({
            text: "CLR"
        });
        clrText.anchor.set(.5);
        return clrText;
    }
    static drawreturn() {
        return new $iuB9z.Graphics().arc(0, 0, 15, -Math.PI / 2, Math.PI).stroke({
            width: 4,
            color: 0x000000
        }).moveTo(0, -20).lineTo(-12, -10).lineTo(3, -8).fill(0x000000);
    }
    static drawPencilIcon(pencil, color) {
        (0, $ad4ha.drawPencil)(pencil, color, {
            x: 0,
            y: 15
        });
        pencil.rotation = Math.PI / 4;
        return pencil;
    }
    static drawRuler() {
        const rulerIcon = new $iuB9z.Graphics();
        rulerIcon.moveTo(-24, -7).lineTo(-24, 7).lineTo(24, 7).lineTo(24, -7).fill(0xFC99C4);
        Array(7).fill(null).forEach((e, eI)=>{
            const x = -24 + (eI + 1) * 6;
            rulerIcon.moveTo(x, -7).lineTo(x, -1).stroke({
                width: 1,
                color: 0x000000,
                alpha: .6
            });
        });
        rulerIcon.rotation = -Math.PI / 4;
        return rulerIcon;
    }
    static drawProtractor() {
        const unitAngle = -Math.PI / 10;
        const radius = 25;
        const protractor = new $iuB9z.Graphics();
        protractor.moveTo(0, 7).arc(0, 7, radius, Math.PI, 0).lineTo(radius, 7).lineTo(-radius, 7).fill(0xFC99C4);
        Array(9).fill(null).forEach((e, eI)=>{
            const rad = unitAngle * (eI + 1);
            const startCoord = (0, $2UGuq.default)(rad, 25);
            const endCoord = (0, $2UGuq.default)(rad, 18);
            protractor.moveTo(startCoord.x, startCoord.y + 7).lineTo(endCoord.x, endCoord.y + 7).stroke({
                width: 1,
                color: 0x000000,
                alpha: .6
            });
        });
        protractor.rotation = -Math.PI / 4;
        return protractor;
    }
    static drawCompass(compass, color) {
        const BLUE = 0x0195b8;
        const DARK_BLUE = 0x015f78;
        compass.clear().moveTo(-16, 24).lineTo(0, -11).stroke({
            width: 2,
            color: 0xD0D0D0
        })// pencil start
        .moveTo(14, 18).lineTo(11, -11).stroke({
            width: 4,
            color: color
        }).moveTo(14, 24).lineTo(12, 18).lineTo(16, 18).lineTo(14, 24).fill(0xD0D0D0)// pencil end
        // left leg
        .moveTo(-12, 16).lineTo(0, -11).stroke({
            width: 5,
            color: BLUE,
            cap: "round"
        })// right leg start
        .moveTo(18, 8).lineTo(10, 10).lineTo(0, -11).stroke({
            width: 4,
            color: BLUE,
            cap: "round"
        }).moveTo(16, 4).lineTo(18, 12).stroke({
            width: 2,
            color: DARK_BLUE
        })// right leg end
        // head start
        .moveTo(0, -11).lineTo(0, -25).stroke({
            width: 2,
            color: DARK_BLUE,
            cap: "round"
        }).moveTo(0, -11).lineTo(0, -17).stroke({
            width: 6,
            color: DARK_BLUE,
            cap: "round"
        }).moveTo(0, -14).circle(0, -14, 1.5).fill(0xD0D0D0);
        // head end
        return compass;
    }
}



function $31980bf168455869$export$d867004e4e40509c(index) {
    const x = -105 + index % 4 * 70;
    const y = 0 + (index < 4 ? 0 : 70);
    return {
        x: x,
        y: y,
        width: 64,
        height: 64
    };
}



var $iuB9z = parcelRequire("iuB9z");

const $db96229a04d1be32$export$ca8f2c484d507a5d = 12;
const $db96229a04d1be32$export$fc40f6c0e3b6831d = 8;
const $db96229a04d1be32$export$9637731d4e084bb4 = {
    x: 0,
    y: 0,
    width: 2 * $db96229a04d1be32$export$ca8f2c484d507a5d,
    height: 2 * $db96229a04d1be32$export$ca8f2c484d507a5d,
    defaultBgColor: 0xFF0000,
    pressedBgColor: 0xFFFFFF,
    border: false,
    borderRadius: $db96229a04d1be32$export$ca8f2c484d507a5d
};
const $db96229a04d1be32$export$56d196d2844d1ca1 = [
    0x333333,
    0x4A90E2,
    0x50E3C2,
    0xB8E986,
    0xF8E71C,
    0xF5A623,
    0xD0021B,
    0xBD10E0,
    0x9013FE,
    0x417505,
    0x223344,
    0xFC99C4
];



var $iuB9z = parcelRequire("iuB9z");

class $f587ead976a68e1b$export$2e2bcd8739ae039 extends $iuB9z.Graphics {
    color;
    constructor(color){
        super(), this.color = color;
        this.draw();
    }
    draw(isStroked = false) {
        this.clear().circle(0, 0, (0, $db96229a04d1be32$export$ca8f2c484d507a5d)).fill(this.color);
        if (isStroked) this.circle(0, 0, (0, $db96229a04d1be32$export$ca8f2c484d507a5d) + 4).fill({
            color: 0x000000,
            alpha: 0
        }).stroke({
            width: 1.5,
            color: 0x000000
        });
    }
}



var $16Wgx = parcelRequire("16Wgx");

var $16HUD = parcelRequire("16HUD");
class $09c9f4bb392d1094$export$2e2bcd8739ae039 extends $iuB9z.Container {
    onHandle;
    onHandleSec;
    buttons;
    bg;
    constructor(coord, width, onHandle, onHandleSec){
        super(), this.onHandle = onHandle, this.onHandleSec = onHandleSec, this.buttons = [], this.bg = this.addChild(new $iuB9z.Graphics()), this.getButtons = ()=>this.buttons;
        this.position.copyFrom(coord);
        this.drawBg(width);
        this.drawColorCircles(width);
    }
    getButtons;
    drawColorCircles(width) {
        const unit = width / (0, $db96229a04d1be32$export$56d196d2844d1ca1).length;
        const sX = -width / 2;
        this.buttons = (0, $db96229a04d1be32$export$56d196d2844d1ca1).map((c, cI)=>{
            const _x = sX + unit * (cI + .5);
            const circle = new (0, $f587ead976a68e1b$export$2e2bcd8739ae039)(c);
            (0, $db96229a04d1be32$export$9637731d4e084bb4).x = _x;
            const button = new (0, $035d220cf9b861a9$export$2e2bcd8739ae039)((0, $db96229a04d1be32$export$9637731d4e084bb4), circle, false, ()=>this.onHandle(cI), ()=>this.onHandleSec());
            this.addChild(button);
            return button;
        });
    }
    drawBg(width) {
        const sX = -width / 2;
        this.bg.roundRect(sX, -(0, $db96229a04d1be32$export$ca8f2c484d507a5d) - (0, $db96229a04d1be32$export$fc40f6c0e3b6831d), width, 2 * ((0, $db96229a04d1be32$export$ca8f2c484d507a5d) + (0, $db96229a04d1be32$export$fc40f6c0e3b6831d)), 6).fill({
            color: 0x000000,
            alpha: .05
        });
        (0, $16Wgx.default)(this.bg, {}, (0, $16HUD.CustomCursorType).default);
    }
}



class $1d041507d44a69df$export$2e2bcd8739ae039 {
    ColorOptionConRenderer;
    Buttons = [];
    constructor(centerCoord, conWidth){
        this.ColorOptionConRenderer = new (0, $09c9f4bb392d1094$export$2e2bcd8739ae039)(centerCoord, conWidth, this.onHandleButton, this.onHandleSecButton);
        this.Buttons = this.ColorOptionConRenderer.getButtons();
        setTimeout(()=>{
            this.setSelectedButton(0);
        }, 10);
    }
    setAllDisabled = (v)=>this.Buttons.forEach((b)=>b.setDisabled(v));
    onHandleButton = (index)=>this.setSelectedButton(index);
    onHandleSecButton = ()=>{};
    addToCon = (con)=>con.addChild(this.ColorOptionConRenderer);
    setSelectedButton(index) {
        this.Buttons.forEach((b, bI)=>{
            const icon = b.icon;
            icon.draw(bI == index);
            if (bI !== index) return b.closeButton();
            (0, $3a1e36f612556c4f$export$b4e79357afe2d23).emit((0, $3a1e36f612556c4f$export$37042196a764db52).selectedColor, icon.color);
        });
    }
}




function $818105c633098145$export$20e1f29129b2d51(toolName, setSelectedTool) {
    const onHandleFunc = ()=>$818105c633098145$var$genHandleFunc(toolName, undefined, (toolName)=>setSelectedTool(toolName));
    const onHandleSecondFunc = ()=>{
        if (toolName == (0, $f443dc34377ca450$export$ec63e05e2ee9f6fc).clear || toolName == (0, $f443dc34377ca450$export$ec63e05e2ee9f6fc).returnBack) $818105c633098145$var$genHandleFunc(toolName, undefined, (toolName)=>setSelectedTool(toolName));
        else if (toolName == (0, $f443dc34377ca450$export$ec63e05e2ee9f6fc).ruler || toolName == (0, $f443dc34377ca450$export$ec63e05e2ee9f6fc).protractor || toolName == (0, $f443dc34377ca450$export$ec63e05e2ee9f6fc).compass) $818105c633098145$var$genHandleFunc(toolName, true, (toolName)=>setSelectedTool(toolName));
        else $818105c633098145$var$genHandleFunc((0, $f443dc34377ca450$export$ec63e05e2ee9f6fc).empty, undefined, (toolName)=>setSelectedTool(toolName));
    };
    return {
        onHandleFunc: onHandleFunc,
        onHandleSecondFunc: onHandleSecondFunc
    };
}
function $818105c633098145$var$genHandleFunc(tool, isSecond = false, setSelectedTool) {
    if (tool == (0, $f443dc34377ca450$export$ec63e05e2ee9f6fc).clear) (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).emit((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).clearAll);
    else if (tool == (0, $f443dc34377ca450$export$ec63e05e2ee9f6fc).returnBack) (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).emit((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).delLastDrawing);
    else {
        const color = tool.includes("RED") ? 0xff0000 : tool.includes("BLUE") ? 0x0000FF : undefined;
        setSelectedTool(tool);
        (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).emit((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).setSelectedTool, tool, color);
        if (tool == (0, $f443dc34377ca450$export$ec63e05e2ee9f6fc).ruler) (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).emit((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).showRuler, !isSecond);
        if (tool == (0, $f443dc34377ca450$export$ec63e05e2ee9f6fc).protractor) (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).emit((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).showProtractor, !isSecond);
        if (tool == (0, $f443dc34377ca450$export$ec63e05e2ee9f6fc).compass) (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).emit((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).showCompass, !isSecond);
    }
}



class $14973a1689ee6a6d$export$2e2bcd8739ae039 extends $iuB9z.Container {
    Panel = (0, $c5e393fa88a2b6ba$export$2e2bcd8739ae039).getInstance();
    Buttons = [];
    ColorOptionCon = new (0, $1d041507d44a69df$export$2e2bcd8739ae039)({
        x: 0,
        y: this.Panel.height - 40
    }, 420);
    constructor(){
        super();
        this.addCoord();
        this.addHeader();
        this.addButtons();
        this.addToPanel();
        this.ColorOptionCon.addToCon(this.Panel);
        (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).on((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).startAnswer, (v)=>this.setButtonDisabled(v));
        (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).on((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).showResults, ()=>this.setButtonDisabled(true, true));
        (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).on((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).setQuestMode, ()=>this.setButtonDisabled(false, true));
        (0, $3a1e36f612556c4f$export$b4e79357afe2d23).on((0, $3a1e36f612556c4f$export$37042196a764db52).selectedColor, (color)=>this.setIconColors(color));
    }
    addToPanel = ()=>this.Panel.addChild(this);
    addHeader = ()=>this.addChild((0, $fdfff4aaf7bc5207$export$47ed31abc613cf55)("Drawing Tools"));
    addCoord = ()=>this.position.copyFrom({
            x: 0,
            y: this.Panel.height - 180
        });
    setSelectedTool(toolName) {
        this.Buttons.forEach((b)=>b.name !== toolName && b.button.handleDefaultPosition());
        toolName !== (0, $f443dc34377ca450$export$ec63e05e2ee9f6fc).ruler && (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).emit((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).showRuler, false);
        toolName !== (0, $f443dc34377ca450$export$ec63e05e2ee9f6fc).protractor && (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).emit((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).showProtractor, false);
        toolName !== (0, $f443dc34377ca450$export$ec63e05e2ee9f6fc).compass && (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).emit((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).showCompass, false);
    }
    setButtonDisabled(v, forAll = false) {
        this.Buttons.forEach((b)=>{
            if (!forAll && (b.name === (0, $f443dc34377ca450$export$ec63e05e2ee9f6fc).clear || b.name === (0, $f443dc34377ca450$export$ec63e05e2ee9f6fc).returnBack)) return;
            b.button.setDisabled(v);
        });
        forAll && this.ColorOptionCon.setAllDisabled(v);
    }
    addButtons() {
        const icons = (0, $fdfff4aaf7bc5207$export$898bcedaee477986)();
        this.Buttons = icons.map((iconObj, iI)=>{
            const bounds = (0, $31980bf168455869$export$d867004e4e40509c)(iI);
            const isActiveButton = iconObj.name !== (0, $f443dc34377ca450$export$ec63e05e2ee9f6fc).clear && iconObj.name !== (0, $f443dc34377ca450$export$ec63e05e2ee9f6fc).returnBack;
            const { onHandleFunc: onHandleFunc, onHandleSecondFunc: onHandleSecondFunc } = (0, $818105c633098145$export$20e1f29129b2d51)(iconObj.name, (toolName)=>this.setSelectedTool(toolName));
            const toolButton = new (0, $035d220cf9b861a9$export$2e2bcd8739ae039)(bounds, iconObj.icon, isActiveButton, onHandleFunc, onHandleSecondFunc);
            this.addChild(toolButton);
            return {
                button: toolButton,
                name: iconObj.name
            };
        });
    }
    setIconColors(color) {
        this.Buttons.forEach((b)=>{
            const icon = b.button.icon;
            if (b.name == (0, $f443dc34377ca450$export$ec63e05e2ee9f6fc).point) (0, $fdfff4aaf7bc5207$export$2e2bcd8739ae039).drawPoint(icon, color);
            else if (b.name == (0, $f443dc34377ca450$export$ec63e05e2ee9f6fc).pencil) (0, $fdfff4aaf7bc5207$export$2e2bcd8739ae039).drawPencilIcon(icon, color);
            else if (b.name == (0, $f443dc34377ca450$export$ec63e05e2ee9f6fc).line) (0, $fdfff4aaf7bc5207$export$2e2bcd8739ae039).drawStandartLine(icon, color);
            else if (b.name == (0, $f443dc34377ca450$export$ec63e05e2ee9f6fc).compass) (0, $fdfff4aaf7bc5207$export$2e2bcd8739ae039).drawCompass(icon, color);
        });
    }
}



var $iuB9z = parcelRequire("iuB9z");


var $iuB9z = parcelRequire("iuB9z");

var $2UGuq = parcelRequire("2UGuq");

var $eymUv = parcelRequire("eymUv");
const $0f8a317945c59d9c$var$PIE_TIMER_RADIUS = 8;
const $0f8a317945c59d9c$var$BG_COLOR = 0xdbf8ff;
const $0f8a317945c59d9c$var$STROKE_COLOR = 0x0195b8;
class $0f8a317945c59d9c$export$2e2bcd8739ae039 {
    static formatTimerText(_sec) {
        const oneMin = 60;
        const oneHour = oneMin * 60;
        const hours = Math.floor(_sec / oneHour);
        const remainSec = _sec - hours * oneHour;
        const mins = Math.floor(remainSec / oneMin);
        const seconds = remainSec - mins * oneMin;
        return `${hours > 0 ? `${hours}h ` : ""}${mins > 0 ? `${mins}m ` : ""}${_sec > 0 ? seconds : "0"}s left`;
    }
    static drawInitTimerText(timer) {
        timer.anchor.set(0, .5);
        timer.style = {
            fill: $0f8a317945c59d9c$var$STROKE_COLOR,
            fontSize: 16
        };
        timer.x = $0f8a317945c59d9c$var$PIE_TIMER_RADIUS * 1.5;
    }
    static drawPieTimer(pieTimer, initSeconds, currSeconds) {
        const startAngle = -Math.PI / 2;
        const endAngle = -(0, $eymUv.default)(currSeconds / initSeconds * 360) + startAngle;
        const startCoord = (0, $2UGuq.default)(startAngle, $0f8a317945c59d9c$var$PIE_TIMER_RADIUS);
        pieTimer.clear().moveTo(0, 0).circle(0, 0, $0f8a317945c59d9c$var$PIE_TIMER_RADIUS).stroke({
            width: 2,
            color: $0f8a317945c59d9c$var$STROKE_COLOR
        }).moveTo(startCoord.x, startCoord.y).arc(0, 0, $0f8a317945c59d9c$var$PIE_TIMER_RADIUS, startAngle, endAngle, true).lineTo(0, 0).lineTo(startCoord.x, startCoord.y).fill($0f8a317945c59d9c$var$STROKE_COLOR);
    }
    static drawBg(bg, textX, textWidth) {
        const w = $0f8a317945c59d9c$var$PIE_TIMER_RADIUS + textX + textWidth + 16;
        bg.clear().roundRect(-14, -14, w, 28, 14).fill({
            color: $0f8a317945c59d9c$var$BG_COLOR
        });
    }
}


class $791773d8c455bb1b$export$2e2bcd8739ae039 extends $iuB9z.Container {
    con;
    initSeconds;
    bg;
    PieTimer;
    TimerText;
    constructor(con, coord, initSeconds){
        super(), this.con = con, this.initSeconds = initSeconds, this.bg = this.addChild(new $iuB9z.Graphics()), this.PieTimer = this.addChild(new $iuB9z.Graphics()), this.TimerText = this.addChild(new $iuB9z.Text()), this.addToCon = ()=>this.con.addChild(this), this.drawInit = ()=>(0, $0f8a317945c59d9c$export$2e2bcd8739ae039).drawInitTimerText(this.TimerText), this.deactiveEventMode = ()=>[
                this.bg,
                this.PieTimer,
                this.TimerText
            ].forEach((e)=>e.eventMode = "none");
        this.addToCon();
        this.deactiveEventMode();
        this.drawInit();
        this.position.copyFrom(coord);
    }
    addToCon;
    drawInit;
    deactiveEventMode;
    draw(seconds) {
        this.TimerText.text = (0, $0f8a317945c59d9c$export$2e2bcd8739ae039).formatTimerText(seconds);
        (0, $0f8a317945c59d9c$export$2e2bcd8739ae039).drawPieTimer(this.PieTimer, this.initSeconds, seconds);
        (0, $0f8a317945c59d9c$export$2e2bcd8739ae039).drawBg(this.bg, this.TimerText.x, this.TimerText.width);
    }
}


class $a2b41efee2f65db4$export$2e2bcd8739ae039 {
    options;
    TimerRenderer;
    InitialSeconds;
    totalSeconds;
    timerInterval;
    constructor(con, coord, options = {}){
        this.options = options;
        this.setTotalSeconds();
        this.TimerRenderer = new (0, $791773d8c455bb1b$export$2e2bcd8739ae039)(con, coord, this.totalSeconds);
        this.TimerRenderer.draw(this.totalSeconds);
    }
    setTotalSeconds() {
        if (typeof this.options == "number") this.totalSeconds = this.options;
        else {
            const { hours: hours, minutes: minutes, seconds: seconds } = this.options;
            this.totalSeconds = ((hours || 0) * 60 + (minutes || 0)) * 60 + (seconds || 0);
        }
        this.InitialSeconds = this.totalSeconds;
    }
    reset() {
        clearInterval(this.timerInterval);
        this.totalSeconds = this.InitialSeconds;
        this.TimerRenderer.draw(this.totalSeconds);
    }
    start() {
        this.TimerRenderer.draw(this.totalSeconds);
        this.timerInterval = setInterval(()=>{
            this.totalSeconds--;
            this.TimerRenderer.draw(this.totalSeconds);
            this.totalSeconds == 0 && clearInterval(this.timerInterval);
        }, 1000);
    }
}




var $erVR3 = parcelRequire("erVR3");




const $162002ea369d4ce2$var$emptyFunc = ()=>{};
class $162002ea369d4ce2$export$2e2bcd8739ae039 {
    static genGoToTestModeButton() {
        let button;
        const onHandleFunc = ()=>{
            (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).emit((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).setQuestMode, (0, $f443dc34377ca450$export$b4d15339b5fb8fcc).practise);
            setTimeout(()=>button.closeButton(), 200);
        };
        const onHandleSecondFunc = ()=>{};
        const sButtonStyle = (0, $63c2c194f5a6a92c$export$51b86c66d1b1665c).gotoPractiseMode;
        button = (0, $d2ff14cd0958f199$export$2e2bcd8739ae039)("Go To Practise Mode", onHandleFunc, onHandleSecondFunc, sButtonStyle, undefined, false);
        return button;
    }
    static genGenNextQuestionButton() {
        let button;
        (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).on((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).startAnswer, (v)=>v && button.setDisabled(true));
        (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).on((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).saveAnswer, ()=>button.setDisabled(false));
        const onHandleFunc = ()=>{
            (0, $erVR3.rootEventBus).emit((0, $erVR3.EnumRootEventBus).cancelledCircleAnim);
            (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).emit((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).setSelectedTool, (0, $f443dc34377ca450$export$ec63e05e2ee9f6fc).empty);
            (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).emit((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).newQuestion);
            (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).emit((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).startAnswer, false);
            (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).emit((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).clearAll);
            setTimeout(()=>button.closeButton(), 200);
        };
        const sButtonStyle = (0, $63c2c194f5a6a92c$export$51b86c66d1b1665c).nextQuestion;
        return button = (0, $d2ff14cd0958f199$export$2e2bcd8739ae039)("Generate Next Question", onHandleFunc, $162002ea369d4ce2$var$emptyFunc, sButtonStyle, undefined, false);
    }
    static genShowResults() {
        let button;
        const onHandleFunc = ()=>{
            (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).emit((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).showResults);
            setTimeout(()=>button.closeButton(), 200);
        };
        const sButtonStyle = (0, $63c2c194f5a6a92c$export$51b86c66d1b1665c).nextQuestion;
        return button = (0, $d2ff14cd0958f199$export$2e2bcd8739ae039)("Show Results", onHandleFunc, $162002ea369d4ce2$var$emptyFunc, sButtonStyle, undefined, false);
    }
    static genStartAnswerButton() {
        let DAT = (0, $f443dc34377ca450$export$ec63e05e2ee9f6fc).answerLine;
        let button;
        const setAnswerMode = (v)=>{
            (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).emit((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).startAnswer, v);
            if (v) return (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).emit((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).setSelectedTool, DAT);
            button.closeButton();
            (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).emit((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).setSelectedTool, (0, $f443dc34377ca450$export$ec63e05e2ee9f6fc).empty);
        };
        (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).on((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).questionType, (type)=>{
            DAT = type == (0, $f443dc34377ca450$export$51940fbbacba35d4).TYPE1 ? (0, $f443dc34377ca450$export$ec63e05e2ee9f6fc).answerLine : (0, $f443dc34377ca450$export$ec63e05e2ee9f6fc).answerPoint;
            button.closeButton();
        });
        (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).on((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).saveAnswer, ()=>setAnswerMode(false));
        const onHandleFunc = ()=>setAnswerMode(true);
        const onHandleSecondFunc = ()=>setAnswerMode(false);
        const sButtonStyle = (0, $63c2c194f5a6a92c$export$51b86c66d1b1665c).giveAnswer;
        return button = (0, $d2ff14cd0958f199$export$2e2bcd8739ae039)("Start Answer", onHandleFunc, onHandleSecondFunc, sButtonStyle, undefined, false);
    }
    static genSaveAnswerButton() {
        let button;
        const onHandleFunc = ()=>{
            (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).emit((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).saveAnswer);
            setTimeout(()=>button.closeButton(), 200);
        };
        const sButtonStyle = (0, $63c2c194f5a6a92c$export$51b86c66d1b1665c).saveAnswer;
        return button = (0, $d2ff14cd0958f199$export$2e2bcd8739ae039)("Save Answer", onHandleFunc, $162002ea369d4ce2$var$emptyFunc, sButtonStyle, undefined, false);
    }
    static genGoToPractiseButton() {
        let button;
        const onHandleFunc = ()=>{
            (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).emit((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).setQuestMode, (0, $f443dc34377ca450$export$b4d15339b5fb8fcc).practise);
            setTimeout(()=>button.closeButton(), 200);
        };
        const sButtonStyle = (0, $63c2c194f5a6a92c$export$51b86c66d1b1665c).goToPractise;
        return button = (0, $d2ff14cd0958f199$export$2e2bcd8739ae039)("Go To Practise", onHandleFunc, $162002ea369d4ce2$var$emptyFunc, sButtonStyle, undefined, false);
    }
    static genTryAgainButton() {
        let button;
        const onHandleFunc = ()=>{
            (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).emit((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).setQuestMode, (0, $f443dc34377ca450$export$b4d15339b5fb8fcc).test);
            setTimeout(()=>button.closeButton(), 200);
        };
        const sButtonStyle = (0, $63c2c194f5a6a92c$export$51b86c66d1b1665c).tryAgain;
        return button = (0, $d2ff14cd0958f199$export$2e2bcd8739ae039)("Try Again", onHandleFunc, $162002ea369d4ce2$var$emptyFunc, sButtonStyle, undefined, false);
    }
}




var $iuB9z = parcelRequire("iuB9z");

var $iuB9z = parcelRequire("iuB9z");
const $930790a1d8d9efd8$var$W = 40;
const $930790a1d8d9efd8$var$H = 25;
var $930790a1d8d9efd8$export$df2e18999f2282d0 = /*#__PURE__*/ function(NavigatorColor) {
    NavigatorColor["default"] = "0xFFFFFF";
    NavigatorColor["prev"] = "0x21D4FE";
    NavigatorColor["curr"] = "0xFC99C4";
    NavigatorColor["true"] = "0x00FF00";
    NavigatorColor["false"] = "0xFF0000";
    NavigatorColor["null"] = "0xE0E0E0";
    return NavigatorColor;
}({});
class $930790a1d8d9efd8$export$2e2bcd8739ae039 extends $iuB9z.Container {
    bg = this.addChild(new $iuB9z.Graphics());
    num = this.addChild(new $iuB9z.Text());
    constructor(number){
        super();
        this.drawBg("0xFFFFFF");
        this.addNum(number);
    }
    drawBg(color) {
        this.bg.roundRect(-$930790a1d8d9efd8$var$W / 2, -$930790a1d8d9efd8$var$H / 2, $930790a1d8d9efd8$var$W, $930790a1d8d9efd8$var$H, 3).fill(color).stroke({
            width: 1,
            color: 0x232323
        });
    }
    addNum(number) {
        this.num.text = number;
        this.num.anchor.set(.5);
        this.num.style.fontSize = 16;
    }
}



var $16Wgx = parcelRequire("16Wgx");



var $16HUD = parcelRequire("16HUD");
class $3c00829ea5df263b$export$2e2bcd8739ae039 extends $iuB9z.Container {
    TestQuestionManager = (0, $905a2b833cc89373$export$2e2bcd8739ae039).getInstance();
    Navigators = [];
    constructor(){
        super();
        this.addNavigators();
        (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).on((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).saveAnswer, ()=>setTimeout(()=>this.markQuestion(), 100));
        (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).on((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).startTest, ()=>this.markQuestion());
        (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).on((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).setQuestMode, ()=>this.markQuestion(true));
        (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).on((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).checkedAnswers, (arr)=>{
            this.markQuestionWithAnswers(arr);
            this.setEventMode(true);
        });
    }
    setEventMode = (v)=>this.Navigators.forEach((e)=>e.eventMode = v ? "static" : "none");
    addNavigators() {
        const qLength = this.TestQuestionManager.getQuestionCount();
        this.Navigators = Array(qLength).fill(null).map((_, i)=>this.addChild(new (0, $930790a1d8d9efd8$export$2e2bcd8739ae039)(i + 1)));
        this.Navigators.forEach((e, eI)=>{
            const uX = 50;
            const uY = 30;
            const x = uX * (eI % 10 - 4.5);
            const y = 530 + (eI > 9 ? 1 : 0) * uY;
            e.position.copyFrom({
                x: x,
                y: y
            });
            const handleDownFunc = ()=>(0, $f60d53a2fe365b05$export$f6644f0f2c90144b).emit((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).showTestQuestion, eI);
            (0, $16Wgx.default)(e, {
                handleDownFunc: handleDownFunc
            }, (0, $16HUD.CustomCursorType).pointer);
        });
        setTimeout(()=>this.setEventMode(false), 200);
    }
    markQuestion(isReset) {
        const v = isReset ? -1 : this.TestQuestionManager.getAnswersLength();
        this.Navigators.forEach((n, nI)=>{
            nI < v && n.drawBg((0, $930790a1d8d9efd8$export$df2e18999f2282d0).prev);
            nI == v && n.drawBg((0, $930790a1d8d9efd8$export$df2e18999f2282d0).curr);
            nI > v && n.drawBg((0, $930790a1d8d9efd8$export$df2e18999f2282d0).default);
        });
    }
    markQuestionWithAnswers(answers) {
        answers.forEach((n, nI)=>{
            const color = n === null ? (0, $930790a1d8d9efd8$export$df2e18999f2282d0).null : n ? (0, $930790a1d8d9efd8$export$df2e18999f2282d0).true : (0, $930790a1d8d9efd8$export$df2e18999f2282d0).false;
            this.Navigators[nI].drawBg(color);
        });
    }
}



var $6m47o = parcelRequire("6m47o");

var $1PAc2 = parcelRequire("1PAc2");
class $cd55c7b9f87095b8$export$2e2bcd8739ae039 extends (0, $1PAc2.default) {
    constructor(options, onUpdate, onComp){
        const { startVal: startVal, targetVal: targetVal, duration: duration } = options;
        super();
        const obj = {
            v: startVal
        };
        new (0, $6m47o.default).Tween(obj).to({
            v: targetVal
        }, duration).easing((0, $6m47o.default).Easing.Linear.None).onUpdate((obj)=>onUpdate(obj.v)).onComplete(()=>onComp()).start();
    }
}





var $iuB9z = parcelRequire("iuB9z");

var $iuB9z = parcelRequire("iuB9z");

var $9ec1t = parcelRequire("9ec1t");

var $iuB9z = parcelRequire("iuB9z");
class $9a36da4dcbaac787$export$2e2bcd8739ae039 extends $iuB9z.Container {
    butLabel;
    options;
    bgBottom;
    bgMid;
    buttonLabel;
    constructor(butLabel, options){
        super(), this.butLabel = butLabel, this.options = options, this.bgBottom = this.addChild(new $iuB9z.Graphics()), this.bgMid = this.addChild(new $iuB9z.Graphics()), this.drawBottomBg = (color = 0xFFFFFF)=>this.drawBg(this.bgBottom, color), this.drawMidBg = ()=>{
            const color = this.options?.buttonColor || 0x0195b8;
            this.drawBg(this.bgMid, color);
            this.setButtonLabelColor(0xFFFFFF);
        }, this.clearMidBg = ()=>{
            this.bgMid.clear();
            this.setButtonLabelColor(0x333333);
        }, this.setButtonLabelColor = (color)=>this.buttonLabel.style.fill = color;
        this.draw();
    }
    drawBottomBg;
    drawMidBg;
    clearMidBg;
    draw() {
        this.addText();
        this.drawBottomBg();
    }
    drawBg(bg, color) {
        const w = this.buttonLabel.width;
        const h = this.options?.buttonHeight || 40;
        bg.clear().moveTo(-w / 2 - h / 2, -20).roundRect(-w / 2 - 20, -h / 2, w + 40, h, 6).fill(color);
    }
    addText() {
        const fontSize = this.options?.fontSize || 16;
        this.buttonLabel = this.addChild(new $iuB9z.Text());
        this.buttonLabel.text = this.butLabel;
        this.buttonLabel.anchor.set(.5);
        this.buttonLabel.style = {
            fill: 0x333333,
            fontSize: fontSize
        };
    }
    setButtonLabelColor;
}



var $16Wgx = parcelRequire("16Wgx");

var $erVR3 = parcelRequire("erVR3");

var $16HUD = parcelRequire("16HUD");
class $7a70f4c2adce4853$export$2e2bcd8739ae039 {
    eventBusName;
    label;
    _handleDownFunc;
    TopButtonRenderer;
    isSelected;
    constructor(eventBusName, label, _handleDownFunc, options){
        this.eventBusName = eventBusName;
        this.label = label;
        this._handleDownFunc = _handleDownFunc;
        this.isSelected = false;
        this.isOver = (v)=>v ? this.TopButtonRenderer.drawBottomBg(0xEDEDED) : this.TopButtonRenderer.drawBottomBg(0xFFFFFF);
        this.checkIsSelected = ()=>this.isSelected ? this.TopButtonRenderer.drawMidBg() : this.TopButtonRenderer.clearMidBg();
        this.TopButtonRenderer = new (0, $9a36da4dcbaac787$export$2e2bcd8739ae039)(this.label, options);
        (0, $16Wgx.default)(this.TopButtonRenderer, {
            handleOverFunc: ()=>this.isOver(true),
            handleDownFunc: ()=>this.handleDownFunc(),
            handleLeaveFunc: ()=>this.isOver(false)
        }, (0, $16HUD.CustomCursorType).pointer, undefined, true);
        (0, $erVR3.rootEventBus).on((0, $erVR3.EnumRootEventBus).topSwitcherButtonLabel, (eventBusName, label)=>{
            eventBusName == this.eventBusName && (this.isSelected = this.label === label);
            this.checkIsSelected();
        });
    }
    isOver;
    checkIsSelected;
    handleDownFunc() {
        if (this.isSelected) return;
        (0, $erVR3.rootEventBus).emit((0, $erVR3.EnumRootEventBus).topSwitcherButtonLabel, this.eventBusName, this.label);
        this._handleDownFunc();
    }
}



var $16Wgx = parcelRequire("16Wgx");

var $16HUD = parcelRequire("16HUD");
class $d940f5507ea3c2bc$export$2e2bcd8739ae039 extends $iuB9z.Container {
    options;
    Layers;
    bg;
    buttons;
    constructor(TopSwitcherProps, con, options){
        super(), this.options = options, this.Layers = (0, $9ec1t.default).getInstance(), this.bg = this.addChild(new $iuB9z.Graphics()), this.buttons = [], this.addToCon = (con)=>con ? con.addChild(this) : this.Layers.UITop.addChild(this), this.disactiveEventMode = ()=>this.bg.eventMode = "none";
        this.addButtons(TopSwitcherProps.eventBusName, TopSwitcherProps.topButtonsProps);
        this.drawBg();
        this.addToCon(con);
        this.disactiveEventMode();
        this.x = 100;
        this.y = 100;
    }
    addToCon;
    drawBg() {
        const firstButton = this.buttons[0].TopButtonRenderer;
        const lastButton = this.buttons[this.buttons.length - 1].TopButtonRenderer;
        const _wHalf = firstButton.width / 2;
        const _w1 = firstButton.x - _wHalf;
        const _w2 = lastButton.x + lastButton.width / 2;
        const h = firstButton.height;
        const bgColor = this.options?.bgColor || 0xFFFFFF;
        this.bg.roundRect(_w1 - 15, -h / 2 - 4, _w2 + _wHalf + 30, h + 8, 10).fill(bgColor);
        if (this.options?.borderStyle) {
            const { width: width, color: color } = this.options.borderStyle;
            this.bg.stroke({
                width: width,
                color: color
            });
        }
        (0, $16Wgx.default)(this.bg, {}, (0, $16HUD.CustomCursorType).default);
    }
    addButtons(eventBusName, TopButtonsProps) {
        TopButtonsProps.forEach((topButton)=>{
            const button = new (0, $7a70f4c2adce4853$export$2e2bcd8739ae039)(eventBusName, topButton.label, topButton.onHandleDownFunc, this.options);
            this.addChild(button.TopButtonRenderer);
            this.buttons.push(button);
        });
        this.buttons.forEach((button, bI)=>{
            if (bI == 0) return;
            const prevButton = this.buttons[bI - 1].TopButtonRenderer;
            const xCoord = prevButton.x + prevButton.width / 2 + button.TopButtonRenderer.width / 2 + 10;
            button.TopButtonRenderer.x = xCoord;
        });
    }
    disactiveEventMode;
}


class $b894785879842ff0$export$2e2bcd8739ae039 {
    TopSwitcherProps;
    TopSwitcherRenderer;
    constructor(TopSwitcherProps, con, options){
        this.TopSwitcherProps = TopSwitcherProps;
        this.setCoord = (coord)=>this.TopSwitcherRenderer.position.copyFrom(coord);
        this.TopSwitcherRenderer = new (0, $d940f5507ea3c2bc$export$2e2bcd8739ae039)(this.TopSwitcherProps, con, options);
    }
    setCoord;
}






var $7oAU9 = parcelRequire("7oAU9");
class $727bec3258d46180$export$2e2bcd8739ae039 {
    static genDirectionButton(con) {
        const style = (0, $63c2c194f5a6a92c$export$9e3f3bbed766482).directionButton;
        const TopSwitcherProps = {
            topButtonsProps: [
                {
                    label: (0, $f443dc34377ca450$export$cacd6541cfeeb6c1).clockwise,
                    onHandleDownFunc: ()=>(0, $f60d53a2fe365b05$export$f6644f0f2c90144b).emit((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).setDirection, (0, $f443dc34377ca450$export$cacd6541cfeeb6c1).clockwise)
                },
                {
                    label: (0, $f443dc34377ca450$export$cacd6541cfeeb6c1).antiClockwise,
                    onHandleDownFunc: ()=>(0, $f60d53a2fe365b05$export$f6644f0f2c90144b).emit((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).setDirection, (0, $f443dc34377ca450$export$cacd6541cfeeb6c1).antiClockwise)
                }
            ],
            eventBusName: (0, $63c2c194f5a6a92c$export$30636d68dd30d3b2).dirBut
        };
        const button = new (0, $b894785879842ff0$export$2e2bcd8739ae039)(TopSwitcherProps, con, style.opts);
        button.setCoord(style.coord);
        return button;
    }
    static genRotationButton(con) {
        const style = (0, $63c2c194f5a6a92c$export$9e3f3bbed766482).rotationButton;
        const TopSwitcherProps = {
            topButtonsProps: [
                {
                    label: "90",
                    onHandleDownFunc: ()=>(0, $f60d53a2fe365b05$export$f6644f0f2c90144b).emit((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).setRotation, 90)
                },
                {
                    label: "180",
                    onHandleDownFunc: ()=>(0, $f60d53a2fe365b05$export$f6644f0f2c90144b).emit((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).setRotation, 180)
                },
                {
                    label: "270",
                    onHandleDownFunc: ()=>(0, $f60d53a2fe365b05$export$f6644f0f2c90144b).emit((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).setRotation, 270)
                }
            ],
            eventBusName: (0, $63c2c194f5a6a92c$export$30636d68dd30d3b2).rotBut
        };
        const button = new (0, $b894785879842ff0$export$2e2bcd8739ae039)(TopSwitcherProps, con, style.opts);
        button.setCoord(style.coord);
        return button;
    }
    static setAnswerButtons(AnswerCon, isDisabled) {
        AnswerCon.children.forEach((b)=>{
            b.filters = isDisabled ? [
                (0, $7oAU9.disabledfilter)
            ] : [];
            b.eventMode = isDisabled ? "none" : "static";
        });
    }
}





var $erVR3 = parcelRequire("erVR3");


class $9bd656b3fedf8531$export$2e2bcd8739ae039 extends $iuB9z.Container {
    TestQuestionManager = (0, $905a2b833cc89373$export$2e2bcd8739ae039).getInstance();
    constructor(){
        super();
        this.addSwitchers();
        (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).on((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).showTestQuestion, (i)=>this.showforAnswer(i));
    }
    addSwitchers() {
        (0, $727bec3258d46180$export$2e2bcd8739ae039).genDirectionButton(this);
        (0, $727bec3258d46180$export$2e2bcd8739ae039).genRotationButton(this);
    }
    setButtons = (v)=>(0, $727bec3258d46180$export$2e2bcd8739ae039).setAnswerButtons(this, v);
    reset() {
        this.setButtons(true);
        (0, $erVR3.rootEventBus).emit((0, $erVR3.EnumRootEventBus).topSwitcherButtonLabel, (0, $63c2c194f5a6a92c$export$30636d68dd30d3b2).dirBut, "");
        (0, $erVR3.rootEventBus).emit((0, $erVR3.EnumRootEventBus).topSwitcherButtonLabel, (0, $63c2c194f5a6a92c$export$30636d68dd30d3b2).rotBut, "");
    }
    showforAnswer(index) {
        let answer = this.TestQuestionManager.getAnswer(index);
        if (answer.type == (0, $f443dc34377ca450$export$51940fbbacba35d4).TYPE1) return this.visible = false;
        this.visible = true;
        this.setButtons(true);
        const ans = answer;
        (0, $erVR3.rootEventBus).emit((0, $erVR3.EnumRootEventBus).topSwitcherButtonLabel, (0, $63c2c194f5a6a92c$export$30636d68dd30d3b2).dirBut, ans.direction || "");
        (0, $erVR3.rootEventBus).emit((0, $erVR3.EnumRootEventBus).topSwitcherButtonLabel, (0, $63c2c194f5a6a92c$export$30636d68dd30d3b2).rotBut, (ans.rotation || "").toString());
    }
}



var $iuB9z = parcelRequire("iuB9z");

class $9dd875116969b226$export$2e2bcd8739ae039 extends $iuB9z.Container {
    Panel = (0, $c5e393fa88a2b6ba$export$2e2bcd8739ae039).getInstance();
    header = this.addChild(new $iuB9z.Text());
    resultText = this.addChild(new $iuB9z.Text());
    constructor(){
        super();
        this.addHeaderDetails();
        this.addResultTextDetails();
        this.addToPanel();
        this.y = 225;
    }
    addToPanel = ()=>this.Panel.addChild(this);
    addHeaderDetails() {
        this.header.text = "Results";
        this.header.anchor.set(.5);
        this.header.y = -64;
        this.header.style.fontSize = 34;
    }
    addResultTextDetails() {
        this.resultText.text = "You answered 16 out of 20 questions correctly. You received a total score of 80 points.";
        this.resultText.anchor.set(.5);
        this.resultText.y = 0;
        this.resultText.style = {
            wordWrap: true,
            wordWrapWidth: 520,
            fontSize: 24
        };
    }
    setResult(questionCount, trueAnswerCount, puan) {
        this.resultText.text = `You answered ${trueAnswerCount} out of ${questionCount} questions correctly. You received a total score of ${puan} points.`;
    }
}



class $b2a8bdd5e2da8800$export$2e2bcd8739ae039 {
    ResultsConRenderer = new (0, $9dd875116969b226$export$2e2bcd8739ae039)();
    constructor(){
        this.setVisible(false);
        (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).on((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).checkedAnswers, (arr)=>this.showResults(arr));
        (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).on((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).setQuestMode, ()=>this.setVisible(false));
    }
    setVisible = (v)=>this.ResultsConRenderer.visible = v;
    showResults(arr) {
        const totQuest = arr.length;
        const trueCount = arr.filter((a)=>a).length;
        this.ResultsConRenderer.setResult(totQuest, trueCount, trueCount * 5);
        this.setVisible(true);
    }
}




function $801a4cd86486a381$export$2e2bcd8739ae039(currQuestion) {
    const getActiveQuestionTypes = (isFirst)=>({
            TYPE1: isFirst,
            TYPE2: !isFirst
        });
    if (currQuestion == 0) (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).emit((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).setActiveQuestionType, getActiveQuestionTypes(true));
    else if (currQuestion == (0, $63c2c194f5a6a92c$export$4213f7fd0b58a789) / 2) (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).emit((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).setActiveQuestionType, getActiveQuestionTypes(false));
}


class $cb57049f1c968bda$export$2e2bcd8739ae039 extends $iuB9z.Container {
    Panel = (0, $c5e393fa88a2b6ba$export$2e2bcd8739ae039).getInstance();
    TestQuestionManager = (0, $905a2b833cc89373$export$2e2bcd8739ae039).getInstance();
    Timer = new (0, $a2b41efee2f65db4$export$2e2bcd8739ae039)(this, (0, $63c2c194f5a6a92c$export$8eac6cc23bfa2b30), 2400);
    AnswerCon = this.addChild(new (0, $9bd656b3fedf8531$export$2e2bcd8739ae039)());
    ResultsCon = new (0, $b2a8bdd5e2da8800$export$2e2bcd8739ae039)();
    NextQuestion = this.addChild((0, $162002ea369d4ce2$export$2e2bcd8739ae039).genGenNextQuestionButton());
    ShowResult = this.addChild((0, $162002ea369d4ce2$export$2e2bcd8739ae039).genShowResults());
    startAnswer = this.addChild((0, $162002ea369d4ce2$export$2e2bcd8739ae039).genStartAnswerButton());
    saveAnswer = this.addChild((0, $162002ea369d4ce2$export$2e2bcd8739ae039).genSaveAnswerButton());
    goToPractise = this.addChild((0, $162002ea369d4ce2$export$2e2bcd8739ae039).genGoToPractiseButton());
    tryAgain = this.addChild((0, $162002ea369d4ce2$export$2e2bcd8739ae039).genTryAgainButton());
    gotoPractiseMode = this.addChild((0, $162002ea369d4ce2$export$2e2bcd8739ae039).genGoToTestModeButton());
    constructor(){
        super();
        this.addChild(new (0, $3c00829ea5df263b$export$2e2bcd8739ae039)());
        this.init();
        this.addToPanel();
        (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).on((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).setQuestMode, (m)=>this.handleTestMode(m));
        (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).on((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).startTest, ()=>this.Timer.start());
        (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).on((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).setQuestMode, ()=>this.handleSetQuestionMode());
        (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).on((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).newQuestion, ()=>this.flipButtons(false));
        (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).on((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).saveAnswer, ()=>this.handleSaveAnswer());
        (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).on((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).showResults, ()=>this.flipButtons(true));
        (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).on((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).startAnswer, (v)=>this.AnswerCon.setButtons(!v));
        (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).on((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).questionType, (t)=>this.setQuestionAnswer(t));
        (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).on((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).showResults, ()=>this.AnswerCon.visible = false);
        (0, $801a4cd86486a381$export$2e2bcd8739ae039)(0);
    }
    addToPanel = ()=>this.Panel.addChild(this);
    handleTestMode = (m)=>m == (0, $f443dc34377ca450$export$b4d15339b5fb8fcc).test && this.init();
    handleSaveAnswer() {
        this.flipButtons(true);
        this.AnswerCon.setButtons(true);
    }
    handleSetQuestionMode() {
        this.Timer.reset();
        this.AnswerCon.visible = false;
        this.flipButtons(false);
    }
    init() {
        this.AnswerCon.visible = false;
        this.NextQuestion.visible = false;
        this.ShowResult.visible = false;
        this.goToPractise.visible = false;
        this.tryAgain.visible = false;
        this.saveAnswer.visible = true;
        this.startAnswer.visible = true;
    }
    setQuestionAnswer(t) {
        if (t == (0, $f443dc34377ca450$export$51940fbbacba35d4).TYPE1) return this.AnswerCon.visible = false;
        this.AnswerCon.visible = true;
        this.AnswerCon.reset();
    }
    async flipButtons(v) {
        await this.flip(1, 0);
        const questionCount = this.TestQuestionManager.getAnswersLength();
        (0, $801a4cd86486a381$export$2e2bcd8739ae039)(questionCount);
        const isLast = this.TestQuestionManager.getIsCompleted();
        const showResultVis = this.ShowResult.visible;
        this.NextQuestion.visible = !isLast && v;
        this.ShowResult.visible = isLast && v;
        this.startAnswer.visible = !v;
        this.saveAnswer.visible = !v;
        if (isLast && v && showResultVis) {
            this.ShowResult.visible = false;
            this.goToPractise.visible = true;
            this.tryAgain.visible = true;
        }
        await this.flip(0, 1);
    }
    async flip(startVal, targetVal) {
        const setPanelScale = (v)=>{
            this.NextQuestion.scale.set(1, v);
            this.ShowResult.scale.set(1, v);
            this.startAnswer.scale.set(1, v);
            this.saveAnswer.scale.set(1, v);
            this.goToPractise.scale.set(1, v);
            this.tryAgain.scale.set(1, v);
        };
        return new Promise((resolve)=>{
            new (0, $cd55c7b9f87095b8$export$2e2bcd8739ae039)({
                startVal: startVal,
                targetVal: targetVal,
                duration: 200
            }, setPanelScale, resolve);
        });
    }
}




class $339e30054b8c3094$export$2e2bcd8739ae039 {
    Panel = new (0, $c5e393fa88a2b6ba$export$2e2bcd8739ae039)();
    DrawingToolManager = new (0, $14973a1689ee6a6d$export$2e2bcd8739ae039)();
    PractiseButtonManager = new (0, $d49b4bd55920a39a$export$2e2bcd8739ae039)();
    TestButtonManager = new (0, $cb57049f1c968bda$export$2e2bcd8739ae039)();
    constructor(){
        this.TestButtonManager.visible = false;
        (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).on((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).setQuestMode, async (mode)=>this.setQuestMode(mode));
    }
    async setQuestMode(mode) {
        await this.flip(1, 0);
        this.PractiseButtonManager.visible = mode === (0, $f443dc34377ca450$export$b4d15339b5fb8fcc).practise;
        this.TestButtonManager.visible = mode === (0, $f443dc34377ca450$export$b4d15339b5fb8fcc).test;
        await this.flip(0, 1);
    }
    async flip(startVal, targetVal) {
        const setPanelScale = (v)=>this.Panel.scale.set(v, 1);
        const flipOpt = {
            startVal: startVal,
            targetVal: targetVal,
            duration: 200
        };
        return new Promise((resolve)=>{
            new (0, $cd55c7b9f87095b8$export$2e2bcd8739ae039)(flipOpt, setPanelScale, resolve);
        });
    }
}



var $6m47o = parcelRequire("6m47o");

var $1PAc2 = parcelRequire("1PAc2");
class $2be39e1e0b800364$export$2e2bcd8739ae039 extends (0, $1PAc2.default) {
    constructor(startVal, targetVal, duration, onUpdate, onComp){
        super();
        const pop = {
            v: startVal
        };
        new (0, $6m47o.default).Tween(pop).to({
            v: targetVal
        }, duration).easing((0, $6m47o.default).Easing.Cubic.Out).onUpdate((pop)=>onUpdate(pop.v)).onComplete(()=>onComp()).start();
    }
}



var $16Wgx = parcelRequire("16Wgx");

var $iuB9z = parcelRequire("iuB9z");

var $75RpY = parcelRequire("75RpY");

var $9ec1t = parcelRequire("9ec1t");
const $d5480ff77c8007cd$var$defaultSize = {
    width: 200,
    height: 100
};
class $d5480ff77c8007cd$export$2e2bcd8739ae039 extends $iuB9z.Container {
    sizes;
    Game;
    dim;
    Layers;
    overlay;
    wrapper;
    modalBg;
    coord;
    constructor(coord, sizes = $d5480ff77c8007cd$var$defaultSize, hideoverlay = false){
        super(), this.sizes = sizes, this.Game = (0, $75RpY.default).getInstance(), this.dim = this.Game.getDim(), this.Layers = (0, $9ec1t.default).getInstance(), this.overlay = this.addChild(new $iuB9z.Graphics()), this.wrapper = this.addChild(new $iuB9z.Container()), this.modalBg = this.wrapper.addChild(new $iuB9z.Graphics()), this.coord = {
            x: this.dim.WIDTH / 2,
            y: this.dim.HEIGHT / 2
        }, this.addToLayer = ()=>this.Layers.UITop.addChild(this), this.setCoord = ()=>this.position.copyFrom(this.coord), this.getDeactiveElms = ()=>[
                this.overlay,
                this.modalBg
            ], this.deactivateEventMode = ()=>this.getDeactiveElms().forEach((e)=>e.eventMode = "none");
        coord && (this.coord = coord);
        this.drawOverlay(hideoverlay ? 0 : .3);
        this.drawModal();
        this.setCoord();
        this.deactivateEventMode();
        this.addToLayer();
        this.visible = false;
    }
    addToLayer;
    setCoord;
    getDeactiveElms;
    deactivateEventMode;
    drawOverlay(alpha = .3) {
        this.overlay.rect(-this.coord.x, -this.coord.y, this.dim.WIDTH, this.dim.HEIGHT).fill({
            color: 0x000000,
            alpha: alpha
        });
    }
    drawModal() {
        this.modalBg.roundRect(-this.sizes.width / 2, -this.sizes.height / 2, this.sizes.width, this.sizes.height, 10).fill(0xFFFFFF);
    }
}



var $16HUD = parcelRequire("16HUD");
class $93dadcde4012f556$export$2e2bcd8739ae039 {
    ModalRenderer;
    constructor(content, size, hideOverlay){
        this.addModalRenderer(size, hideOverlay);
        this.ModalRenderer.wrapper.addChild(content);
    }
    setModalWrapperScale = (v)=>this.ModalRenderer.wrapper.scale.set(v);
    openModal() {
        const startVal = .4;
        const targetVal = 1;
        const onUpdate = (v)=>this.setModalWrapperScale(v);
        this.ModalRenderer.visible = true;
        this.setModalWrapperScale(startVal);
        new (0, $2be39e1e0b800364$export$2e2bcd8739ae039)(startVal, targetVal, 200, onUpdate, ()=>{});
    }
    hideModal() {
        const startVal = 1;
        const targetVal = .4;
        const onUpdate = (v)=>this.setModalWrapperScale(v);
        const onComp = ()=>this.ModalRenderer.visible = false;
        this.setModalWrapperScale(startVal);
        new (0, $2be39e1e0b800364$export$2e2bcd8739ae039)(startVal, targetVal, 150, onUpdate, onComp);
    }
    addModalRenderer(size, hideOverlay) {
        this.ModalRenderer = new (0, $d5480ff77c8007cd$export$2e2bcd8739ae039)(null, size, hideOverlay);
        this.ModalRenderer.getDeactiveElms().forEach((e)=>(0, $16Wgx.default)(e, {}, (0, $16HUD.CustomCursorType).default));
    }
}





var $iuB9z = parcelRequire("iuB9z");

const $51a0ab160ddcf916$export$301500ed3a742f63 = [
    0x21D4FE,
    0x0195B8
];
const $51a0ab160ddcf916$export$860cd0863a39b65 = {
    x: 0,
    y: 80,
    width: 140,
    height: 36,
    defaultBgColor: $51a0ab160ddcf916$export$301500ed3a742f63[0],
    pressedBgColor: 0xFFFFFF,
    border: false
};


const $ae11c599d999cb53$var$START = (0, $035d220cf9b861a9$export$2e2bcd8739ae039).generateText("Start", 20, (0, $51a0ab160ddcf916$export$301500ed3a742f63)[1]);
class $ae11c599d999cb53$export$2e2bcd8739ae039 extends $iuB9z.Container {
    onHandleDownStartFunc;
    startButton;
    info;
    constructor(onHandleDownStartFunc){
        super(), this.onHandleDownStartFunc = onHandleDownStartFunc, this.info = this.addChild(new $iuB9z.Text());
        this.addStartButton();
        this.addText();
    }
    addText() {
        this.info.text = "Let's Start Quiz";
        this.info.anchor.set(.5);
        this.info.x = 0;
        this.info.y = 20;
    }
    addStartButton() {
        const closeButton = ()=>setTimeout(()=>this.startButton.closeButton(), 200);
        this.startButton = this.addChild(new (0, $035d220cf9b861a9$export$2e2bcd8739ae039)((0, $51a0ab160ddcf916$export$860cd0863a39b65), $ae11c599d999cb53$var$START, true, ()=>{
            closeButton();
            this.onHandleDownStartFunc();
        }, ()=>{}));
    }
}


class $eca13203f5efa2c3$export$2e2bcd8739ae039 {
    Modal;
    TestModalRenderer;
    constructor(){
        const size = {
            width: 420,
            height: 240
        };
        this.initTestModalRenderer();
        this.Modal = new (0, $93dadcde4012f556$export$2e2bcd8739ae039)(this.TestModalRenderer, size, false);
        (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).on((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).setQuestMode, (mode)=>this.setModal(mode));
    }
    initTestModalRenderer() {
        const onHandleDownStartButton = ()=>{
            this.Modal.hideModal();
            (0, $f60d53a2fe365b05$export$f6644f0f2c90144b).emit((0, $f60d53a2fe365b05$export$cb883390c27ec6dd).startTest);
        };
        this.TestModalRenderer = new (0, $ae11c599d999cb53$export$2e2bcd8739ae039)(()=>onHandleDownStartButton());
    }
    setModal(mode) {
        mode == (0, $f443dc34377ca450$export$b4d15339b5fb8fcc).test ? this.Modal.openModal() : this.Modal.hideModal();
    }
}


class $db23cdc8435dde0b$export$2e2bcd8739ae039 {
    constructor(){
        new (0, $339e30054b8c3094$export$2e2bcd8739ae039)();
        new (0, $f4e93496f8d935cb$export$2e2bcd8739ae039)();
        new (0, $eca13203f5efa2c3$export$2e2bcd8739ae039)();
    }
}



const $f9c9e53e31dd11ae$var$canvas = document.querySelector("#canvas");
if ($f9c9e53e31dd11ae$var$canvas) window.context = new (0, $75RpY.default)($f9c9e53e31dd11ae$var$canvas, "", ()=>new (0, $db23cdc8435dde0b$export$2e2bcd8739ae039)(), (0, $63c2c194f5a6a92c$export$a310f85340477585));
else console.error("Canvas is not found");


//# sourceMappingURL=index.d8d14119.js.map
